(() => {
  var e = {
      260: (e, t, r) => {
        "use strict";
        r.d(t, { GlobalProductCard: () => GlobalProductCard });
        class ShopifyUtils {
          constructor(e) {
            this.money_format = e.money_format || "Â£{{amount}}";
          }
          handleize(e) {
            return e
              .toLowerCase()
              .replace(/[^\w\u00C0-\u024f]+/g, "-")
              .replace(/^-+|-+$/g, "");
          }
          parseImgUrl(e, t) {
            const r = e.includes(".png") ? "png" : "jpg";
            return `${e.split("png" == r ? ".png" : ".jpg")[0]}_${t}x.${r}`;
          }
          formatMoney(e, t) {
            "string" == typeof e && (e = e.replace(".", ""));
            var r = "",
              n = /\{\{\s*(\w+)\s*\}\}/,
              s = t || this.money_format;
            function defaultOption(e, t) {
              return void 0 === e ? t : e;
            }
            function formatWithDelimiters(e, t, r, n) {
              if (
                ((t = defaultOption(t, 2)),
                (r = defaultOption(r, ",")),
                (n = defaultOption(n, ".")),
                isNaN(e) || null == e)
              )
                return 0;
              var s = (e = (e / 100).toFixed(t)).split(".");
              return (
                s[0].replace(/(\d)(?=(\d\d\d)+(?!\d))/g, "$1" + r) +
                (s[1] ? n + s[1] : "")
              );
            }
            switch (s.match(n)[1]) {
              case "amount":
                r = formatWithDelimiters(e, 2);
                break;
              case "amount_no_decimals":
                r = formatWithDelimiters(e, 0);
                break;
              case "amount_optional_decimals":
                (r = formatWithDelimiters(e, 2)),
                  (r = Number(r) % 1 == 0 ? Number(r).toFixed(0) : r);
                break;
              case "amount_with_comma_separator":
                r = formatWithDelimiters(e, 2, ".", ",");
                break;
              case "amount_with_period_separator":
                r = formatWithDelimiters(e, 2, ",", ".");
                break;
              case "amount_no_decimals_with_comma_separator":
                r = formatWithDelimiters(e, 0, ".", ",");
            }
            return s.replace(n, r);
          }
        }
        class GlobalProductCard extends HTMLElement {
          constructor() {
            super(), (this.ObserverLite = new ObserverLite());
            const e = `${window.cartCurrencySymbol}{{amount_optional_decimals}}`;
            this.ShopifyUtils = new ShopifyUtils({ money_format: e });
          }
          connectedCallback() {
            DomReadyPromise()
              .then(async () => {
                const e = this.querySelector(":scope > template");
                if (e)
                  try {
                    (this.settings = JSON.parse(e.innerHTML)), e.remove();
                  } catch (e) {
                    return console.log(e), void this.remove();
                  }
                this.#e(),
                  this.settings && (this.innerHTML = await this.#t()),
                  this.#r();
              })
              .catch((e) => {
                console.log(e);
              });
          }
          #e() {
            if (!window.GlobalProductCardMounted) {
              const e =
                '\n        <style type="text/css">\n          .gpc__img-wrapper{\n            margin:10px 0;\n            position:relative;\n          }\n\n          global-product-card .hover-img {\n            position: absolute;\n            top: 0;\n            z-index: -1;\n            opacity: 0;\n          }\n\n          @media all and (min-width: 768px) {\n            global-product-card:hover .hover-img {\n              z-index: 1;\n              opacity: 1;\n            }\n\n            global-product-card:hover .gpc__badge {\n              display: none;\n            }\n\n            global-product-card:hover .gpc__button-bar {\n              display: flex;\n              flex-direction: column-reverse;\n            }\n\n            global-product-card:not(:hover) .gpc__wishlist{\n              opacity: 0;\n            }\n          }\n\n          global-product-card #loyaltylion .lion-action-button {\n            background: var(--color-black);\n            width: 100%;\n            border: 1px solid var(--color-black);\n          }\n\n          global-product-card #loyaltylion .lion-action-button:hover {\n            background: var(--color-white);\n            color: var(--color-black);\n          }\n\n          global-product-card #loyaltylion .lion-action-button--disabled {\n            background: var(--grey);\n            border-color: var(--grey);\n          }\n\n          @media all and (min-width: 1100px) {\n            global-product-card:hover .gpc__button-bar {\n              flex-direction: row;\n            }\n          }\n\n          .gpc__badge {\n            position: absolute;\n            bottom: 10px;\n            left: 10px;\n            background: var(--color-grey);\n            border-radius: 5px;\n            padding: 4px 12px;\n          }\n\n          .template-index.dark-mode .gpc__badge {\n            background: var(--body-Background);\n          }\n\n          .gpc__button-bar {\n            display: none;\n            position: absolute;\n            bottom: 0px;\n            gap: 15px;\n            padding: 0 15px 15px;\n            z-index: 10;\n          }\n\n          .gpc__button-bar--redemption {\n            display: block;\n          }\n\n          .gpc__button {\n            display: flex;\n            justify-content: center;\n            align-items: center;\n            border: 1px solid var(--color-black);\n            border-radius: 5px;\n            min-height: 3em;\n            line-height: normal;\n          }\n\n          .gpc__button--primary {\n            background: var(--color-black);\n            color: var(--color-white);\n          }\n\n          .gpc__button--primary:hover {\n            background:  var(--color-white);\n            color: var(--color-black);\n            transition: all .1s ease-in;\n          }\n\n          .gpc__button--secondary {\n            background:  var(--color-white);\n            color: var(--color-black);\n          }\n\n          .gpc__button--secondary:hover {\n            background: var(--color-black);\n            color: var(--color-white);\n            transition: all .1s ease-in;\n          }\n\n          .gpc__size--separator::after {\n            content: "|";\n            padding: 0 7px 0 4px;\n          }\n\n          .gpc__wishlist {\n            position: absolute;\n            top: 18px;\n            right: 8px;\n            z-index: 3;\n          }\n\n          .gpc__wishlist-wrapper {\n            background: #FFFFFFCC;\n            width: 24px;\n            height: 24px;\n            border-radius: 50%;\n          }\n\n          .gpc__wishlist-wrapper button {\n            margin-top: 2px !important;\n          }\n\n          .gpc__wishlist-wrapper .swym-button.swym-add-to-wishlist-view-product.swym-added {\n            opacity: 1;\n          }\n\n          .gpc__atb-btn {\n            position: absolute;\n            right: 5px;\n            bottom: 5px;\n            background: var(--color-white);\n            width:28px;\n            height:28px;\n          }\n\n          @media all and (min-width: 768px) {\n            .gpc__atb-btn {\n              display: none;\n            }\n          }\n        </style>\n      ';
              (window.GlobalProductCardMounted = !0),
                document.body.append(parseHTML(e));
            }
          }
          async #r() {
            (this.quickViewToggle = this.querySelector("[data-product]")),
              this.quickViewToggle?.addEventListener("click", (e) => {
                e.preventDefault(),
                  window.onQuickViewClick(this.quickViewToggle);
              }),
              (this.GlobalCart = await new GlobalCart());
            const e = this.querySelector(".gpc__atb-btn");
            e.addEventListener("click", (t) => {
              (e.disabled = !0), (e.dataset.loading = !0);
              const r = {
                items: [{ id: this.settings.product.id, quantity: 1 }],
              };
              this.GlobalCart.addToCart(r).then(() => {
                (e.disabled = !1), (e.dataset.loading = !1);
              });
            }),
              this.ObserverLite.next();
          }
          #n({ src: e, alt: t, sizes: r, width: n, classList: s }) {
            return `\n      <img \n        srcset="${(r = r || [512, 256, 128])
              .map((t) => {
                return `${e}${((r = e), r.includes("?") ? "&" : "?")} ${t}w`;
                var r;
              })
              .join(
                ", "
              )}" \n        alt="${t}"  \n        width="${n}" \n        height="${n}" \n        class="${s}"\n        loading="lazy">\n    `;
          }
          async #s(e) {
            const t = e.compare ? " f-w600" : "",
              r = `<span class='price-v2__${Number(
                e.id
              )}${t}'>${this.ShopifyUtils.formatMoney(e.price)}</span>`;
            let n = e.compare
              ? `<s class="cell-r--d3">${this.ShopifyUtils.formatMoney(
                  e.compare
                )}</s>${r}`
              : r;
            sitewide &&
              (n = await sitewide.updateGlobalProductPriceV2(e.id, n));
            const s =
              ("0" != e.size_variant && e.size_variant) || e.size_product;
            return `${
              s ? `<span class="gpc__size--separator">${s}</span>` : ""
            }${n}`;
          }
          async #i(e, t) {
            let r = e.compare || e.badge,
              n = r
                ? `<span class='badge-v2 badge-v2__product-card block-z3' aria-label='${r}'>${r}</span>`
                : "";
            return (
              sitewide &&
                (n = await sitewide.updateGlobalProductThumbnailLabelV2(
                  e.id,
                  n
                )),
              `\n      <div class="label-wrapper label-wrapper__${e.id}" data-type="product-card"\n        aria-label="Label for ${t}">\n        ${n}\n      </div>\n    `
            );
          }
          #a(e) {
            return "Bundles" === e.product_type
              ? `<button class="btn--full gpc__button gpc__button--primary t-ucase t-xxs">\n      <span class="text">${this.settings.translations.view_bundle}</span>\n    </button>`
              : `<form action="/cart/add" method="post" enctype="multipart/form-data" class="flex_1">\n      <input type="hidden" name="id" value="${e.id}">\n      <input min="1" type="hidden" name="quantity" value="1" data-variant-id="${e.id}" data-variant-inventory-qty="${e.inventory_quantity}">\n      <button class="btn--full gpc__button gpc__button--primary t-ucase t-xxs" onclick="GlobalCartMain.addProductFromButton(event)" aria-label="Add To Bag">\n        <span class="text">${this.settings.translations.add_to_cart}</span>\n      </button>\n    </form>`;
          }
          #o(e) {
            return `\n      <button class="btn--full gpc__button gpc__button--secondary flex_1 t-ucase t-xxs" data-product="/products/${e.handle_product}?variant=${e.id}">\n        ${this.settings.translations.quickview}\n      </button>\n    `;
          }
          buildReviews(e) {
            return `\n      <a href="/products/${e.handle_product}#shopify-section-product-reviews-js" class="hotspot-reviews">\n        <div class="yotpo-widget-instance no-events" data-yotpo-instance-id="${window?.yotpoStarsInstanceId}" data-yotpo-product-id="${e.id_product}" data-yotpo-cart-product-id="" data-yotpo-section-id="${window?.yotpoSectionId}"></div>\n      </a>\n    `;
          }
          async #c(e, t) {
            return `\n      <div class="gpc__wishlist">\n        <div class="gpc__wishlist-wrapper flex justify-center align-center">\n          <button\n          aria-label="Add ${t} to wishlist" data-with-epi="true"\n          class="swym-button swym-add-to-wishlist-view-product product_${e.id_product}"\n          data-swaction="addToWishlist"\n          data-product-id="${e.id_product}"\n          data-variant-id="${e.id}"\n          data-product-url="${window.shopUrl}/${e.handle_product}"\n          ></button>\n        </div>\n      </div>\n    `;
          }
          async #t() {
            const { product: e } = this.settings,
              t = this.#n({
                src: e.image_variant ? e.image_variant : e.image_product,
                alt: e.title,
                width: 512,
                classList: "d-block",
              }),
              r =
                e.images_product.length > 1
                  ? this.#n({
                      src: e.images_product[2]
                        ? e.images_product[2]
                        : e.images_product[1],
                      alt: `${e.title} hover`,
                      width: 512,
                      classList: "d-block hover-img",
                    })
                  : "",
              n = this.#a(e),
              s = this.#o(e),
              i =
                e.title_variant && !e.title_variant.includes("Default")
                  ? e.title_variant
                  : e.title_product,
              a = e.tagline_variant ? e.tagline_variant : e.subheading_product,
              o = e.routine
                ? `<span class="gpc__badge t-xxs lh-16 block-z3">${e.routine}</span>`
                : "";
            return `\n      <div class="flex flex-grid--d3 column-nowrap justify-space block-rel block-fh">\n        <span class="gpc__img-wrapper">\n          <a href="/products/${
              e.handle_product
            }?variant=${
              e.id
            }" class="block-rel">\n            ${o}\n\n            ${await this.#i(
              e,
              i
            )}\n\n            ${t}\n            ${r}\n          </a>\n\n          <div class="gpc__button-bar ${
              "redemption" === this.settings.type
                ? "gpc__button-bar--redemption"
                : ""
            } justify-space block-12/12">\n            ${
              "redemption" === this.settings.type
                ? `\n                <span style="width:100%" data-lion-seamless-product-reward='${e.id_product}' data-variant-id='${e.id}'>\n                </span>\n              `
                : `\n                ${n}\n                ${s}\n              `
            }\n          </div>\n\n          ${
              "redemption" === this.settings.type
                ? ""
                : '\n            <button class="gpc__atb-btn btn-reset" aria-label="Add To Bag"></button>\n          '
            }\n        </span>\n\n        <a class="variant-title-container" href="/products/${
              e.handle_product
            }?variant=${
              e.id
            }">\n          <span class="variant-title ls-2 t-rm lh-20">\n            ${i}\n          </span>\n        </a>\n\n        <a href="/products/${
              e.handle_product
            }?variant=${
              e.id
            }"\n            class="flex flex-grid--d3 column-nowrap grow-1 justify-space t-xxs lh-18">\n          ${a}\n          ${this.buildReviews(
              e
            )}\n        </a>\n        \n        <div class="flex flex-grid--d3 column-nowrap">\n          <span class="ls-1_5 t-xxs f-w400 lh-18">\n            ${
              "redemption" === this.settings.type ? "" : await this.#s(e)
            }\n          </span>\n        </div>\n\n        ${await this.#c(
              e,
              i
            )}\n      </div>\n    `;
          }
        }
        customElements.get("global-product-card") ||
          customElements.define("global-product-card", GlobalProductCard);
      },
      837: (e, t, r) => {
        "use strict";
        function createIterablePromise({
          func: e,
          validate: t,
          aggregator: r,
          error: n,
          timeout: s = () => 0,
        }) {
          const retry = (i) =>
            new Promise((a, o) => {
              e(i)
                .then(
                  (e) => (
                    r && r(e),
                    t(e)
                      ? a(e)
                      : n && n.validate(e)
                      ? o(new Error(n.message(e)))
                      : setTimeout(() => {
                          retry(e).then(a).catch(o);
                        }, s())
                  )
                )
                .catch((e) => {
                  o(e);
                });
            });
          return retry();
        }
        function createBrowserLocalStorageCache(e) {
          let t;
          const r = `algolia-client-js-${e.key}`;
          function getStorage() {
            return (
              void 0 === t && (t = e.localStorage || window.localStorage), t
            );
          }
          function getNamespace() {
            return JSON.parse(getStorage().getItem(r) || "{}");
          }
          function setNamespace(e) {
            getStorage().setItem(r, JSON.stringify(e));
          }
          return {
            get: (t, r, n = { miss: () => Promise.resolve() }) =>
              Promise.resolve()
                .then(
                  () => (
                    (function removeOutdatedCacheItems() {
                      const t = e.timeToLive ? 1e3 * e.timeToLive : null,
                        r = getNamespace(),
                        n = Object.fromEntries(
                          Object.entries(r).filter(
                            ([, e]) => void 0 !== e.timestamp
                          )
                        );
                      if ((setNamespace(n), !t)) return;
                      setNamespace(
                        Object.fromEntries(
                          Object.entries(n).filter(([, e]) => {
                            const r = new Date().getTime();
                            return !(e.timestamp + t < r);
                          })
                        )
                      );
                    })(),
                    getNamespace()[JSON.stringify(t)]
                  )
                )
                .then((e) => Promise.all([e ? e.value : r(), void 0 !== e]))
                .then(([e, t]) => Promise.all([e, t || n.miss(e)]))
                .then(([e]) => e),
            set: (e, t) =>
              Promise.resolve().then(() => {
                const n = getNamespace();
                return (
                  (n[JSON.stringify(e)] = {
                    timestamp: new Date().getTime(),
                    value: t,
                  }),
                  getStorage().setItem(r, JSON.stringify(n)),
                  t
                );
              }),
            delete: (e) =>
              Promise.resolve().then(() => {
                const t = getNamespace();
                delete t[JSON.stringify(e)],
                  getStorage().setItem(r, JSON.stringify(t));
              }),
            clear: () =>
              Promise.resolve().then(() => {
                getStorage().removeItem(r);
              }),
          };
        }
        function createFallbackableCache(e) {
          const t = [...e.caches],
            r = t.shift();
          return void 0 === r
            ? (function createNullCache() {
                return {
                  get: (e, t, r = { miss: () => Promise.resolve() }) =>
                    t()
                      .then((e) => Promise.all([e, r.miss(e)]))
                      .then(([e]) => e),
                  set: (e, t) => Promise.resolve(t),
                  delete: (e) => Promise.resolve(),
                  clear: () => Promise.resolve(),
                };
              })()
            : {
                get: (e, n, s = { miss: () => Promise.resolve() }) =>
                  r
                    .get(e, n, s)
                    .catch(() =>
                      createFallbackableCache({ caches: t }).get(e, n, s)
                    ),
                set: (e, n) =>
                  r
                    .set(e, n)
                    .catch(() =>
                      createFallbackableCache({ caches: t }).set(e, n)
                    ),
                delete: (e) =>
                  r
                    .delete(e)
                    .catch(() =>
                      createFallbackableCache({ caches: t }).delete(e)
                    ),
                clear: () =>
                  r
                    .clear()
                    .catch(() =>
                      createFallbackableCache({ caches: t }).clear()
                    ),
              };
        }
        function createMemoryCache(e = { serializable: !0 }) {
          let t = {};
          return {
            get(r, n, s = { miss: () => Promise.resolve() }) {
              const i = JSON.stringify(r);
              if (i in t)
                return Promise.resolve(
                  e.serializable ? JSON.parse(t[i]) : t[i]
                );
              const a = n();
              return a.then((e) => s.miss(e)).then(() => a);
            },
            set: (r, n) => (
              (t[JSON.stringify(r)] = e.serializable ? JSON.stringify(n) : n),
              Promise.resolve(n)
            ),
            delete: (e) => (delete t[JSON.stringify(e)], Promise.resolve()),
            clear: () => ((t = {}), Promise.resolve()),
          };
        }
        r.d(t, {
          AgSearchInsightsUtil: () => AgSearchInsightsUtil,
          AgSearchUtil: () => AgSearchUtil,
        });
        const n = 12e4;
        function createStatefulHost(e, t = "up") {
          const r = Date.now();
          return {
            ...e,
            status: t,
            lastUpdate: r,
            isUp: function isUp() {
              return "up" === t || Date.now() - r > n;
            },
            isTimedOut: function isTimedOut() {
              return "timed out" === t && Date.now() - r <= n;
            },
          };
        }
        function _toPropertyKey(e) {
          var t = (function _toPrimitive(e, t) {
            if ("object" != typeof e || !e) return e;
            var r = e[Symbol.toPrimitive];
            if (void 0 !== r) {
              var n = r.call(e, t || "default");
              if ("object" != typeof n) return n;
              throw new TypeError(
                "@@toPrimitive must return a primitive value."
              );
            }
            return ("string" === t ? String : Number)(e);
          })(e, "string");
          return "symbol" == typeof t ? t : t + "";
        }
        function _defineProperty(e, t, r) {
          return (
            (t = _toPropertyKey(t)) in e
              ? Object.defineProperty(e, t, {
                  value: r,
                  enumerable: !0,
                  configurable: !0,
                  writable: !0,
                })
              : (e[t] = r),
            e
          );
        }
        class AlgoliaError extends Error {
          constructor(e, t) {
            super(e),
              _defineProperty(this, "name", "AlgoliaError"),
              t && (this.name = t);
          }
        }
        class ErrorWithStackTrace extends AlgoliaError {
          constructor(e, t, r) {
            super(e, r),
              _defineProperty(this, "stackTrace", void 0),
              (this.stackTrace = t);
          }
        }
        class RetryError extends ErrorWithStackTrace {
          constructor(e) {
            super(
              "Unreachable hosts - your application id may be incorrect. If the error persists, please create a ticket at https://support.algolia.com/ sharing steps we can use to reproduce the issue.",
              e,
              "RetryError"
            );
          }
        }
        class ApiError extends ErrorWithStackTrace {
          constructor(e, t, r, n = "ApiError") {
            super(e, r, n),
              _defineProperty(this, "status", void 0),
              (this.status = t);
          }
        }
        class DeserializationError extends AlgoliaError {
          constructor(e, t) {
            super(e, "DeserializationError"),
              _defineProperty(this, "response", void 0),
              (this.response = t);
          }
        }
        class DetailedApiError extends ApiError {
          constructor(e, t, r, n) {
            super(e, t, n, "DetailedApiError"),
              _defineProperty(this, "error", void 0),
              (this.error = r);
          }
        }
        function serializeUrl(e, t, r) {
          const n = (function serializeQueryParameters(e) {
            const isObjectOrArray = (e) =>
              "[object Object]" === Object.prototype.toString.call(e) ||
              "[object Array]" === Object.prototype.toString.call(e);
            return Object.keys(e)
              .map(
                (t) =>
                  `${t}=${encodeURIComponent(
                    isObjectOrArray(e[t]) ? JSON.stringify(e[t]) : e[t]
                  ).replaceAll("+", "%20")}`
              )
              .join("&");
          })(r);
          let s = `${e.protocol}://${e.url}${e.port ? `:${e.port}` : ""}/${
            "/" === t.charAt(0) ? t.substring(1) : t
          }`;
          return n.length && (s += `?${n}`), s;
        }
        function stackFrameWithoutCredentials(e) {
          const t = e.request.headers["x-algolia-api-key"]
            ? { "x-algolia-api-key": "*****" }
            : {};
          return {
            ...e,
            request: { ...e.request, headers: { ...e.request.headers, ...t } },
          };
        }
        function createTransporter({
          hosts: e,
          hostsCache: t,
          baseHeaders: r,
          baseQueryParameters: n,
          algoliaAgent: s,
          timeouts: i,
          requester: a,
          requestsCache: o,
          responsesCache: c,
        }) {
          async function retryableRequest(o, c, l = !0) {
            const d = [],
              u = (function serializeData(e, t) {
                if (
                  "GET" === e.method ||
                  (void 0 === e.data && void 0 === t.data)
                )
                  return;
                const r = Array.isArray(e.data)
                  ? e.data
                  : { ...e.data, ...t.data };
                return JSON.stringify(r);
              })(o, c),
              h = (function serializeHeaders(e, t, r) {
                const n = { Accept: "application/json", ...e, ...t, ...r },
                  s = {};
                return (
                  Object.keys(n).forEach((e) => {
                    const t = n[e];
                    s[e.toLowerCase()] = t;
                  }),
                  s
                );
              })(r, o.headers, c.headers),
              p = "GET" === o.method ? { ...o.data, ...c.data } : {},
              m = { ...n, ...o.queryParameters, ...p };
            if (
              (s.value && (m["x-algolia-agent"] = s.value),
              c && c.queryParameters)
            )
              for (const e of Object.keys(c.queryParameters))
                c.queryParameters[e] &&
                "[object Object]" !==
                  Object.prototype.toString.call(c.queryParameters[e])
                  ? (m[e] = c.queryParameters[e].toString())
                  : (m[e] = c.queryParameters[e]);
            let g = 0;
            const retry = async (e, r) => {
                const n = e.pop();
                if (void 0 === n)
                  throw new RetryError(
                    (function stackTraceWithoutCredentials(e) {
                      return e.map((e) => stackFrameWithoutCredentials(e));
                    })(d)
                  );
                let s = l
                  ? c.timeouts?.read || i.read
                  : c.timeouts?.write || i.write;
                const p = {
                    data: u,
                    headers: h,
                    method: o.method,
                    url: serializeUrl(n, o.path, m),
                    connectTimeout: r(g, c.timeouts?.connect || i.connect),
                    responseTimeout: r(g, s),
                  },
                  pushToStackTrace = (t) => {
                    const r = {
                      request: p,
                      response: t,
                      host: n,
                      triesLeft: e.length,
                    };
                    return d.push(r), r;
                  },
                  b = await a.send(p);
                if (
                  (function isRetryable({ isTimedOut: e, status: t }) {
                    return (
                      e ||
                      (function isNetworkError({ isTimedOut: e, status: t }) {
                        return !e && !~~t;
                      })({ isTimedOut: e, status: t }) ||
                      (2 != ~~(t / 100) && 4 != ~~(t / 100))
                    );
                  })(b)
                ) {
                  const s = pushToStackTrace(b);
                  return (
                    b.isTimedOut && g++,
                    console.log(
                      "Retryable failure",
                      stackFrameWithoutCredentials(s)
                    ),
                    await t.set(
                      n,
                      createStatefulHost(n, b.isTimedOut ? "timed out" : "down")
                    ),
                    retry(e, r)
                  );
                }
                if (
                  (function isSuccess({ status: e }) {
                    return 2 == ~~(e / 100);
                  })(b)
                )
                  return (function deserializeSuccess(e) {
                    try {
                      return JSON.parse(e.content);
                    } catch (t) {
                      throw new DeserializationError(t.message, e);
                    }
                  })(b);
                throw (
                  (pushToStackTrace(b),
                  (function deserializeFailure({ content: e, status: t }, r) {
                    try {
                      const n = JSON.parse(e);
                      return "error" in n
                        ? new DetailedApiError(n.message, t, n.error, r)
                        : new ApiError(n.message, t, r);
                    } catch (e) {}
                    return new ApiError(e, t, r);
                  })(b, d))
                );
              },
              b = e.filter(
                (e) =>
                  "readWrite" === e.accept ||
                  (l ? "read" === e.accept : "write" === e.accept)
              ),
              f = await (async function createRetryableOptions(e) {
                const r = await Promise.all(
                    e.map((e) =>
                      t.get(e, () => Promise.resolve(createStatefulHost(e)))
                    )
                  ),
                  n = r.filter((e) => e.isUp()),
                  s = r.filter((e) => e.isTimedOut()),
                  i = [...n, ...s];
                return {
                  hosts: i.length > 0 ? i : e,
                  getTimeout: (e, t) =>
                    (0 === s.length && 0 === e ? 1 : s.length + 3 + e) * t,
                };
              })(b);
            return retry([...f.hosts].reverse(), f.getTimeout);
          }
          return {
            hostsCache: t,
            requester: a,
            timeouts: i,
            algoliaAgent: s,
            baseHeaders: r,
            baseQueryParameters: n,
            hosts: e,
            request: function createRequest(e, t = {}) {
              const s = e.useReadTransporter || "GET" === e.method;
              if (!s) return retryableRequest(e, t, s);
              const createRetryableRequest = () => retryableRequest(e, t);
              if (!0 !== (t.cacheable || e.cacheable))
                return createRetryableRequest();
              const i = {
                request: e,
                requestOptions: t,
                transporter: { queryParameters: n, headers: r },
              };
              return c.get(
                i,
                () =>
                  o.get(i, () =>
                    o
                      .set(i, createRetryableRequest())
                      .then(
                        (e) => Promise.all([o.delete(i), e]),
                        (e) => Promise.all([o.delete(i), Promise.reject(e)])
                      )
                      .then(([e, t]) => t)
                  ),
                { miss: (e) => c.set(i, e) }
              );
            },
            requestsCache: o,
            responsesCache: c,
          };
        }
        function getAlgoliaAgent({ algoliaAgents: e, client: t, version: r }) {
          const n = (function createAlgoliaAgent(e) {
            const t = {
              value: `Algolia for JavaScript (${e})`,
              add(e) {
                const r = `; ${e.segment}${
                  void 0 !== e.version ? ` (${e.version})` : ""
                }`;
                return (
                  -1 === t.value.indexOf(r) && (t.value = `${t.value}${r}`), t
                );
              },
            };
            return t;
          })(r).add({ segment: t, version: r });
          return e.forEach((e) => n.add(e)), n;
        }
        const s = "5.0.0-beta.2";
        function getDefaultHosts(e) {
          return [
            { url: `${e}-dsn.algolia.net`, accept: "read", protocol: "https" },
            { url: `${e}.algolia.net`, accept: "write", protocol: "https" },
          ].concat(
            (function shuffle(e) {
              const t = e;
              for (let r = e.length - 1; r > 0; r--) {
                const n = Math.floor(Math.random() * (r + 1)),
                  s = e[r];
                (t[r] = e[n]), (t[n] = s);
              }
              return t;
            })([
              {
                url: `${e}-1.algolianet.com`,
                accept: "readWrite",
                protocol: "https",
              },
              {
                url: `${e}-2.algolianet.com`,
                accept: "readWrite",
                protocol: "https",
              },
              {
                url: `${e}-3.algolianet.com`,
                accept: "readWrite",
                protocol: "https",
              },
            ])
          );
        }
        function searchClient(e, t, r) {
          if (!e || "string" != typeof e)
            throw new Error("`appId` is missing.");
          if (!t || "string" != typeof t)
            throw new Error("`apiKey` is missing.");
          return (function createSearchClient({
            appId: e,
            apiKey: t,
            authMode: r,
            algoliaAgents: n,
            ...i
          }) {
            const a = (function createAuth(e, t, r = "WithinHeaders") {
                const n = {
                  "x-algolia-api-key": t,
                  "x-algolia-application-id": e,
                };
                return {
                  headers: () => ("WithinHeaders" === r ? n : {}),
                  queryParameters: () =>
                    "WithinQueryParameters" === r ? n : {},
                };
              })(e, t, r),
              o = createTransporter({
                hosts: getDefaultHosts(e),
                ...i,
                algoliaAgent: getAlgoliaAgent({
                  algoliaAgents: n,
                  client: "Search",
                  version: s,
                }),
                baseHeaders: {
                  "content-type": "text/plain",
                  ...a.headers(),
                  ...i.baseHeaders,
                },
                baseQueryParameters: {
                  ...a.queryParameters(),
                  ...i.baseQueryParameters,
                },
              });
            return {
              transporter: o,
              appId: e,
              clearCache: () =>
                Promise.all([
                  o.requestsCache.clear(),
                  o.responsesCache.clear(),
                ]).then(() => {}),
              get _ua() {
                return o.algoliaAgent.value;
              },
              addAlgoliaAgent(e, t) {
                o.algoliaAgent.add({ segment: e, version: t });
              },
              waitForTask(
                {
                  indexName: e,
                  taskID: t,
                  maxRetries: r = 50,
                  timeout: n = (e) => Math.min(200 * e, 5e3),
                },
                s
              ) {
                let i = 0;
                return createIterablePromise({
                  func: () => this.getTask({ indexName: e, taskID: t }, s),
                  validate: (e) => "published" === e.status,
                  aggregator: () => (i += 1),
                  error: {
                    validate: () => i >= r,
                    message: () =>
                      `The maximum number of retries exceeded. (${i}/${r})`,
                  },
                  timeout: () => n(i),
                });
              },
              waitForApiKey(
                {
                  operation: e,
                  key: t,
                  apiKey: r,
                  maxRetries: n = 50,
                  timeout: s = (e) => Math.min(200 * e, 5e3),
                },
                i
              ) {
                let a = 0;
                const o = {
                  aggregator: () => (a += 1),
                  error: {
                    validate: () => a >= n,
                    message: () =>
                      `The maximum number of retries exceeded. (${a}/${n})`,
                  },
                  timeout: () => s(a),
                };
                if ("update" === e) {
                  if (!r)
                    throw new Error(
                      "`apiKey` is required when waiting for an `update` operation."
                    );
                  return createIterablePromise({
                    ...o,
                    func: () => this.getApiKey({ key: t }, i),
                    validate: (e) => {
                      for (const t of Object.keys(r)) {
                        const n = r[t],
                          s = e[t];
                        if (Array.isArray(n) && Array.isArray(s)) {
                          if (
                            n.length !== s.length ||
                            n.some((e, t) => e !== s[t])
                          )
                            return !1;
                        } else if (n !== s) return !1;
                      }
                      return !0;
                    },
                  });
                }
                return createIterablePromise({
                  ...o,
                  func: () => this.getApiKey({ key: t }, i).catch((e) => e),
                  validate: (t) =>
                    "add" === e ? 404 !== t.status : 404 === t.status,
                });
              },
              browseObjects({ indexName: e, browseParams: t, ...r }, n) {
                return createIterablePromise({
                  func: (r) =>
                    this.browse(
                      {
                        indexName: e,
                        browseParams: { cursor: r ? r.cursor : void 0, ...t },
                      },
                      n
                    ),
                  validate: (e) => void 0 === e.cursor,
                  ...r,
                });
              },
              browseRules({ indexName: e, searchRulesParams: t, ...r }, n) {
                const s = { hitsPerPage: 1e3, ...t };
                return createIterablePromise({
                  func: (t) =>
                    this.searchRules(
                      {
                        indexName: e,
                        searchRulesParams: {
                          ...s,
                          page: t ? t.page + 1 : s.page || 0,
                        },
                      },
                      n
                    ),
                  validate: (e) => e.nbHits < s.hitsPerPage,
                  ...r,
                });
              },
              browseSynonyms(
                { indexName: e, searchSynonymsParams: t, ...r },
                n
              ) {
                const s = { page: 0, ...t, hitsPerPage: 1e3 };
                return createIterablePromise({
                  func: (t) => {
                    const r = this.searchSynonyms(
                      {
                        indexName: e,
                        searchSynonymsParams: { ...s, page: s.page },
                      },
                      n
                    );
                    return (s.page += 1), r;
                  },
                  validate: (e) => e.nbHits < s.hitsPerPage,
                  ...r,
                });
              },
              searchForHits(e, t) {
                return this.search(e, t);
              },
              searchForFacets(e, t) {
                return this.search(e, t);
              },
              async chunkedBatch(
                {
                  indexName: e,
                  objects: t,
                  action: r = "addObject",
                  waitForTasks: n,
                  batchSize: s = 1e3,
                },
                i
              ) {
                let a = [];
                const o = [];
                for (const [n, c] of t.entries())
                  a.push({ action: r, body: c }),
                    n % s == 0 &&
                      (o.push(
                        await this.batch(
                          { indexName: e, batchWriteParams: { requests: a } },
                          i
                        )
                      ),
                      (a = []));
                if (n)
                  for (const t of o)
                    await this.waitForTask({ indexName: e, taskID: t.taskID });
                return o;
              },
              async replaceAllObjects(
                { indexName: e, objects: t, batchSize: r },
                n
              ) {
                const s = `${e}_tmp_${Math.random().toString(36).substring(7)}`,
                  i = await this.operationIndex(
                    {
                      indexName: e,
                      operationIndexParams: {
                        operation: "copy",
                        destination: s,
                        scope: ["settings", "rules", "synonyms"],
                      },
                    },
                    n
                  );
                await this.waitForTask({ indexName: e, taskID: i.taskID });
                const a = await this.chunkedBatch(
                    {
                      indexName: s,
                      objects: t,
                      waitForTasks: !0,
                      batchSize: r,
                    },
                    n
                  ),
                  o = await this.operationIndex(
                    {
                      indexName: s,
                      operationIndexParams: {
                        operation: "move",
                        destination: e,
                      },
                    },
                    n
                  );
                return (
                  await this.waitForTask({ indexName: e, taskID: o.taskID }),
                  {
                    copyOperationResponse: i,
                    batchResponses: a,
                    moveOperationResponse: o,
                  }
                );
              },
              addApiKey(e, t) {
                if (!e)
                  throw new Error(
                    "Parameter `apiKey` is required when calling `addApiKey`."
                  );
                if (!e.acl)
                  throw new Error(
                    "Parameter `apiKey.acl` is required when calling `addApiKey`."
                  );
                const r = {
                  method: "POST",
                  path: "/1/keys",
                  queryParameters: {},
                  headers: {},
                  data: e,
                };
                return o.request(r, t);
              },
              addOrUpdateObject({ indexName: e, objectID: t, body: r }, n) {
                if (!e)
                  throw new Error(
                    "Parameter `indexName` is required when calling `addOrUpdateObject`."
                  );
                if (!t)
                  throw new Error(
                    "Parameter `objectID` is required when calling `addOrUpdateObject`."
                  );
                if (!r)
                  throw new Error(
                    "Parameter `body` is required when calling `addOrUpdateObject`."
                  );
                const s = {
                  method: "PUT",
                  path: "/1/indexes/{indexName}/{objectID}"
                    .replace("{indexName}", encodeURIComponent(e))
                    .replace("{objectID}", encodeURIComponent(t)),
                  queryParameters: {},
                  headers: {},
                  data: r,
                };
                return o.request(s, n);
              },
              appendSource(e, t) {
                if (!e)
                  throw new Error(
                    "Parameter `source` is required when calling `appendSource`."
                  );
                if (!e.source)
                  throw new Error(
                    "Parameter `source.source` is required when calling `appendSource`."
                  );
                const r = {
                  method: "POST",
                  path: "/1/security/sources/append",
                  queryParameters: {},
                  headers: {},
                  data: e,
                };
                return o.request(r, t);
              },
              assignUserId({ xAlgoliaUserID: e, assignUserIdParams: t }, r) {
                if (!e)
                  throw new Error(
                    "Parameter `xAlgoliaUserID` is required when calling `assignUserId`."
                  );
                if (!t)
                  throw new Error(
                    "Parameter `assignUserIdParams` is required when calling `assignUserId`."
                  );
                if (!t.cluster)
                  throw new Error(
                    "Parameter `assignUserIdParams.cluster` is required when calling `assignUserId`."
                  );
                const n = {};
                void 0 !== e && (n["X-Algolia-User-ID"] = e.toString());
                const s = {
                  method: "POST",
                  path: "/1/clusters/mapping",
                  queryParameters: {},
                  headers: n,
                  data: t,
                };
                return o.request(s, r);
              },
              batch({ indexName: e, batchWriteParams: t }, r) {
                if (!e)
                  throw new Error(
                    "Parameter `indexName` is required when calling `batch`."
                  );
                if (!t)
                  throw new Error(
                    "Parameter `batchWriteParams` is required when calling `batch`."
                  );
                if (!t.requests)
                  throw new Error(
                    "Parameter `batchWriteParams.requests` is required when calling `batch`."
                  );
                const n = {
                  method: "POST",
                  path: "/1/indexes/{indexName}/batch".replace(
                    "{indexName}",
                    encodeURIComponent(e)
                  ),
                  queryParameters: {},
                  headers: {},
                  data: t,
                };
                return o.request(n, r);
              },
              batchAssignUserIds(
                { xAlgoliaUserID: e, batchAssignUserIdsParams: t },
                r
              ) {
                if (!e)
                  throw new Error(
                    "Parameter `xAlgoliaUserID` is required when calling `batchAssignUserIds`."
                  );
                if (!t)
                  throw new Error(
                    "Parameter `batchAssignUserIdsParams` is required when calling `batchAssignUserIds`."
                  );
                if (!t.cluster)
                  throw new Error(
                    "Parameter `batchAssignUserIdsParams.cluster` is required when calling `batchAssignUserIds`."
                  );
                if (!t.users)
                  throw new Error(
                    "Parameter `batchAssignUserIdsParams.users` is required when calling `batchAssignUserIds`."
                  );
                const n = {};
                void 0 !== e && (n["X-Algolia-User-ID"] = e.toString());
                const s = {
                  method: "POST",
                  path: "/1/clusters/mapping/batch",
                  queryParameters: {},
                  headers: n,
                  data: t,
                };
                return o.request(s, r);
              },
              batchDictionaryEntries(
                { dictionaryName: e, batchDictionaryEntriesParams: t },
                r
              ) {
                if (!e)
                  throw new Error(
                    "Parameter `dictionaryName` is required when calling `batchDictionaryEntries`."
                  );
                if (!t)
                  throw new Error(
                    "Parameter `batchDictionaryEntriesParams` is required when calling `batchDictionaryEntries`."
                  );
                if (!t.requests)
                  throw new Error(
                    "Parameter `batchDictionaryEntriesParams.requests` is required when calling `batchDictionaryEntries`."
                  );
                const n = {
                  method: "POST",
                  path: "/1/dictionaries/{dictionaryName}/batch".replace(
                    "{dictionaryName}",
                    encodeURIComponent(e)
                  ),
                  queryParameters: {},
                  headers: {},
                  data: t,
                };
                return o.request(n, r);
              },
              browse({ indexName: e, browseParams: t }, r) {
                if (!e)
                  throw new Error(
                    "Parameter `indexName` is required when calling `browse`."
                  );
                const n = {
                  method: "POST",
                  path: "/1/indexes/{indexName}/browse".replace(
                    "{indexName}",
                    encodeURIComponent(e)
                  ),
                  queryParameters: {},
                  headers: {},
                  data: t || {},
                };
                return o.request(n, r);
              },
              clearObjects({ indexName: e }, t) {
                if (!e)
                  throw new Error(
                    "Parameter `indexName` is required when calling `clearObjects`."
                  );
                const r = {
                  method: "POST",
                  path: "/1/indexes/{indexName}/clear".replace(
                    "{indexName}",
                    encodeURIComponent(e)
                  ),
                  queryParameters: {},
                  headers: {},
                };
                return o.request(r, t);
              },
              clearRules({ indexName: e, forwardToReplicas: t }, r) {
                if (!e)
                  throw new Error(
                    "Parameter `indexName` is required when calling `clearRules`."
                  );
                const n = "/1/indexes/{indexName}/rules/clear".replace(
                    "{indexName}",
                    encodeURIComponent(e)
                  ),
                  s = {};
                void 0 !== t && (s.forwardToReplicas = t.toString());
                const i = {
                  method: "POST",
                  path: n,
                  queryParameters: s,
                  headers: {},
                };
                return o.request(i, r);
              },
              clearSynonyms({ indexName: e, forwardToReplicas: t }, r) {
                if (!e)
                  throw new Error(
                    "Parameter `indexName` is required when calling `clearSynonyms`."
                  );
                const n = "/1/indexes/{indexName}/synonyms/clear".replace(
                    "{indexName}",
                    encodeURIComponent(e)
                  ),
                  s = {};
                void 0 !== t && (s.forwardToReplicas = t.toString());
                const i = {
                  method: "POST",
                  path: n,
                  queryParameters: s,
                  headers: {},
                };
                return o.request(i, r);
              },
              customDelete({ path: e, parameters: t }, r) {
                if (!e)
                  throw new Error(
                    "Parameter `path` is required when calling `customDelete`."
                  );
                const n = {
                  method: "DELETE",
                  path: "/{path}".replace("{path}", e),
                  queryParameters: t || {},
                  headers: {},
                };
                return o.request(n, r);
              },
              customGet({ path: e, parameters: t }, r) {
                if (!e)
                  throw new Error(
                    "Parameter `path` is required when calling `customGet`."
                  );
                const n = {
                  method: "GET",
                  path: "/{path}".replace("{path}", e),
                  queryParameters: t || {},
                  headers: {},
                };
                return o.request(n, r);
              },
              customPost({ path: e, parameters: t, body: r }, n) {
                if (!e)
                  throw new Error(
                    "Parameter `path` is required when calling `customPost`."
                  );
                const s = {
                  method: "POST",
                  path: "/{path}".replace("{path}", e),
                  queryParameters: t || {},
                  headers: {},
                  data: r || {},
                };
                return o.request(s, n);
              },
              customPut({ path: e, parameters: t, body: r }, n) {
                if (!e)
                  throw new Error(
                    "Parameter `path` is required when calling `customPut`."
                  );
                const s = {
                  method: "PUT",
                  path: "/{path}".replace("{path}", e),
                  queryParameters: t || {},
                  headers: {},
                  data: r || {},
                };
                return o.request(s, n);
              },
              deleteApiKey({ key: e }, t) {
                if (!e)
                  throw new Error(
                    "Parameter `key` is required when calling `deleteApiKey`."
                  );
                const r = {
                  method: "DELETE",
                  path: "/1/keys/{key}".replace("{key}", encodeURIComponent(e)),
                  queryParameters: {},
                  headers: {},
                };
                return o.request(r, t);
              },
              deleteBy({ indexName: e, deleteByParams: t }, r) {
                if (!e)
                  throw new Error(
                    "Parameter `indexName` is required when calling `deleteBy`."
                  );
                if (!t)
                  throw new Error(
                    "Parameter `deleteByParams` is required when calling `deleteBy`."
                  );
                const n = {
                  method: "POST",
                  path: "/1/indexes/{indexName}/deleteByQuery".replace(
                    "{indexName}",
                    encodeURIComponent(e)
                  ),
                  queryParameters: {},
                  headers: {},
                  data: t,
                };
                return o.request(n, r);
              },
              deleteIndex({ indexName: e }, t) {
                if (!e)
                  throw new Error(
                    "Parameter `indexName` is required when calling `deleteIndex`."
                  );
                const r = {
                  method: "DELETE",
                  path: "/1/indexes/{indexName}".replace(
                    "{indexName}",
                    encodeURIComponent(e)
                  ),
                  queryParameters: {},
                  headers: {},
                };
                return o.request(r, t);
              },
              deleteObject({ indexName: e, objectID: t }, r) {
                if (!e)
                  throw new Error(
                    "Parameter `indexName` is required when calling `deleteObject`."
                  );
                if (!t)
                  throw new Error(
                    "Parameter `objectID` is required when calling `deleteObject`."
                  );
                const n = {
                  method: "DELETE",
                  path: "/1/indexes/{indexName}/{objectID}"
                    .replace("{indexName}", encodeURIComponent(e))
                    .replace("{objectID}", encodeURIComponent(t)),
                  queryParameters: {},
                  headers: {},
                };
                return o.request(n, r);
              },
              deleteRule(
                { indexName: e, objectID: t, forwardToReplicas: r },
                n
              ) {
                if (!e)
                  throw new Error(
                    "Parameter `indexName` is required when calling `deleteRule`."
                  );
                if (!t)
                  throw new Error(
                    "Parameter `objectID` is required when calling `deleteRule`."
                  );
                const s = "/1/indexes/{indexName}/rules/{objectID}"
                    .replace("{indexName}", encodeURIComponent(e))
                    .replace("{objectID}", encodeURIComponent(t)),
                  i = {};
                void 0 !== r && (i.forwardToReplicas = r.toString());
                const a = {
                  method: "DELETE",
                  path: s,
                  queryParameters: i,
                  headers: {},
                };
                return o.request(a, n);
              },
              deleteSource({ source: e }, t) {
                if (!e)
                  throw new Error(
                    "Parameter `source` is required when calling `deleteSource`."
                  );
                const r = {
                  method: "DELETE",
                  path: "/1/security/sources/{source}".replace(
                    "{source}",
                    encodeURIComponent(e)
                  ),
                  queryParameters: {},
                  headers: {},
                };
                return o.request(r, t);
              },
              deleteSynonym(
                { indexName: e, objectID: t, forwardToReplicas: r },
                n
              ) {
                if (!e)
                  throw new Error(
                    "Parameter `indexName` is required when calling `deleteSynonym`."
                  );
                if (!t)
                  throw new Error(
                    "Parameter `objectID` is required when calling `deleteSynonym`."
                  );
                const s = "/1/indexes/{indexName}/synonyms/{objectID}"
                    .replace("{indexName}", encodeURIComponent(e))
                    .replace("{objectID}", encodeURIComponent(t)),
                  i = {};
                void 0 !== r && (i.forwardToReplicas = r.toString());
                const a = {
                  method: "DELETE",
                  path: s,
                  queryParameters: i,
                  headers: {},
                };
                return o.request(a, n);
              },
              getApiKey({ key: e }, t) {
                if (!e)
                  throw new Error(
                    "Parameter `key` is required when calling `getApiKey`."
                  );
                const r = {
                  method: "GET",
                  path: "/1/keys/{key}".replace("{key}", encodeURIComponent(e)),
                  queryParameters: {},
                  headers: {},
                };
                return o.request(r, t);
              },
              getDictionaryLanguages(e) {
                const t = {
                  method: "GET",
                  path: "/1/dictionaries/*/languages",
                  queryParameters: {},
                  headers: {},
                };
                return o.request(t, e);
              },
              getDictionarySettings(e) {
                const t = {
                  method: "GET",
                  path: "/1/dictionaries/*/settings",
                  queryParameters: {},
                  headers: {},
                };
                return o.request(t, e);
              },
              getLogs(
                { offset: e, length: t, indexName: r, type: n } = {},
                s = void 0
              ) {
                const i = {};
                void 0 !== e && (i.offset = e.toString()),
                  void 0 !== t && (i.length = t.toString()),
                  void 0 !== r && (i.indexName = r.toString()),
                  void 0 !== n && (i.type = n.toString());
                const a = {
                  method: "GET",
                  path: "/1/logs",
                  queryParameters: i,
                  headers: {},
                };
                return o.request(a, s);
              },
              getObject(
                { indexName: e, objectID: t, attributesToRetrieve: r },
                n
              ) {
                if (!e)
                  throw new Error(
                    "Parameter `indexName` is required when calling `getObject`."
                  );
                if (!t)
                  throw new Error(
                    "Parameter `objectID` is required when calling `getObject`."
                  );
                const s = "/1/indexes/{indexName}/{objectID}"
                    .replace("{indexName}", encodeURIComponent(e))
                    .replace("{objectID}", encodeURIComponent(t)),
                  i = {};
                void 0 !== r && (i.attributesToRetrieve = r.toString());
                const a = {
                  method: "GET",
                  path: s,
                  queryParameters: i,
                  headers: {},
                };
                return o.request(a, n);
              },
              getObjects(e, t) {
                if (!e)
                  throw new Error(
                    "Parameter `getObjectsParams` is required when calling `getObjects`."
                  );
                if (!e.requests)
                  throw new Error(
                    "Parameter `getObjectsParams.requests` is required when calling `getObjects`."
                  );
                const r = {
                  method: "POST",
                  path: "/1/indexes/*/objects",
                  queryParameters: {},
                  headers: {},
                  data: e,
                  useReadTransporter: !0,
                  cacheable: !0,
                };
                return o.request(r, t);
              },
              getRule({ indexName: e, objectID: t }, r) {
                if (!e)
                  throw new Error(
                    "Parameter `indexName` is required when calling `getRule`."
                  );
                if (!t)
                  throw new Error(
                    "Parameter `objectID` is required when calling `getRule`."
                  );
                const n = {
                  method: "GET",
                  path: "/1/indexes/{indexName}/rules/{objectID}"
                    .replace("{indexName}", encodeURIComponent(e))
                    .replace("{objectID}", encodeURIComponent(t)),
                  queryParameters: {},
                  headers: {},
                };
                return o.request(n, r);
              },
              getSettings({ indexName: e }, t) {
                if (!e)
                  throw new Error(
                    "Parameter `indexName` is required when calling `getSettings`."
                  );
                const r = {
                  method: "GET",
                  path: "/1/indexes/{indexName}/settings".replace(
                    "{indexName}",
                    encodeURIComponent(e)
                  ),
                  queryParameters: {},
                  headers: {},
                };
                return o.request(r, t);
              },
              getSources(e) {
                const t = {
                  method: "GET",
                  path: "/1/security/sources",
                  queryParameters: {},
                  headers: {},
                };
                return o.request(t, e);
              },
              getSynonym({ indexName: e, objectID: t }, r) {
                if (!e)
                  throw new Error(
                    "Parameter `indexName` is required when calling `getSynonym`."
                  );
                if (!t)
                  throw new Error(
                    "Parameter `objectID` is required when calling `getSynonym`."
                  );
                const n = {
                  method: "GET",
                  path: "/1/indexes/{indexName}/synonyms/{objectID}"
                    .replace("{indexName}", encodeURIComponent(e))
                    .replace("{objectID}", encodeURIComponent(t)),
                  queryParameters: {},
                  headers: {},
                };
                return o.request(n, r);
              },
              getTask({ indexName: e, taskID: t }, r) {
                if (!e)
                  throw new Error(
                    "Parameter `indexName` is required when calling `getTask`."
                  );
                if (!t)
                  throw new Error(
                    "Parameter `taskID` is required when calling `getTask`."
                  );
                const n = {
                  method: "GET",
                  path: "/1/indexes/{indexName}/task/{taskID}"
                    .replace("{indexName}", encodeURIComponent(e))
                    .replace("{taskID}", encodeURIComponent(t)),
                  queryParameters: {},
                  headers: {},
                };
                return o.request(n, r);
              },
              getTopUserIds(e) {
                const t = {
                  method: "GET",
                  path: "/1/clusters/mapping/top",
                  queryParameters: {},
                  headers: {},
                };
                return o.request(t, e);
              },
              getUserId({ userID: e }, t) {
                if (!e)
                  throw new Error(
                    "Parameter `userID` is required when calling `getUserId`."
                  );
                const r = {
                  method: "GET",
                  path: "/1/clusters/mapping/{userID}".replace(
                    "{userID}",
                    encodeURIComponent(e)
                  ),
                  queryParameters: {},
                  headers: {},
                };
                return o.request(r, t);
              },
              hasPendingMappings({ getClusters: e } = {}, t = void 0) {
                const r = {};
                void 0 !== e && (r.getClusters = e.toString());
                const n = {
                  method: "GET",
                  path: "/1/clusters/mapping/pending",
                  queryParameters: r,
                  headers: {},
                };
                return o.request(n, t);
              },
              listApiKeys(e) {
                const t = {
                  method: "GET",
                  path: "/1/keys",
                  queryParameters: {},
                  headers: {},
                };
                return o.request(t, e);
              },
              listClusters(e) {
                const t = {
                  method: "GET",
                  path: "/1/clusters",
                  queryParameters: {},
                  headers: {},
                };
                return o.request(t, e);
              },
              listIndices({ page: e, hitsPerPage: t } = {}, r = void 0) {
                const n = {};
                void 0 !== e && (n.page = e.toString()),
                  void 0 !== t && (n.hitsPerPage = t.toString());
                const s = {
                  method: "GET",
                  path: "/1/indexes",
                  queryParameters: n,
                  headers: {},
                };
                return o.request(s, r);
              },
              listUserIds({ page: e, hitsPerPage: t } = {}, r = void 0) {
                const n = {};
                void 0 !== e && (n.page = e.toString()),
                  void 0 !== t && (n.hitsPerPage = t.toString());
                const s = {
                  method: "GET",
                  path: "/1/clusters/mapping",
                  queryParameters: n,
                  headers: {},
                };
                return o.request(s, r);
              },
              multipleBatch(e, t) {
                if (!e)
                  throw new Error(
                    "Parameter `batchParams` is required when calling `multipleBatch`."
                  );
                if (!e.requests)
                  throw new Error(
                    "Parameter `batchParams.requests` is required when calling `multipleBatch`."
                  );
                const r = {
                  method: "POST",
                  path: "/1/indexes/*/batch",
                  queryParameters: {},
                  headers: {},
                  data: e,
                };
                return o.request(r, t);
              },
              operationIndex({ indexName: e, operationIndexParams: t }, r) {
                if (!e)
                  throw new Error(
                    "Parameter `indexName` is required when calling `operationIndex`."
                  );
                if (!t)
                  throw new Error(
                    "Parameter `operationIndexParams` is required when calling `operationIndex`."
                  );
                if (!t.operation)
                  throw new Error(
                    "Parameter `operationIndexParams.operation` is required when calling `operationIndex`."
                  );
                if (!t.destination)
                  throw new Error(
                    "Parameter `operationIndexParams.destination` is required when calling `operationIndex`."
                  );
                const n = {
                  method: "POST",
                  path: "/1/indexes/{indexName}/operation".replace(
                    "{indexName}",
                    encodeURIComponent(e)
                  ),
                  queryParameters: {},
                  headers: {},
                  data: t,
                };
                return o.request(n, r);
              },
              partialUpdateObject(
                {
                  indexName: e,
                  objectID: t,
                  attributesToUpdate: r,
                  createIfNotExists: n,
                },
                s
              ) {
                if (!e)
                  throw new Error(
                    "Parameter `indexName` is required when calling `partialUpdateObject`."
                  );
                if (!t)
                  throw new Error(
                    "Parameter `objectID` is required when calling `partialUpdateObject`."
                  );
                if (!r)
                  throw new Error(
                    "Parameter `attributesToUpdate` is required when calling `partialUpdateObject`."
                  );
                const i = "/1/indexes/{indexName}/{objectID}/partial"
                    .replace("{indexName}", encodeURIComponent(e))
                    .replace("{objectID}", encodeURIComponent(t)),
                  a = {};
                void 0 !== n && (a.createIfNotExists = n.toString());
                const c = {
                  method: "POST",
                  path: i,
                  queryParameters: a,
                  headers: {},
                  data: r,
                };
                return o.request(c, s);
              },
              removeUserId({ userID: e }, t) {
                if (!e)
                  throw new Error(
                    "Parameter `userID` is required when calling `removeUserId`."
                  );
                const r = {
                  method: "DELETE",
                  path: "/1/clusters/mapping/{userID}".replace(
                    "{userID}",
                    encodeURIComponent(e)
                  ),
                  queryParameters: {},
                  headers: {},
                };
                return o.request(r, t);
              },
              replaceSources({ source: e }, t) {
                if (!e)
                  throw new Error(
                    "Parameter `source` is required when calling `replaceSources`."
                  );
                const r = {
                  method: "PUT",
                  path: "/1/security/sources",
                  queryParameters: {},
                  headers: {},
                  data: e,
                };
                return o.request(r, t);
              },
              restoreApiKey({ key: e }, t) {
                if (!e)
                  throw new Error(
                    "Parameter `key` is required when calling `restoreApiKey`."
                  );
                const r = {
                  method: "POST",
                  path: "/1/keys/{key}/restore".replace(
                    "{key}",
                    encodeURIComponent(e)
                  ),
                  queryParameters: {},
                  headers: {},
                };
                return o.request(r, t);
              },
              saveObject({ indexName: e, body: t }, r) {
                if (!e)
                  throw new Error(
                    "Parameter `indexName` is required when calling `saveObject`."
                  );
                if (!t)
                  throw new Error(
                    "Parameter `body` is required when calling `saveObject`."
                  );
                const n = {
                  method: "POST",
                  path: "/1/indexes/{indexName}".replace(
                    "{indexName}",
                    encodeURIComponent(e)
                  ),
                  queryParameters: {},
                  headers: {},
                  data: t,
                };
                return o.request(n, r);
              },
              saveRule(
                { indexName: e, objectID: t, rule: r, forwardToReplicas: n },
                s
              ) {
                if (!e)
                  throw new Error(
                    "Parameter `indexName` is required when calling `saveRule`."
                  );
                if (!t)
                  throw new Error(
                    "Parameter `objectID` is required when calling `saveRule`."
                  );
                if (!r)
                  throw new Error(
                    "Parameter `rule` is required when calling `saveRule`."
                  );
                if (!r.objectID)
                  throw new Error(
                    "Parameter `rule.objectID` is required when calling `saveRule`."
                  );
                const i = "/1/indexes/{indexName}/rules/{objectID}"
                    .replace("{indexName}", encodeURIComponent(e))
                    .replace("{objectID}", encodeURIComponent(t)),
                  a = {};
                void 0 !== n && (a.forwardToReplicas = n.toString());
                const c = {
                  method: "PUT",
                  path: i,
                  queryParameters: a,
                  headers: {},
                  data: r,
                };
                return o.request(c, s);
              },
              saveRules(
                {
                  indexName: e,
                  rules: t,
                  forwardToReplicas: r,
                  clearExistingRules: n,
                },
                s
              ) {
                if (!e)
                  throw new Error(
                    "Parameter `indexName` is required when calling `saveRules`."
                  );
                if (!t)
                  throw new Error(
                    "Parameter `rules` is required when calling `saveRules`."
                  );
                const i = "/1/indexes/{indexName}/rules/batch".replace(
                    "{indexName}",
                    encodeURIComponent(e)
                  ),
                  a = {};
                void 0 !== r && (a.forwardToReplicas = r.toString()),
                  void 0 !== n && (a.clearExistingRules = n.toString());
                const c = {
                  method: "POST",
                  path: i,
                  queryParameters: a,
                  headers: {},
                  data: t,
                };
                return o.request(c, s);
              },
              saveSynonym(
                {
                  indexName: e,
                  objectID: t,
                  synonymHit: r,
                  forwardToReplicas: n,
                },
                s
              ) {
                if (!e)
                  throw new Error(
                    "Parameter `indexName` is required when calling `saveSynonym`."
                  );
                if (!t)
                  throw new Error(
                    "Parameter `objectID` is required when calling `saveSynonym`."
                  );
                if (!r)
                  throw new Error(
                    "Parameter `synonymHit` is required when calling `saveSynonym`."
                  );
                if (!r.objectID)
                  throw new Error(
                    "Parameter `synonymHit.objectID` is required when calling `saveSynonym`."
                  );
                if (!r.type)
                  throw new Error(
                    "Parameter `synonymHit.type` is required when calling `saveSynonym`."
                  );
                const i = "/1/indexes/{indexName}/synonyms/{objectID}"
                    .replace("{indexName}", encodeURIComponent(e))
                    .replace("{objectID}", encodeURIComponent(t)),
                  a = {};
                void 0 !== n && (a.forwardToReplicas = n.toString());
                const c = {
                  method: "PUT",
                  path: i,
                  queryParameters: a,
                  headers: {},
                  data: r,
                };
                return o.request(c, s);
              },
              saveSynonyms(
                {
                  indexName: e,
                  synonymHit: t,
                  forwardToReplicas: r,
                  replaceExistingSynonyms: n,
                },
                s
              ) {
                if (!e)
                  throw new Error(
                    "Parameter `indexName` is required when calling `saveSynonyms`."
                  );
                if (!t)
                  throw new Error(
                    "Parameter `synonymHit` is required when calling `saveSynonyms`."
                  );
                const i = "/1/indexes/{indexName}/synonyms/batch".replace(
                    "{indexName}",
                    encodeURIComponent(e)
                  ),
                  a = {};
                void 0 !== r && (a.forwardToReplicas = r.toString()),
                  void 0 !== n && (a.replaceExistingSynonyms = n.toString());
                const c = {
                  method: "POST",
                  path: i,
                  queryParameters: a,
                  headers: {},
                  data: t,
                };
                return o.request(c, s);
              },
              search(e, t) {
                if (e && Array.isArray(e)) {
                  const t = {
                    requests: e.map(({ params: e, ...t }) =>
                      "facet" === t.type
                        ? { ...t, ...e, type: "facet" }
                        : {
                            ...t,
                            ...e,
                            facet: void 0,
                            maxFacetHits: void 0,
                            facetQuery: void 0,
                          }
                    ),
                  };
                  e = t;
                }
                if (!e)
                  throw new Error(
                    "Parameter `searchMethodParams` is required when calling `search`."
                  );
                if (!e.requests)
                  throw new Error(
                    "Parameter `searchMethodParams.requests` is required when calling `search`."
                  );
                const r = {
                  method: "POST",
                  path: "/1/indexes/*/queries",
                  queryParameters: {},
                  headers: {},
                  data: e,
                  useReadTransporter: !0,
                  cacheable: !0,
                };
                return o.request(r, t);
              },
              searchDictionaryEntries(
                { dictionaryName: e, searchDictionaryEntriesParams: t },
                r
              ) {
                if (!e)
                  throw new Error(
                    "Parameter `dictionaryName` is required when calling `searchDictionaryEntries`."
                  );
                if (!t)
                  throw new Error(
                    "Parameter `searchDictionaryEntriesParams` is required when calling `searchDictionaryEntries`."
                  );
                if (!t.query)
                  throw new Error(
                    "Parameter `searchDictionaryEntriesParams.query` is required when calling `searchDictionaryEntries`."
                  );
                const n = {
                  method: "POST",
                  path: "/1/dictionaries/{dictionaryName}/search".replace(
                    "{dictionaryName}",
                    encodeURIComponent(e)
                  ),
                  queryParameters: {},
                  headers: {},
                  data: t,
                  useReadTransporter: !0,
                  cacheable: !0,
                };
                return o.request(n, r);
              },
              searchForFacetValues(
                { indexName: e, facetName: t, searchForFacetValuesRequest: r },
                n
              ) {
                if (!e)
                  throw new Error(
                    "Parameter `indexName` is required when calling `searchForFacetValues`."
                  );
                if (!t)
                  throw new Error(
                    "Parameter `facetName` is required when calling `searchForFacetValues`."
                  );
                const s = {
                  method: "POST",
                  path: "/1/indexes/{indexName}/facets/{facetName}/query"
                    .replace("{indexName}", encodeURIComponent(e))
                    .replace("{facetName}", encodeURIComponent(t)),
                  queryParameters: {},
                  headers: {},
                  data: r || {},
                  useReadTransporter: !0,
                  cacheable: !0,
                };
                return o.request(s, n);
              },
              searchRules({ indexName: e, searchRulesParams: t }, r) {
                if (!e)
                  throw new Error(
                    "Parameter `indexName` is required when calling `searchRules`."
                  );
                const n = {
                  method: "POST",
                  path: "/1/indexes/{indexName}/rules/search".replace(
                    "{indexName}",
                    encodeURIComponent(e)
                  ),
                  queryParameters: {},
                  headers: {},
                  data: t || {},
                  useReadTransporter: !0,
                  cacheable: !0,
                };
                return o.request(n, r);
              },
              searchSingleIndex({ indexName: e, searchParams: t }, r) {
                if (!e)
                  throw new Error(
                    "Parameter `indexName` is required when calling `searchSingleIndex`."
                  );
                const n = {
                  method: "POST",
                  path: "/1/indexes/{indexName}/query".replace(
                    "{indexName}",
                    encodeURIComponent(e)
                  ),
                  queryParameters: {},
                  headers: {},
                  data: t || {},
                  useReadTransporter: !0,
                  cacheable: !0,
                };
                return o.request(n, r);
              },
              searchSynonyms({ indexName: e, searchSynonymsParams: t }, r) {
                if (!e)
                  throw new Error(
                    "Parameter `indexName` is required when calling `searchSynonyms`."
                  );
                const n = {
                  method: "POST",
                  path: "/1/indexes/{indexName}/synonyms/search".replace(
                    "{indexName}",
                    encodeURIComponent(e)
                  ),
                  queryParameters: {},
                  headers: {},
                  data: t || {},
                  useReadTransporter: !0,
                  cacheable: !0,
                };
                return o.request(n, r);
              },
              searchUserIds(e, t) {
                if (!e)
                  throw new Error(
                    "Parameter `searchUserIdsParams` is required when calling `searchUserIds`."
                  );
                if (!e.query)
                  throw new Error(
                    "Parameter `searchUserIdsParams.query` is required when calling `searchUserIds`."
                  );
                const r = {
                  method: "POST",
                  path: "/1/clusters/mapping/search",
                  queryParameters: {},
                  headers: {},
                  data: e,
                  useReadTransporter: !0,
                  cacheable: !0,
                };
                return o.request(r, t);
              },
              setDictionarySettings(e, t) {
                if (!e)
                  throw new Error(
                    "Parameter `dictionarySettingsParams` is required when calling `setDictionarySettings`."
                  );
                if (!e.disableStandardEntries)
                  throw new Error(
                    "Parameter `dictionarySettingsParams.disableStandardEntries` is required when calling `setDictionarySettings`."
                  );
                const r = {
                  method: "PUT",
                  path: "/1/dictionaries/*/settings",
                  queryParameters: {},
                  headers: {},
                  data: e,
                };
                return o.request(r, t);
              },
              setSettings(
                { indexName: e, indexSettings: t, forwardToReplicas: r },
                n
              ) {
                if (!e)
                  throw new Error(
                    "Parameter `indexName` is required when calling `setSettings`."
                  );
                if (!t)
                  throw new Error(
                    "Parameter `indexSettings` is required when calling `setSettings`."
                  );
                const s = "/1/indexes/{indexName}/settings".replace(
                    "{indexName}",
                    encodeURIComponent(e)
                  ),
                  i = {};
                void 0 !== r && (i.forwardToReplicas = r.toString());
                const a = {
                  method: "PUT",
                  path: s,
                  queryParameters: i,
                  headers: {},
                  data: t,
                };
                return o.request(a, n);
              },
              updateApiKey({ key: e, apiKey: t }, r) {
                if (!e)
                  throw new Error(
                    "Parameter `key` is required when calling `updateApiKey`."
                  );
                if (!t)
                  throw new Error(
                    "Parameter `apiKey` is required when calling `updateApiKey`."
                  );
                if (!t.acl)
                  throw new Error(
                    "Parameter `apiKey.acl` is required when calling `updateApiKey`."
                  );
                const n = {
                  method: "PUT",
                  path: "/1/keys/{key}".replace("{key}", encodeURIComponent(e)),
                  queryParameters: {},
                  headers: {},
                  data: t,
                };
                return o.request(n, r);
              },
            };
          })({
            appId: e,
            apiKey: t,
            timeouts: { connect: 1e3, read: 2e3, write: 3e4 },
            requester: {
              send: function send(e) {
                return new Promise((t) => {
                  const r = new XMLHttpRequest();
                  r.open(e.method, e.url, !0),
                    Object.keys(e.headers).forEach((t) =>
                      r.setRequestHeader(t, e.headers[t])
                    );
                  const createTimeout = (e, n) =>
                      setTimeout(() => {
                        r.abort(), t({ status: 0, content: n, isTimedOut: !0 });
                      }, e),
                    n = createTimeout(e.connectTimeout, "Connection timeout");
                  let s;
                  (r.onreadystatechange = () => {
                    r.readyState > r.OPENED &&
                      void 0 === s &&
                      (clearTimeout(n),
                      (s = createTimeout(e.responseTimeout, "Socket timeout")));
                  }),
                    (r.onerror = () => {
                      0 === r.status &&
                        (clearTimeout(n),
                        clearTimeout(s),
                        t({
                          content: r.responseText || "Network request failed",
                          status: r.status,
                          isTimedOut: !1,
                        }));
                    }),
                    (r.onload = () => {
                      clearTimeout(n),
                        clearTimeout(s),
                        t({
                          content: r.responseText,
                          status: r.status,
                          isTimedOut: !1,
                        });
                    }),
                    r.send(e.data);
                });
              },
            },
            algoliaAgents: [{ segment: "Browser" }],
            authMode: "WithinQueryParameters",
            responsesCache: createMemoryCache(),
            requestsCache: createMemoryCache({ serializable: !1 }),
            hostsCache: createFallbackableCache({
              caches: [
                createBrowserLocalStorageCache({ key: `${s}-${e}` }),
                createMemoryCache(),
              ],
            }),
            ...r,
          });
        }
        var i = r(424),
          a = r.n(i);
        class AgSearchInsightsUtil {
          constructor(e) {
            if (
              ((this.singleton$ = new ObserverLite({
                key: "AgSearchInsightsUtil$",
              })),
              !e)
            )
              return new Promise(async (e, t) => {
                e(await this.singleton$.once());
              });
            (this.settings = e), this.init();
          }
          async init() {
            a()("init", {
              appId: this.settings.app_id,
              apiKey: this.settings.search_api_key,
              useCookie: !1,
            }),
              this.singleton$.next(this);
            const e = new ObserverLite({ key: "Shopify.customerPrivacyApi" }),
              { analyticsAllowed: t } = await e.once();
            t &&
              a()("init", {
                appId: this.settings.app_id,
                apiKey: this.settings.search_api_key,
                useCookie: !0,
              });
          }
          sendItemClickEvent(e) {
            a()("clickedObjectIDsAfterSearch", {
              eventName: "Product Clicked",
              index: e.index,
              objectIDs: e.objectIDs,
            });
          }
        }
        class AgSearchUtil {
          constructor(e) {
            (this.settings = e),
              (this.client = searchClient(
                this.settings.app_id,
                this.settings.search_api_key
              ));
          }
          checkForRedirect(e) {
            e &&
              e.renderingContent &&
              e.renderingContent.redirect &&
              (window.location.href = e.renderingContent.redirect.url);
          }
          search({ query: e, indexes: t, merge: r }) {
            return new Promise((n, s) => {
              (t?.length && e) || s({ error: "no terms or indexes" }),
                this.client
                  .search({
                    requests: t.map(
                      ({
                        indexName: t,
                        hitsPerPage: r,
                        facets: n,
                        facetFilters: s,
                        attributesToRetrieve: i,
                      }) => ({
                        indexName: t,
                        query: e,
                        hitsPerPage: (r = r || 10),
                        facets: (n = n || ["*"]),
                        facetFilters: s,
                        attributesToRetrieve: (i = i || ["*"]),
                      })
                    ),
                  })
                  .then(({ results: e }) => {
                    if (
                      ((e = (e = e.map(
                        (e) => (
                          this.checkForRedirect(e),
                          (e.hits = e.hits.map(
                            (t) => ((t.agSearchIndexName = e.index), t)
                          )),
                          e
                        )
                      )).reduce(
                        (e, r) => (
                          (e[
                            t.find(({ indexName: e }) => e == r.index)?.key ||
                              r.index
                          ] = r),
                          e
                        ),
                        {}
                      )),
                      r)
                    ) {
                      const t = r.indexes.map((t) => e[t].hits).flat(1);
                      (r.hits = t),
                        (r.merge = !0),
                        (r.datasets = r.indexes.map((t) => e[t]).flat(1)),
                        r.indexes.forEach((t) => delete e[t]),
                        (e[r.key] = r);
                    }
                    n(e);
                  })
                  .catch((e) => {
                    s({ error: e });
                  });
            });
          }
        }
      },
      879: (e, t) => {
        "use strict";
        Object.defineProperty(t, "__esModule", { value: !0 });
        var r = "2.15.0";
        function extractAdditionalParams(e) {
          return e.reduce(
            function (e, t) {
              var r = e.events;
              e = e.additionalParams;
              return "index" in t
                ? { additionalParams: e, events: r.concat([t]) }
                : { events: r, additionalParams: t };
            },
            { events: [], additionalParams: void 0 }
          );
        }
        var LocalStorage = function () {},
          n =
            ((LocalStorage.get = function (e) {
              if (!(e = localStorage.getItem(e))) return null;
              try {
                return JSON.parse(e);
              } catch (e) {
                return null;
              }
            }),
            (LocalStorage.set = function (e, t) {
              try {
                localStorage.setItem(e, JSON.stringify(t));
              } catch (t) {
                console.error(
                  "Unable to set " +
                    e +
                    " in localStorage, storage may be full."
                );
              }
            }),
            (LocalStorage.remove = function (e) {
              localStorage.removeItem(e);
            }),
            (LocalStorage.THRESHOLD = 0.9),
            "AlgoliaObjectQueryCache"),
          s = 5e3,
          i = 1e3;
        function getCache() {
          var e;
          return null != (e = LocalStorage.get(n)) ? e : {};
        }
        function setCache(e) {
          LocalStorage.set(
            n,
            (function limited(e) {
              return Object.keys(e).length > s
                ? (function purgeOldest(e) {
                    return (
                      (e = Object.entries(e).sort(function (e, t) {
                        return (e = e[1][1]), t[1][1] - e;
                      })),
                      e.slice(0, e.length - i - 1).reduce(function (e, t) {
                        var r = t[0];
                        t = t[1];
                        return Object.assign(
                          Object.assign({}, e),
                          (((e = {})[r] = t), e)
                        );
                      }, {})
                    );
                  })(e)
                : e;
            })(e)
          );
        }
        function makeKey(e, t) {
          return e + "_" + t;
        }
        function storeQueryForObject(e, t, r) {
          var n = getCache();
          (n[makeKey(e, t)] = [r, Date.now()]), setCache(n);
        }
        var isUndefined = function (e) {
            return void 0 === e;
          },
          isFunction = function (e) {
            return "function" == typeof e;
          };
        function getFunctionalInterface(e) {
          return function (t) {
            for (var r = [], n = arguments.length - 1; 0 < n--; )
              r[n] = arguments[n + 1];
            t && isFunction(e[t])
              ? e[t].apply(e, r)
              : console.warn("The method `" + t + "` doesn't exist.");
          };
        }
        var a = [
          "insights-js (" + r + ")",
          "insights-js-browser-cjs (" + r + ")",
        ];
        function addAlgoliaAgent(e) {
          -1 === this._ua.indexOf(e) && this._ua.push(e);
        }
        function getVersion(e) {
          isFunction(e) && e(this.version);
        }
        function __rest(e, t) {
          var r = {};
          for (s in e)
            Object.prototype.hasOwnProperty.call(e, s) &&
              t.indexOf(s) < 0 &&
              (r[s] = e[s]);
          if (null != e && "function" == typeof Object.getOwnPropertySymbols)
            for (
              var n = 0, s = Object.getOwnPropertySymbols(e);
              n < s.length;
              n++
            )
              t.indexOf(s[n]) < 0 &&
                Object.prototype.propertyIsEnumerable.call(e, s[n]) &&
                (r[s[n]] = e[s[n]]);
          return r;
        }
        function addQueryId(e) {
          return e.map(function (e) {
            var t, r;
            return (function isValidEventForQueryIdLookup(e) {
              return !e.queryID && "conversion" === e.eventType;
            })(e) &&
              ((t = []),
              (r =
                null == (r = e.objectIDs)
                  ? void 0
                  : r.map(function (r, n) {
                      var s = null == (s = e.objectData) ? void 0 : s[n];
                      return null != s && s.queryID
                        ? s
                        : ((n = (
                            null !=
                            (n = (function getQueryForObject(e, t) {
                              return getCache()[makeKey(e, t)];
                            })(e.index, r))
                              ? n
                              : []
                          )[0]) && t.push(r),
                          Object.assign(Object.assign({}, s), { queryID: n }));
                    })),
              0 !== t.length)
              ? Object.assign(Object.assign({}, e), {
                  objectData: r,
                  objectIDsWithInferredQueryID: t,
                })
              : e;
          });
        }
        function makeSendEvents(e) {
          return function (t, r) {
            var n = this;
            if (!this._userHasOptedOut) {
              if (
                !(
                  (!isUndefined(this._apiKey) && !isUndefined(this._appId)) ||
                  ((null == (s = null == r ? void 0 : r.headers)
                    ? void 0
                    : s["X-Algolia-Application-Id"]) &&
                    (null == (s = null == r ? void 0 : r.headers)
                      ? void 0
                      : s["X-Algolia-API-Key"]))
                )
              )
                throw new Error(
                  "Before calling any methods on the analytics, you first need to call the 'init' function with appId and apiKey parameters or provide custom credentials in additional parameters."
                );
              !this._userToken &&
                this._anonymousUserToken &&
                this.setAnonymousUserToken(!0);
              var s = (null != r && r.inferQueryID ? addQueryId(t) : t).map(
                function (e) {
                  var t = e.filters,
                    r = __rest(e, ["filters"]);
                  e = Object.assign(Object.assign({}, r), {
                    userToken:
                      null != (r = null == e ? void 0 : e.userToken)
                        ? r
                        : n._userToken,
                    authenticatedUserToken:
                      null !=
                      (r = null == e ? void 0 : e.authenticatedUserToken)
                        ? r
                        : n._authenticatedUserToken,
                  });
                  return (
                    isUndefined(t) || (e.filters = t.map(encodeURIComponent)), e
                  );
                }
              );
              return 0 === s.length
                ? Promise.resolve(!1)
                : ((t = (function sendRequest(e, t, r, n, s, i, a) {
                    var o = (a = void 0 === a ? {} : a)[
                        "X-Algolia-Application-Id"
                      ],
                      c = a["X-Algolia-API-Key"],
                      l =
                        ((a = __rest(a, [
                          "X-Algolia-Application-Id",
                          "X-Algolia-API-Key",
                        ])),
                        Object.assign(
                          {
                            "X-Algolia-Application-Id": null != o ? o : s,
                            "X-Algolia-API-Key": null != c ? c : i,
                            "X-Algolia-Agent": encodeURIComponent(t.join("; ")),
                          },
                          a
                        ));
                    return e(
                      r +
                        "/1/events?" +
                        Object.keys(l)
                          .map(function (e) {
                            return e + "=" + l[e];
                          })
                          .join("&"),
                      { events: n }
                    );
                  })(
                    e,
                    this._ua,
                    this._endpointOrigin,
                    s,
                    this._appId,
                    this._apiKey,
                    null == r ? void 0 : r.headers
                  )),
                  (function (e) {
                    return "function" == typeof (null == e ? void 0 : e.then);
                  })(t)
                    ? t.then(
                        (function purgePurchased(e) {
                          return function (t) {
                            return (
                              t &&
                                e
                                  .filter(function (e) {
                                    var t = e.eventType,
                                      r = e.eventSubtype;
                                    e = e.objectIDs;
                                    return (
                                      "conversion" === t &&
                                      "purchase" === r &&
                                      (null == e ? void 0 : e.length)
                                    );
                                  })
                                  .forEach(function (e) {
                                    return (function removeQueryForObjects(
                                      e,
                                      t
                                    ) {
                                      var r = getCache();
                                      t.forEach(function (t) {
                                        delete r[makeKey(e, t)];
                                      }),
                                        setCache(r);
                                    })(e.index, e.objectIDs);
                                  }),
                              t
                            );
                          };
                        })(s)
                      )
                    : t);
            }
          };
        }
        function createUUID() {
          return "xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx".replace(
            /[xy]/g,
            function (e) {
              var t = (16 * Math.random()) | 0;
              return ("x" === e ? t : (3 & t) | 8).toString(16);
            }
          );
        }
        var o = "_ALGOLIA",
          c = 2592e6;
        function setAnonymousUserToken(e) {
          (e = void 0 !== e && e)
            ? this.setUserToken("anonymous-" + createUUID())
            : (function () {
                try {
                  return Boolean(navigator.cookieEnabled);
                } catch (e) {
                  return !1;
                }
              })() &&
              ((e = (function (e) {
                for (
                  var t = e + "=", r = document.cookie.split(";"), n = 0;
                  n < r.length;
                  n++
                ) {
                  for (var s = r[n]; " " === s.charAt(0); ) s = s.substring(1);
                  if (0 === s.indexOf(t))
                    return s.substring(t.length, s.length);
                }
                return "";
              })(o)) &&
              "" !== e &&
              0 === e.indexOf("anonymous-")
                ? this.setUserToken(e)
                : ((e = this.setUserToken("anonymous-" + createUUID())),
                  (function (e, t, r) {
                    var n = new Date();
                    n.setTime(n.getTime() + r),
                      (r = "expires=" + n.toUTCString()),
                      (document.cookie = e + "=" + t + ";" + r + ";path=/");
                  })(o, e, this._cookieDuration)));
        }
        function setUserToken(e) {
          return (
            (this._userToken = e),
            isFunction(this._onUserTokenChangeCallback) &&
              this._onUserTokenChangeCallback(this._userToken),
            this._userToken
          );
        }
        function getUserToken(e, t) {
          return isFunction(t) && t(null, this._userToken), this._userToken;
        }
        function onUserTokenChange(e, t) {
          (this._onUserTokenChangeCallback = e),
            t &&
              t.immediate &&
              isFunction(this._onUserTokenChangeCallback) &&
              this._onUserTokenChangeCallback(this._userToken);
        }
        function setAuthenticatedUserToken(e) {
          return (
            (this._authenticatedUserToken = e),
            isFunction(this._onAuthenticatedUserTokenChangeCallback) &&
              this._onAuthenticatedUserTokenChangeCallback(
                this._authenticatedUserToken
              ),
            this._authenticatedUserToken
          );
        }
        function getAuthenticatedUserToken(e, t) {
          return (
            isFunction(t) && t(null, this._authenticatedUserToken),
            this._authenticatedUserToken
          );
        }
        function onAuthenticatedUserTokenChange(e, t) {
          (this._onAuthenticatedUserTokenChangeCallback = e),
            t &&
              t.immediate &&
              isFunction(this._onAuthenticatedUserTokenChangeCallback) &&
              this._onAuthenticatedUserTokenChangeCallback(
                this._authenticatedUserToken
              );
        }
        function addEventType(e, t) {
          return t.map(function (t) {
            return Object.assign({ eventType: e }, t);
          });
        }
        function addEventTypeAndSubtype(e, t, r) {
          return r.map(function (r) {
            return Object.assign({ eventType: e, eventSubtype: t }, r);
          });
        }
        function clickedObjectIDsAfterSearch() {
          for (var e = [], t = arguments.length; t--; ) e[t] = arguments[t];
          var r = (n = extractAdditionalParams(e)).events,
            n = n.additionalParams;
          return (
            r.forEach(function (e) {
              var t = e.index,
                r = e.queryID;
              return e.objectIDs.forEach(function (e) {
                return storeQueryForObject(t, e, r);
              });
            }),
            this.sendEvents(addEventType("click", r), n)
          );
        }
        function clickedObjectIDs() {
          for (var e = [], t = arguments.length; t--; ) e[t] = arguments[t];
          var r = (n = extractAdditionalParams(e)).events,
            n = n.additionalParams;
          return this.sendEvents(addEventType("click", r), n);
        }
        function clickedFilters() {
          for (var e = [], t = arguments.length; t--; ) e[t] = arguments[t];
          var r = (n = extractAdditionalParams(e)).events,
            n = n.additionalParams;
          return this.sendEvents(addEventType("click", r), n);
        }
        function convertedObjectIDsAfterSearch() {
          for (var e = [], t = arguments.length; t--; ) e[t] = arguments[t];
          var r = (n = extractAdditionalParams(e)).events,
            n = n.additionalParams;
          return this.sendEvents(addEventType("conversion", r), n);
        }
        function addedToCartObjectIDsAfterSearch() {
          for (var e = [], t = arguments.length; t--; ) e[t] = arguments[t];
          var r = (n = extractAdditionalParams(e)).events,
            n = n.additionalParams;
          return (
            r.forEach(function (e) {
              var t = e.index,
                r = e.queryID,
                n = e.objectIDs,
                s = e.objectData;
              return n.forEach(function (e, n) {
                (n =
                  null !=
                  (n =
                    null == (n = null == s ? void 0 : s[n])
                      ? void 0
                      : n.queryID)
                    ? n
                    : r) && storeQueryForObject(t, e, n);
              });
            }),
            this.sendEvents(
              addEventTypeAndSubtype("conversion", "addToCart", r),
              n
            )
          );
        }
        function purchasedObjectIDsAfterSearch() {
          for (var e = [], t = arguments.length; t--; ) e[t] = arguments[t];
          var r = (n = extractAdditionalParams(e)).events,
            n = n.additionalParams;
          return this.sendEvents(
            addEventTypeAndSubtype("conversion", "purchase", r),
            n
          );
        }
        function convertedObjectIDs() {
          for (var e = [], t = arguments.length; t--; ) e[t] = arguments[t];
          var r = (n = extractAdditionalParams(e)).events,
            n = n.additionalParams;
          return this.sendEvents(addEventType("conversion", r), n);
        }
        function addedToCartObjectIDs() {
          for (var e = [], t = arguments.length; t--; ) e[t] = arguments[t];
          var r = (n = extractAdditionalParams(e)).events,
            n = n.additionalParams;
          return (
            r.forEach(function (e) {
              var t = e.index,
                r = e.objectIDs,
                n = e.objectData;
              return r.forEach(function (e, r) {
                (r =
                  null == (r = null == n ? void 0 : n[r])
                    ? void 0
                    : r.queryID) && storeQueryForObject(t, e, r);
              });
            }),
            this.sendEvents(
              addEventTypeAndSubtype("conversion", "addToCart", r),
              n
            )
          );
        }
        function purchasedObjectIDs() {
          for (var e = [], t = arguments.length; t--; ) e[t] = arguments[t];
          var r = (n = extractAdditionalParams(e)).events,
            n = n.additionalParams;
          return this.sendEvents(
            addEventTypeAndSubtype("conversion", "purchase", r),
            n
          );
        }
        function convertedFilters() {
          for (var e = [], t = arguments.length; t--; ) e[t] = arguments[t];
          var r = (n = extractAdditionalParams(e)).events,
            n = n.additionalParams;
          return this.sendEvents(addEventType("conversion", r), n);
        }
        var l = ["de", "us"];
        function init(e) {
          var t;
          if (
            !isUndefined((e = void 0 === e ? {} : e).region) &&
            -1 === l.indexOf(e.region)
          )
            throw new Error(
              "optional region is incorrect, please provide either one of: " +
                l.join(", ") +
                "."
            );
          if (
            !(
              isUndefined(e.cookieDuration) ||
              ((function (e) {
                return "number" == typeof e;
              })(e.cookieDuration) &&
                isFinite(e.cookieDuration) &&
                Math.floor(e.cookieDuration) === e.cookieDuration)
            )
          )
            throw new Error(
              "optional cookieDuration is incorrect, expected an integer."
            );
          (function setOptions(e, t, r) {
            var n = t.partial,
              s = __rest(t, ["partial"]);
            n || Object.assign(e, r),
              Object.assign(
                e,
                Object.keys(s).reduce(function (e, t) {
                  return Object.assign(
                    Object.assign({}, e),
                    (((e = {})["_" + t] = s[t]), e)
                  );
                }, {})
              );
          })(this, e, {
            _userHasOptedOut: Boolean(e.userHasOptedOut),
            _region: e.region,
            _host: e.host,
            _anonymousUserToken: null == (t = e.anonymousUserToken) || t,
            _useCookie: null != (t = e.useCookie) && t,
            _cookieDuration: e.cookieDuration || 6 * c,
          }),
            (this._endpointOrigin =
              this._host ||
              (this._region
                ? "https://insights." + this._region + ".algolia.io"
                : "https://insights.algolia.io")),
            (this._ua = [].concat(a)),
            e.authenticatedUserToken &&
              this.setAuthenticatedUserToken(e.authenticatedUserToken),
            e.userToken
              ? this.setUserToken(e.userToken)
              : this._userToken ||
                this._userHasOptedOut ||
                !this._useCookie ||
                this.setAnonymousUserToken();
        }
        function viewedObjectIDs() {
          for (var e = [], t = arguments.length; t--; ) e[t] = arguments[t];
          var r = (n = extractAdditionalParams(e)).events,
            n = n.additionalParams;
          return this.sendEvents(addEventType("view", r), n);
        }
        function viewedFilters() {
          for (var e = [], t = arguments.length; t--; ) e[t] = arguments[t];
          var r = (n = extractAdditionalParams(e)).events,
            n = n.additionalParams;
          return this.sendEvents(addEventType("view", r), n);
        }
        var AlgoliaAnalytics = function (e) {
          (e = e.requestFn),
            (this._endpointOrigin = "https://insights.algolia.io"),
            (this._anonymousUserToken = !0),
            (this._userHasOptedOut = !1),
            (this._useCookie = !1),
            (this._cookieDuration = 6 * c),
            (this._ua = []),
            (this.version = r),
            (this.sendEvents = makeSendEvents(e).bind(this)),
            (this.init = init.bind(this)),
            (this.addAlgoliaAgent = addAlgoliaAgent.bind(this)),
            (this.setUserToken = setUserToken.bind(this)),
            (this.setAnonymousUserToken = setAnonymousUserToken.bind(this)),
            (this.getUserToken = getUserToken.bind(this)),
            (this.onUserTokenChange = onUserTokenChange.bind(this)),
            (this.setAuthenticatedUserToken =
              setAuthenticatedUserToken.bind(this)),
            (this.getAuthenticatedUserToken =
              getAuthenticatedUserToken.bind(this)),
            (this.onAuthenticatedUserTokenChange =
              onAuthenticatedUserTokenChange.bind(this)),
            (this.clickedObjectIDsAfterSearch =
              clickedObjectIDsAfterSearch.bind(this)),
            (this.clickedObjectIDs = clickedObjectIDs.bind(this)),
            (this.clickedFilters = clickedFilters.bind(this)),
            (this.convertedObjectIDsAfterSearch =
              convertedObjectIDsAfterSearch.bind(this)),
            (this.purchasedObjectIDsAfterSearch =
              purchasedObjectIDsAfterSearch.bind(this)),
            (this.addedToCartObjectIDsAfterSearch =
              addedToCartObjectIDsAfterSearch.bind(this)),
            (this.convertedObjectIDs = convertedObjectIDs.bind(this)),
            (this.addedToCartObjectIDs = addedToCartObjectIDs.bind(this)),
            (this.purchasedObjectIDs = purchasedObjectIDs.bind(this)),
            (this.convertedFilters = convertedFilters.bind(this)),
            (this.viewedObjectIDs = viewedObjectIDs.bind(this)),
            (this.viewedFilters = viewedFilters.bind(this)),
            (this.getVersion = getVersion.bind(this));
        };
        var requestWithXMLHttpRequest = function (e, t) {
            return new Promise(function (r, n) {
              var s = JSON.stringify(t),
                i = new XMLHttpRequest();
              i.addEventListener("readystatechange", function () {
                4 === i.readyState && 200 === i.status
                  ? r(!0)
                  : 4 === i.readyState && r(!1);
              }),
                i.addEventListener("error", function () {
                  return n();
                }),
                i.addEventListener("timeout", function () {
                  return r(!1);
                }),
                i.open("POST", e),
                i.setRequestHeader("Content-Type", "application/json"),
                i.setRequestHeader("Content-Length", "" + s.length),
                i.send(s);
            });
          },
          requestWithSendBeacon = function (e, t) {
            var r = JSON.stringify(t);
            r = navigator.sendBeacon(e, r);
            return Promise.resolve(!!r || requestWithXMLHttpRequest(e, t));
          },
          requestWithNativeFetch = function (e, t) {
            return new Promise(function (r, n) {
              fetch(e, {
                method: "POST",
                body: JSON.stringify(t),
                headers: { "Content-Type": "application/json" },
              })
                .then(function (e) {
                  r(200 === e.status);
                })
                .catch(function (e) {
                  n(e);
                });
            });
          };
        function getRequesterForBrowser() {
          if (
            (function () {
              try {
                return Boolean(navigator.sendBeacon);
              } catch (e) {
                return !1;
              }
            })()
          )
            return requestWithSendBeacon;
          if (
            (function () {
              try {
                return Boolean(XMLHttpRequest);
              } catch (e) {
                return !1;
              }
            })()
          )
            return requestWithXMLHttpRequest;
          if (
            (function () {
              try {
                return void 0 !== fetch;
              } catch (e) {
                return !1;
              }
            })()
          )
            return requestWithNativeFetch;
          throw new Error(
            "Could not find a supported HTTP request client in this environment."
          );
        }
        var d = (function createInsightsClient(e) {
          var t;
          if (
            ((e = getFunctionalInterface(
              new AlgoliaAnalytics({ requestFn: e })
            )),
            "object" == typeof window && !window.AlgoliaAnalyticsObject)
          ) {
            for (; (t = createUUID()), void 0 !== window[t]; );
            (window.AlgoliaAnalyticsObject = t),
              (window[window.AlgoliaAnalyticsObject] = e);
          }
          return (e.version = r), e;
        })(getRequesterForBrowser());
        (t.AlgoliaAnalytics = AlgoliaAnalytics),
          (t.default = d),
          (t.getFunctionalInterface = getFunctionalInterface),
          (t.getRequesterForBrowser = getRequesterForBrowser),
          (t.processQueue = function processQueue(e) {
            var t,
              r = e.AlgoliaAnalyticsObject;
            r &&
              ((t = getFunctionalInterface(this)),
              ((e = e[r]).queue = e.queue || []),
              (r = e.queue).forEach(function (e) {
                var r = (e = [].slice.call(e))[0];
                e = e.slice(1);
                t.apply(void 0, [r].concat(e));
              }),
              (r.push = function (e) {
                var r = (e = [].slice.call(e))[0];
                e = e.slice(1);
                t.apply(void 0, [r].concat(e));
              }));
          });
      },
      424: (e, t, r) => {
        const n = r(879);
        (e.exports = n.default),
          Object.keys(n).forEach((t) => {
            "default" !== t && (e.exports[t] = n[t]);
          });
      },
    },
    t = {};
  function __webpack_require__(r) {
    var n = t[r];
    if (void 0 !== n) return n.exports;
    var s = (t[r] = { exports: {} });
    return e[r](s, s.exports, __webpack_require__), s.exports;
  }
  (__webpack_require__.n = (e) => {
    var t = e && e.__esModule ? () => e.default : () => e;
    return __webpack_require__.d(t, { a: t }), t;
  }),
    (__webpack_require__.d = (e, t) => {
      for (var r in t)
        __webpack_require__.o(t, r) &&
          !__webpack_require__.o(e, r) &&
          Object.defineProperty(e, r, { enumerable: !0, get: t[r] });
    }),
    (__webpack_require__.o = (e, t) =>
      Object.prototype.hasOwnProperty.call(e, t)),
    (__webpack_require__.r = (e) => {
      "undefined" != typeof Symbol &&
        Symbol.toStringTag &&
        Object.defineProperty(e, Symbol.toStringTag, { value: "Module" }),
        Object.defineProperty(e, "__esModule", { value: !0 });
    });
  var r = {};
  (() => {
    "use strict";
    __webpack_require__.r(r),
      __webpack_require__.d(r, {
        AccountRegisterEmailCapture: () => AccountRegisterEmailCapture,
        AlgoliaSearchHeader: () => AlgoliaSearchHeader,
        CartBeam: () => CartBeam,
        CartFooterMain: () => CartFooterMain,
        CartIconBanner: () => CartIconBanner,
        CartItems: () => CartItems,
        CartLineItem: () => CartLineItem,
        CartMessageBar: () => CartMessageBar,
        CountdownTimer: () => CountdownTimer,
        CountriesData: () => CountriesData_CountriesData,
        DomReadyPromise: () => DomReadyPromise_DomReadyPromise,
        DynamicImporter: () => DynamicImporter_DynamicImporter,
        DynamicUpsellAtc: () => DynamicUpsellAtc,
        EmailSubscribeV2: () => EmailSubscribeV2,
        ExitIntentObserver: () => ExitIntentObserver,
        GlobalCarousel: () => GlobalCarousel,
        /*GlobalCartProgressBar: () => GlobalCartProgressBar,
        GlobalCartProgressBarTiersProducer: () =>
          GlobalCartProgressBarTiersProducer,
        GlobalConditonalUpsellProducer: () =>
          GlobalConditonalUpsellProducer_GlobalConditonalUpsellProducer,
        GlobalCountySelector: () => GlobalCountySelector,*/
        GlobalHotspotItem: () => GlobalHotspotItem,
        GlobalHotspotTarget: () => GlobalHotspotTarget,
        GlobalProductCard: () => n.GlobalProductCard,
        GlobalQtySelector: () => GlobalQtySelector,
        GlobalSidebar: () => GlobalSidebar,
        GlobalVariantQtyHelper: () => GlobalVariantQtyHelper,
        ModalBox: () => ModalBox,
        NiceScroll: () => NiceScroll,
        SellingPlanSelector: () => SellingPlanSelector,
        SidebarCart: () => SidebarCart,
        SidebarCartLayout: () => SidebarCartLayout,
        SidebarCartSection: () => SidebarCartSection,
        SmsSubscribe: () => SmsSubscribe,
        SocialLogin: () => SocialLogin,
        TrapFocusLite: () => TrapFocusLite,
        customerPrivacyApi: () => customerPrivacyApi,
        klaviyoSubscribe: () => KlaviyoSubscribe_klaviyoSubscribe,
      });
    class TrapFocusLite {
      constructor(e) {
        (this.ObserverLite = new ObserverLite()),
          (this.element = e),
          this.element.addEventListener("keydown", (e) => {
            this.keyDownHandler(e);
          });
      }
      subscribe(e) {
        return this.ObserverLite.subscribe(e);
      }
      next(e) {
        this.ObserverLite.next(e);
      }
      setAttributes(e, t) {
        for (let r in t) e.setAttribute(r, t[r]);
      }
      removeAttributes(e, t) {
        t.forEach((t) => {
          e.removeAttribute(t);
        });
      }
      get focusables() {
        return this.element.querySelectorAll(
          'summary, [tabindex="0"], [role="button"], a[href]:not([disabled]), button:not([disabled]), textarea:not([disabled]), input[type="text"]:not([disabled]), input[type="radio"]:not([disabled]), input[type="checkbox"]:not([disabled]), select:not([disabled])'
        );
      }
      setFocus() {
        (this.lastFocusedElement = document.activeElement),
          this.focusables[0]?.focus();
      }
      resetFocus() {
        this.lastFocusedElement.focus();
      }
      keyDownHandler(e) {
        const t = this.focusables,
          r = t[0],
          n = t[t.length - 1];
        "Tab" === e.key || 9 === e.keyCode
          ? e.shiftKey
            ? document.activeElement === r && (e.preventDefault(), n.focus())
            : document.activeElement === n && (e.preventDefault(), r.focus())
          : this.next({ key: e.key });
      }
    }
    /*
    class GlobalSidebar extends HTMLElement {
      constructor() {
        super(),
          (this.hasMenuBeenInit = !1),
          (this.ObserverLite = new ObserverLite()),
          this.cartCloseBtnTimeout;
      }
      subscribe(e) {
        return this.ObserverLite.subscribe(e);
      }
      next(e) {
        this.ObserverLite.next(e);
      }
      connectedCallback() {
        if (
          ((this.containerRight = !!this.attributes.container_right),
          (this.buttonLeft = !!this.attributes.button_left),
          (this.renderedOnInit = !!this.attributes.rendered_on_Init),
          (this.observer_key =
            !!this.attributes.observer_key &&
            this.attributes.observer_key.value),
          this.renderedOnInit && this.initRender(),
          this.observer_key)
        ) {
          new ObserverLite({ key: this.observer_key }).next(this);
        }
      }
      toggle() {
        this.isOpen ? this.close() : this.open();
      }
      addWrapper() {
        (this.wrapper = this.querySelector(".modal-wrapper") || !1),
          this.wrapper &&
            ((this.mask = this.wrapper.querySelector(".modal-mask")),
            (this.contentWrapper =
              this.wrapper.querySelector(".modal-sidebar")),
            (this.closeButton =
              this.wrapper.querySelector(".modal-close-btn")));
      }
      initRender() {
        if ((this.addWrapper(), !this.wrapper)) {
          this.content =
            this.querySelector(":scope > template")?.content ||
            this.children[0];
          let e =
            '<div class="modal-wrapper">\n                         <div class="modal-mask modal-close"></div>\n                         <div class="modal-sidebar"></div>\n                       </div>';
          (e = parseHTML(e)),
            (this.wrapper = e.querySelector(".modal-wrapper")),
            (this.mask = e.querySelector(".modal-mask")),
            (this.contentWrapper = e.querySelector(".modal-sidebar")),
            this.contentWrapper.appendChild(this.content),
            this.appendChild(e);
        }
        this.next({ render: !0 }),
          this.isBound ||
            ((this.isBound = !0),
            this.containerRight &&
              ((this.contentWrapper.style.left = "auto"),
              (this.contentWrapper.style.right = "0px")),
            this.buttonLeft &&
              this.closeButton.classList.add("modal-close-btn--left"),
            this.wrapper.querySelectorAll(".modal-close").forEach((e) => {
              e.addEventListener("click", (e) => {
                e.preventDefault();
                const t = document.querySelector(
                    ".mh__icon-nav-item--mob-menu"
                  ),
                  r = document.querySelector(".js-cart-toggle");
                t &&
                  (document.body.classList.contains("mobile-menu") &&
                    (clearTimeout(this.cartCloseBtnTimeout),
                    (this.cartCloseBtnTimeout = setTimeout(() => {
                      document.body.classList.remove("mobile-menu");
                    }, 222))),
                  t.classList.remove("active"),
                  t.setAttribute("aria-expanded", "false")),
                  r && r.setAttribute("aria-expanded", "false"),
                  this.close();
              });
            }),
            (this.TrapFocusLite = new TrapFocusLite(this)),
            this.TrapFocusLite.subscribe(({ key: e }) => {
              "Escape" == e && this.close();
            })),
          (this.isInitRendered = !0);
      }
      open() {
        this.isInitRendered || this.initRender();
        const e = window.innerWidth - document.body.clientWidth;
        document.body.classList.add("body-masked"),
          (document.body.style.paddingRight = `${e}px`),
          (this.wrapper.style.display = "block"),
          (this.wrapper.animate(
            [{ opacity: 0 }, { opacity: 1 }],
            300
          ).onfinish = (e) => {
            e.target.effect.target.style.opacity = 1;
          });
        const t = this.containerRight ? "150px" : "-150px";
        this.contentWrapper.animate(
          [
            { transform: `translateX(${t})`, opacity: 0 },
            { transform: "translateX(0px)", opacity: 1 },
          ],
          200
        ).onfinish = (e) => {
          (e.target.effect.target.style.transform = "translateX(0px)"),
            (e.target.effect.target.style.opacity = 1),
            this.TrapFocusLite.setFocus(),
            this.TrapFocusLite.setAttributes(this, {
              role: "dialog",
              "aria-modal": "true",
              "aria-live": "assertive",
            }),
            this.TrapFocusLite.removeAttributes(this, ["aria-hidden"]),
            this.next({ open: !0 });
        };
      }
      close() {
        (this.wrapper.animate([{ opacity: 1 }, { opacity: 0 }], 200).onfinish =
          (e) => {
            (e.target.effect.target.style.opacity = 0),
              (e.target.effect.target.style.display = "none"),
              document.body.classList.remove("body-masked"),
              (document.body.style.paddingRight = "0px"),
              this.TrapFocusLite.resetFocus(),
              this.TrapFocusLite.removeAttributes(this, [
                "role",
                "aria-modal",
                "aria-live",
              ]),
              this.TrapFocusLite.setAttributes(this, { "aria-hidden": "true" }),
              this.next({ open: !1 });
          }),
          (this.contentWrapper.animate(
            [
              { transform: "scale(1)", opacity: 1 },
              { transform: "scale(1.2)", opacity: 0 },
            ],
            200
          ).onfinish = (e) => {
            e.target.effect.target.style.opacity = 0;
          });
      }
    }
    customElements.define("global-sidebar", GlobalSidebar);
    
    
    class GlobalQtySelector extends HTMLElement {
      constructor() {
        super(), (this.ObserverLite = new ObserverLite());
      }
      subscribe(e) {
        return this.ObserverLite.subscribe(e);
      }
      next(e) {
        this.ObserverLite.next(e);
      }
      connectedCallback() {
        DomReadyPromise()
          .then(() => {
            this.mounted || this.mount();
          })
          .catch((e) => {
            console.log(e);
          });
      }
      update(e) {
        const { input: t } = this,
          r = parseInt(t.value),
          n = r + 1,
          s = r - 1,
          i = t.min || 0,
          a = t.max || 1 / 0;
        "add" == e && n <= a && (t.value = n),
          "remove" == e && s >= i && (t.value = s),
          clearTimeout(this.timeoutId),
          (this.timeoutId = setTimeout(() => {
            this.next(), t.dispatchEvent(new Event("change"));
          }, 500));
      }
      mount() {
        if (((this.mounted = !0), !window.GlobalQtySelectorStylesInjected)) {
          const e =
            "\n        <style type=\"text/css\">\n          global-qty-selector{\n            --elementSize:40px;\n            display:flex;\n          }\n\n          .qty-selector-disabled{\n            opacity:0.2;\n            pointer-events:none;\n          }\n\n          .qty-selector__btn{\n            width:var(--elementSize);\n            height:var(--elementSize);\n            border:1px solid #666;\n            color:#000;\n            outline:none;\n            border-radius:5px;\n            transition: all .1s ease-in;\n            position:relative;\n          }\n\n          .qty-selector__btn:hover{\n            background:#000;\n            border-color:#000;\n            color:#fff;\n          }\n\n          .qty-selector__btn:after{\n            content:'+';\n            position:absolute;\n            top:50%;\n            left:50%;\n            transform:translate(-50%,-50%);\n            font-size:20px;\n          }\n          \n          .qty-selector__btn--dec:after{\n            content:'-';\n          }\n\n          input.qty-selector__input{\n            width:var(--elementSize);\n            height:var(--elementSize);\n            border:0px;\n            outline:0px;\n            pointer-events:none;\n            padding:2px;\n            margin:0;\n            text-align:center;\n          }\n        </style>\n      ";
          (window.GlobalQtySelectorStylesInjected = !0),
            document.body.append(parseHTML(e));
        }
        const e = parseHTML(
            '<button class="js-qty-selector__btn--inc btn-reset qty-selector__btn qty-selector__btn--inc" aria-label="Add Item" type="button"></button>'
          ),
          t = parseHTML(
            '<button class="js-qty-selector__btn--dec btn-reset qty-selector__btn qty-selector__btn--dec" aria-label="Remove Item" type="button"></button>'
          );
        this.prepend(t),
          this.append(e),
          (this.increase = this.querySelector(".js-qty-selector__btn--inc")),
          (this.decrease = this.querySelector(".js-qty-selector__btn--dec")),
          (this.input = this.querySelector("input")),
          this.input.classList.add("qty-selector__input", "reset-input"),
          this.input.setAttribute("readonly", !0),
          this.input.setAttribute("type", "text"),
          this.increase.addEventListener("click", () => {
            this.update("add");
          }),
          this.decrease.addEventListener("click", () => {
            this.update("remove");
          });
      }
    }
    customElements.define("global-qty-selector", GlobalQtySelector);
    class GlobalVariantQtyHelper {
      constructor(e) {
        (this.ObserverLite = new ObserverLite()), this.init(e);
      }
      async init(e) {
        (this.cart = await new GlobalCart()),
          this.updateSettings(e),
          this.cart.subscribe(() => {
            this.next();
          });
      }
      subscribe(e) {
        return this.ObserverLite.subscribe(e);
      }
      next(e) {
        this.ObserverLite.next(e);
      }
      updateSettings(e) {
        (this.settings = e), this.next();
      }
      getVariantData() {
        return new Promise(async (e, t) => {
          this.cart = this.cart || (await new GlobalCart());
          const r = this.cart
            .getLineItemsByVariantId(this.settings.variantId)
            .map(({ quantity: e }) => e)
            .reduce((e, t) => e + t, 0);
          e({
            stock: this.settings.variantInventoryQty,
            cart: r,
            remaining: this.settings.variantInventoryQty - r,
            managed: this.settings.variantInventoryManagement,
            data: this.settings.data,
          });
        });
      }
    }
    class GlobalCartProgressBarTiersProducer {
      constructor() {
        return new Promise(async (e, t) => {
          const r = new ObserverLite({
            key: "GlobalCartProgressBarTiersProducer$",
          });
          r.once().then((t) => {
            e(t);
          }),
            r.onceDone ||
              ((this.dynamic = []),
              (this.static = []),
              (this.ObserverLite = new ObserverLite()),
              r.next(this));
        });
      }
      subscribe(e) {
        return this.ObserverLite.subscribe(e);
      }
      next(e) {
        this.ObserverLite.next(e);
      }
    }
    class GlobalCartProgressBar extends HTMLElement {
      constructor() {
        super(),
          (this.ObserverLite = new ObserverLite()),
          (this.settings = {}),
          (this.tiers = !1);
      }
      subscribe(e) {
        return this.ObserverLite.subscribe(e);
      }
      next(e) {
        this.ObserverLite.next(e);
      }
      connectedCallback() {
        DomReadyPromise()
          .then(async () => {
            await this.mount();
            const e = this.attributes?.observer_key?.value || !1;
            if (e) {
              const t = new ObserverLite({ key: e });
              this.ObserverLite.subscribe((e) => {
                t.next(e);
              });
            }
            (this.tiersProducer =
              await new GlobalCartProgressBarTiersProducer()),
              (this.globalcart = this.globalcart || (await new GlobalCart())),
              this.tiersProducer.subscribe(() => {
                this.render();
              }),
              this.globalcart.subscribe(() => {
                this.render();
              }),
              this.render();
          })
          .catch((e) => {
            console.log(e);
          });
      }
      async getTiers() {
        let e = await Promise.all(this.tiersProducer.dynamic);
        return (
          (e = e.flat()), [...this.tiersProducer.static, ...e].filter((e) => e)
        );
      }
      set progressBarWidth(e) {
        this.style.setProperty("--progress-bar-width", e);
      }
      set progressItemWidth(e) {
        this.style.setProperty("--progress-bar-item-width", e);
      }
      mount() {
        return new Promise((e, t) => {
          if (window.GlobalCartProgressBarMounted) e();
          else {
            window.GlobalCartProgressBarMounted = !0;
            const t =
              '\n          <style type="text/css">\n            :host { \n              --progress-bar-width:0%;\n            }\n            :root{\n              --progress--color-primary: #000000;\n              --progress--color-secondary: #6e6e6e;\n            }\n            global-cart-progress-bar{\n              padding-top:Var(--gutter-unit);\n              padding-bottom:var(--gutter-unit);\n            }\n            global-cart-progress-bar[hidden="true"]{\n              display:none;\n            }\n            \n            .cart-progress-bar__bar{\n              width:100%;\n              height:24px;\n              position:relative;\n              background:#a1a1a1;\n              border-radius: 12px;\n              overflow:hidden;\n            }\n            \n            .cart-progress-bar--small .cart-progress-bar__bar{\n              height:20px;\n            }\n            .cart-progress-bar__bold{\n              font-family: ridley_groteskbold,sans-serif;\n            }\n            .cart-progress-bar__bar:after {\n              transition:width 1000ms ease-out;\n              content:\'\';\n              position:absolute;\n              background: url(https://cdn.medik8.com/f3b762a8-adbe-4f3f-8425-97b09363b2de/diagnol.png) repeat-x center top/contain,linear-gradient(270deg,var(--progress--color-primary) 0%,var(--progress--color-secondary) 35%,var(--progress--color-primary) 100%);\n              border-radius: 0 15.5px 15.5px 0;\n              height:100%;\n              width: var(--progress-bar-width);\n            }\n            \n            .cart-progress-bar__item{\n              padding:var(--gutter-unit-d3) 0 0 var(--gutter-unit-d2);\n              width:var(--progress-bar-item-width);\n              text-align:right;\n              font-family: ridley_groteskmedium,sans-serif;\n              font-size:var(--t-xs);\n            }\n            .cart-progress-bar__item[data-threshold="0"]{\n              text-align:left;\n            }\n            .cart-progress-bar__item:before{\n              width:24px;\n              height:24px;\n              top:0;\n              right:0;\n              position:absolute;\n              content:\'\';\n              border-radius:100%;\n              transform:translate(0%,-100%);\n              background-color:#fff;\n              background-position:center;\n              background-repeat:no-repeat;\n              background-size: 13px;\n              background-image: url(data:image/svg+xml;base64,PHN2ZyBoZWlnaHQ9IjUxMiIgdmlld0JveD0iMCAwIDMyIDMyIiB3aWR0aD0iNTEyIiB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciPg0KICAgIDxwYXRoIGZpbGw9IiNhMWExYTEiIGQ9Im0yNiAxNGgtM3YtNWE3IDcgMCAwIDAgLTE0IDB2NWgtM2EuOTk5NzQuOTk5NzQgMCAwIDAgLTEgMXYxNGEuOTk5NzQuOTk5NzQgMCAwIDAgMSAxaDIwYS45OTk3NC45OTk3NCAwIDAgMCAxLTF2LTE0YS45OTk3NC45OTk3NCAwIDAgMCAtMS0xem0tMTUtNWE1IDUgMCAwIDEgMTAgMHY1aC0xMHoiIC8+DQo8L3N2Zz4NCg==)\n            }\n            .cart-progress-bar__item[data-threshold="0"]:before{\n              right:auto;\n              left:0;\n            }\n            .cart-progress-bar--small .cart-progress-bar__item:before{\n              height:20px;\n              width:20px;\n              background-size: 11px;\n            }\n            .cart-progress-bar__item[data-active]:before{\n              background-color:#000;\n              background-size: 15px;\n              background-image: url(data:image/svg+xml;base64,DQo8c3ZnIGlkPSJhYjIxYjQ5NS0xNTUyLTRmYTEtOTFhMi1iNWZjYjMyM2Y0NTEiIGhlaWdodD0iNTEyIiB2aWV3Qm94PSIwIDAgNjQgNjQiIHdpZHRoPSI1MTIiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+PHBhdGggZmlsbD0iI2ZmZiIgZD0ibTIxLjYzMzUgNDcuMTg2NGMtMS44OTI3LTIuMTI2NC0zLjQyMTYtNC4yMDY0LTQuODk4NS02LjIyMDhhMzUuNDY3IDM1LjQ2NyAwIDAgMSAtMy40OTQzLTUuODQ0OGMtLjYxLTEuMjQ3NC0uODgtMi41MTA1LjQ0MTMtMy4zMjI2IDMuNzg2Ny0yLjMyNzEgNC41NjI3LS4xMDUxIDYuNjIwOSAyLjQ3MzEgMS4yMiAxLjUyNzcgMy4wMTkgNC4wNDY5IDQuMTQ2MiA1LjYzODYgMS4wNzY3IDEuNTIgMi4zODkzLTEuMjIzNCAyLjkxMzMtMS45OTc1IDEuODYyNC0yLjc1MTEgNi43MDI5LTkuNDg2MyA4LjcwMzItMTEuOTc1OSAxLjg5OS0yLjM2MzQgOC4wMjg1LTguOTg0NCA5LjE3MTEtMTAuMDM3NS45NzI2LS44OTY3IDMuMDI2MS0yLjg2MzUgNC40MDctMS43Nzg1IDEuNDUxMSAxLjE0IDIuMTYgMy4zMDcgMS4xNCA0LjcxNi0xLjc3NjQgMi40NTMtNC41NjY3IDQuNzg2NS02LjQ5NzQgNy4xMjIyLTMuOTA4MiA0LjcyOC03LjYwODMgOS44MjQ0LTExLjE2IDE0Ljg5ODgtMS4yMDY5IDEuNzI0NC0yLjkwMTQgNC42MTI1LTMuOTUzNCA2LjQ4MjYtMS45Njc5IDMuNDk4NS0zLjY5NjQgNC4xNjQzLTcuNTM5NC0uMTUzN3oiLz48L3N2Zz4=);\n            }\n            .cart-progress-bar--small .cart-progress-bar__item[data-active]:before{\n              background-size: 13px;\n            }\n            @media all and (max-width: 767px) {\n              .cart-progress-bar__bar{\n                height:16px;\n              }\n              .cart-progress-bar__item{\n                font-size:10px;\n              }\n              .cart-progress-bar__item:before{\n                width:16px;\n                height:16px;\n                background-size: 10px;\n              }\n              .cart-progress-bar__item[data-active]:before{\n                background-size: 11px;\n              }\n            }\n          </style>\n        ';
            document.body.append(parseHTML(t)), e();
          }
        });
      }
      async render() {
        this.globalcart = this.globalcart || (await new GlobalCart());
        let e = await this.getTiers();
        if (!e.length)
          return (
            (this.tiers = !1),
            this.setAttribute("hidden", !0),
            void this.next({ eventType: "ui:hidden" })
          );
        this.removeAttribute("hidden"), this.next({ eventType: "ui:show" });
        const t = (await this.globalcart.get_CartTotalMinusFreeGifts()) / 100,
          r = (await this.globalcart.get_CartTotalMinusFreeGifts(!0)) / 100,
          n = 100 - (r / t) * 100;
        e.forEach((e) => {
          (e.thresholdWithMultiplier = e.thresholdWithMultiplier
            ? parseFloat(e.thresholdWithMultiplier)
            : 0),
            (e.threshold = parseInt(e.threshold)),
            (e.amount = parseInt(e.amount) || 0);
        }),
          (e = e
            .sort((e, t) => e.threshold - t.threshold)
            .map(
              (n, s) => (
                e.slice(-1)[0].calcDiscountTotal
                  ? (n.active = r >= n.threshold)
                  : (n.active = t >= n.threshold),
                n
              )
            )
            .map((s, i) => {
              const a = e[i + 1] || !1,
                o = a?.thresholdWithMultiplier || a?.threshold || 0,
                c = e[i - 1],
                l = c?.thresholdWithMultiplier || c?.threshold || 0,
                d = s.thresholdWithMultiplier || s.threshold || 1,
                u = s.thresholdWithMultiplier ? t : r;
              (s.isLast = i == e.length - 1),
                (s.isFirst = 0 == i),
                (s.index = i),
                (s.amountUntilActive =
                  (n && n == s.amount) ||
                  !s.amount ||
                  e.slice(-1)[0].calcDiscountTotal
                    ? s.threshold - r
                    : s.threshold - t);
              let h =
                s.active || !c || c.active
                  ? s.active && (d >= 1 || a?.active)
                    ? 100
                    : s.active && 1 == d && !a?.active
                    ? ((o - (o - u)) / o) * 100
                    : ((u - l) / (d - l)) * 100
                  : 0;
              return (s.relativeWidth = h < 0 ? 0 : h > 100 ? 100 : h), s;
            }));
        const s = 100 / e.length;
        this.progressItemWidth = `${s}%`;
        const i = [...e].reverse().find(({ active: e }) => e) || !1,
          a = i ? (i.isLast ? i : e[i.index + 1]) : e[0];
        let o = (t / 100) * a.amount;
        o = o.toFixed(2);
        const c = this.globalcart.currency_symbol;
        let l =
          (a.isLast && a.isFirst && a.active) || i.isLast
            ? 0
            : a.amountUntilActive;
        l = l.toFixed(2);
        let d =
          (a.isLast && a.isFirst && a.active) || i.isLast
            ? a.progressBarMessages_active
            : a.progressBarMessages_pending;
        (d = d.replace(
          "{{ remaining }}",
          `<span class="cart-progress-bar__bold">${c}${l}</span>`
        )),
          (d = d.replace(
            "{{ saving }}",
            `<span class="cart-progress-bar__bold">${c}${o}</span>`
          )),
          (this.tiers = e),
          (this.innerHTML = `\n      <p class="tac">${d}</p>\n      <div class="flex row-wrap align-top justify-center">\n        <div class="cart-progress-bar__bar"></div>\n        ${this.tiers
            .map(
              (e) =>
                `\n            <div class="cart-progress-bar__item t-ucase block-rel lh-r" \n                 ${
                  e.active ? "data-active" : ""
                }\n                 data-threshold="${
                  e.threshold
                }">\n                 ${e.name}\n            </div>\n          `
            )
            .join("")}\n      </div>\n    `);
        const u = e
          .map(({ relativeWidth: e }) => (s / 100) * e)
          .reduce((e, t) => e + t, 0);
        setTimeout(() => {
          this.progressBarWidth = `${u}%`;
        }, 200);
      }
    }
    customElements.define("global-cart-progress-bar", GlobalCartProgressBar);
    class NiceScrollSlider {
      constructor({ slides: e, nicescroller: t }) {
        (this.nicescroller = t),
          (this.slides = e),
          (this.slides[0].dataset.nicescrollActive = !0),
          (this.activeIndex = 0);
      }
      goToNextSlide() {
        let e = this.activeIndex + 1;
        (e = e > this.slides.length - 2 ? 0 : e),
          (this.activeIndex = e),
          this.animate();
      }
      goToPrevSlide() {
        let e = this.activeIndex - 1;
        (e = e >= 0 ? e : this.slides.length - 1),
          (this.activeIndex = e),
          this.animate();
      }
      animate() {
        let e = !1;
        this.slides.forEach((t, r) => {
          (t.dataset.nicescrollActive = r == this.activeIndex),
            this.activeIndex == r && (e = t);
        });
        const t =
          this.nicescroller.getBoundingClientRect().x -
          e.getBoundingClientRect().x;
        this.nicescroller.scrollBy({ left: 0 - t, top: 0, behavior: "smooth" });
      }
    }
    class NiceScroll extends HTMLElement {
      constructor() {
        super(), (this.moving = !1);
      }
      connectedCallback() {
        DomReadyPromise().then(() => {
          if (!this.mounted) {
            this.id = Math.floor(999999999999999 * Math.random());
            const {
              slideTarget: e,
              showControls: t,
              hideScrollBar: r,
            } = this.attributes;
            (this.slideTarget = e?.value || !1),
              (this.showControls = !!t),
              (this.hideScrollBar = !!r),
              (this.mounted = !0),
              (this.style.userSelect = "none"),
              (this.resizeTimeout = `resizeTimeout_${this.id}`),
              this.mount(),
              this.build(),
              this.bind();
          }
        });
      }
      mount() {
        if (!window.NiceScrollMounted) {
          const e =
            '\n        <style type="text/css">\n\n          nice-scroll{\n            display:block;\n            max-width: 100%;\n          }\n\n          .nice-scroll--has-controls{\n            position:relative;\n          }\n\n          .nice-scroll--scrollbar-active{\n            padding-bottom: var(--gutter-unit);\n          }\n\n          .nice-scroll__content{\n            overflow-x: auto;\n            overflow-y:hidden;\n            display:block;\n            width:100%;\n            padding-bottom:16px;\n          }\n\n          .nice-scroll__content .arrow{\n            display:none;\n            top:calc(50% - 8px);\n            transform:translate(80%,-50%);\n          }\n\n          .nice-scroll__content .arrow--left{\n            transform:translate(-80%,-50%);\n          }\n\n          .nice-scroll__content label{\n            position: relative;\n          }\n\n          .nice-scroll__content label input{\n            width:100%;\n            height:100%;\n            top:0;\n            left:0;\n            margin:0;\n          }\n\n          .nice-scroll__content::-webkit-scrollbar {\n            width: 50%;\n            height:5px;\n          }\n\n          .nice-scroll__content::-webkit-scrollbar-track {\n            background: #eee;\n          }\n\n          .nice-scroll__content::-webkit-scrollbar-thumb {\n            background: #000;\n          }\n  \n          .nice-scroll__content::-webkit-scrollbar-thumb:hover {\n            background: #000;\n          }\n\n          .nice-scroll__content--no-scrollbar{\n            padding-bottom:0;\n          }\n\n          .nice-scroll__content--no-scrollbar::-webkit-scrollbar {\n            display:none;\n          }\n\n          .nice-scroll__content--no-scrollbar .arrow{\n            top:50%;\n          }\n\n        </style>\n      ';
          (window.NiceScrollMounted = !0), document.body.append(parseHTML(e));
        }
      }
      build() {
        (this.innerHTML = `\n      <div class="nice-scroll__content" data-nicescroll-content>\n        ${this.innerHTML}\n      </div>\n    `),
          (this.content = this.querySelector("[data-nicescroll-content]")),
          this.hideScrollBar &&
            this.content.classList.add("nice-scroll__content--no-scrollbar");
        const e = (this.slideTarget =
          this.querySelectorAll(this.slideTarget) ||
          this.querySelectorAll("[data-nicescroll-slide]"));
        e?.length &&
          this.showControls &&
          (this.classList.add("nice-scroll--has-controls"),
          this.content.append(
            parseHTML(
              '\n      <button class="arrow arrow--left"  data-nicescroll-slide-prev aria-label="Previous item"></button>\n      <button class="arrow arrow--right" data-nicescroll-slide-next aria-label="Next item"></button>\n      '
            )
          ),
          (this.controls = {
            prev: this.querySelector("[data-nicescroll-slide-prev]"),
            next: this.querySelector("[data-nicescroll-slide-next]"),
          }),
          (this.slider = new NiceScrollSlider({
            slides: e,
            nicescroller: this.content,
          })));
      }
      toggleControls() {
        clearTimeout(this.resizeTimeout),
          (this.resizeTimeout = setTimeout(() => {
            const { width: e } = this.content.getBoundingClientRect(),
              t = Math.floor(e) < this.content.scrollWidth;
            (this.controls.prev.style.display = t ? "block" : "none"),
              (this.controls.next.style.display = t ? "block" : "none"),
              this.hideScrollBar ||
                this.classList.toggle("nice-scroll--scrollbar-active", t);
          }, 500));
      }
      bind() {
        this.slider &&
          (this.controls.prev.addEventListener("click", (e) => {
            e.preventDefault(this.slider.goToPrevSlide());
          }),
          this.controls.next.addEventListener("click", (e) => {
            e.preventDefault(this.slider.goToNextSlide());
          }),
          new ResizeObserver((e) => {
            for (const t of e) t.contentBoxSize && this.toggleControls();
          }).observe(this.content));
        let e,
          t,
          r = !1;
        const resetCursorAndMouseDownState = () => {
          (r = !1), (this.content.style.cursor = "grab");
        };
        this.content.addEventListener("mousedown", (n) => {
          (r = !0),
            (this.content.style.cursor = "grabbing"),
            (e = n.pageX - this.content.offsetLeft),
            (t = this.content.scrollLeft);
        }),
          this.content.addEventListener(
            "mouseleave",
            resetCursorAndMouseDownState
          ),
          this.content.addEventListener(
            "mouseup",
            resetCursorAndMouseDownState
          ),
          this.addEventListener("mousemove", (n) => {
            if (!r) return;
            n.preventDefault();
            const s = 1 * (n.pageX - this.content.offsetLeft - e);
            this.content.scrollLeft = t - s;
          });
      }
    }
    customElements.define("nice-scroll", NiceScroll);
    */
    class ModalBox {
      constructor({ content: e, settings: t }) {
        window.ModalBoxInstance && window.ModalBoxInstance.close(),
          (window.ModalBoxInstance = this),
          (this.content = e),
          (this.settings = t || { containerCloseButton: !0 }),
          (this.ObserverLite = new ObserverLite());
      }
      subscribe(e) {
        return this.ObserverLite.subscribe(e);
      }
      next(e) {
        this.ObserverLite.next(e);
      }
      toggle() {
        this.active ? this.close() : this.open();
      }
      open() {
        return (
          (this.active = !0),
          this.next({ type: "open" }),
          new Promise((e, t) => {
            if (!this.wrapper) {
              let e = `<div class="modal-wrapper ${
                this.settings.wrapperClass ? this.settings.wrapperClass : ""
              }"\n                            style="${
                this.settings.wrapperStyles ? this.settings.wrapperStyles : ""
              }">\n                         <div class="modal-mask modal-close"></div>\n                         <div class="modal-flex ${
                this.settings.flexClass ? this.settings.flexClass : ""
              }">\n                           <div class="modal-content  \n                                       ${
                this.settings.contentClass
                  ? `${this.settings.contentClass}`
                  : ""
              }\n                                       ${
                this.settings.overlayClose ? "modal-close" : ""
              }">\n                              ${
                this.settings.containerCloseButton
                  ? '<button aria-label="close" class="modal-close modal-close-btn btn-reset"></button>'
                  : ""
              }\n                           </div>\n                         </div>\n                       </div>`;
              (e = parseHTML(e)),
                (this.wrapper = e.querySelector(".modal-wrapper")),
                (this.wrapper.style.opacity = 0),
                (this.mask = e.querySelector(".modal-mask")),
                (this.content = parseHTML(this.content)),
                (this.contentWrapper = e.querySelector(".modal-content")),
                (this.contentWrapper.style.opacity = 0),
                this.contentWrapper.appendChild(this.content),
                e.querySelectorAll(".modal-close").forEach((e) => {
                  e.addEventListener("click", (e) => {
                    e.preventDefault(), this.close();
                  });
                }),
                document.body.appendChild(e),
                (this.TrapFocusLite = new TrapFocusLite(this.wrapper)),
                this.TrapFocusLite.subscribe(({ key: e }) => {
                  "Escape" == e && this.close();
                });
            }
            window.innerWidth, document.body.clientWidth;
            document.body.classList.add("body-masked"),
              (this.wrapper.style.display = "block"),
              (this.wrapper.animate(
                [{ opacity: 0 }, { opacity: 1 }],
                300
              ).onfinish = (e) => {
                e.target.effect.target.style.opacity = 1;
              }),
              (this.contentWrapper.animate(
                [
                  { transform: "translateY(100px)", opacity: 0 },
                  { transform: "translateY(0px)", opacity: 1 },
                ],
                300
              ).onfinish = (t) => {
                (t.target.effect.target.style.transform = "translateY(0px)"),
                  (t.target.effect.target.style.opacity = 1),
                  this.TrapFocusLite.setFocus(),
                  this.TrapFocusLite.setAttributes(this.wrapper, {
                    role: "dialog",
                    "aria-modal": "true",
                    "aria-live": "assertive",
                  }),
                  this.TrapFocusLite.removeAttributes(this.wrapper, [
                    "aria-hidden",
                  ]),
                  this.next({ type: "open:rendered" }),
                  e();
              });
          })
        );
      }
      close() {
        (this.active = !1),
          this.next({ type: "close" }),
          (this.wrapper.animate(
            [{ opacity: 1 }, { opacity: 0 }],
            200
          ).onfinish = (e) => {
            (e.target.effect.target.style.opacity = 0),
              document.body.classList.remove("body-masked"),
              (document.body.style.paddingRight = "0px"),
              (this.wrapper.style.display = "none");
          }),
          (this.contentWrapper.animate(
            [
              { transform: "scale(1)", opacity: 1 },
              { transform: "scale(1.2)", opacity: 0 },
            ],
            200
          ).onfinish = (e) => {
            (e.target.effect.target.style.opacity = 0),
              this.TrapFocusLite.resetFocus(),
              this.TrapFocusLite.removeAttributes(this.wrapper, [
                "role",
                "aria-modal",
                "aria-live",
              ]),
              this.TrapFocusLite.setAttributes(this.wrapper, {
                "aria-hidden": "true",
              }),
              this.next({ type: "close:finish" });
          });
      }
      destroy() {
        this.wrapper.remove();
      }
    }
    class DynamicImporter_DynamicImporter {
      constructor(e) {
        if (window.DynamicImporterSingleton)
          return (
            (window.DynamicImporterSingleton.items =
              window.DynamicImporterSingleton.items.concat(
                e.filter((e) => !this.items?.find(({ url: t }) => e.url !== t))
              )),
            window.DynamicImporterSingleton
          );
        (this.observer = new ObserverLite()),
          (this.items = e),
          (window.DynamicImporterSingleton = this);
      }
      async loadScript(e) {
        if ("js" === e.type) {
          const t = e.url.split("//");
          (e.url = `https://${t[1]}`),
            (e.loading =
              e.loading ||
              new Promise((t, r) => {
                import(`${e.url}`)
                  .then((r) => {
                    (e.loaded = !0), t(r);
                  })
                  .catch((e) => {
                    console.log(e), r({ error: !0 });
                  });
              }));
        } else
          e.loading =
            e.loading ||
            new Promise((t) => {
              try {
                const r = document.createElement("link");
                (r.rel = "stylesheet"),
                  (r.href = e.url),
                  document.head.appendChild(r),
                  (r.onload = () => {
                    (e.loaded = !0), t(r);
                  });
              } catch (e) {
                console.log(e), reject({ error: !0 });
              }
            });
        return e.loading;
      }
      load() {
        return new Promise((e, t) => {
          const r = this.items
            .filter(({ loaded: e }) => !e)
            .map((e) => this.loadScript(e));
          Promise.all(r)
            .then((t) => {
              this.observer.next(), e({ results: t });
            })
            .catch((t) => {
              e({ error: !0 });
            });
        });
      }
    }
    function customerPrivacyApi() {
      const e = new ObserverLite({ key: "Shopify.customerPrivacyApi" });
      function initClarity() {
        "function" == typeof window.clarity && window.clarity("consent");
      }
      window.Shopify.loadFeatures(
        [{ name: "consent-tracking-api", version: "0.1" }],
        (t) => {
          t
            ? console.error(t)
            : (document.addEventListener("visitorConsentCollected", (t) => {
                t.detail.analyticsAllowed &&
                  (initClarity(), e.next({ analyticsAllowed: !0 }));
              }),
              window.Shopify.customerPrivacy.analyticsProcessingAllowed() &&
                (initClarity(), e.next({ analyticsAllowed: !0 })));
        }
      );
    }
    async function KlaviyoSubscribe_klaviyoSubscribe(e, t) {
      t = t || new FormData(e);
      const r = Object.fromEntries(t.entries());
      if (!r.email || !r.key || !r.list_id || r.hpf) return !1;
      try {
        return (
          202 ===
          (
            await fetch(
              `https://a.klaviyo.com/client/subscriptions/?company_id=${r.key}`,
              options(r)
            )
          ).status
        );
      } catch (e) {
        return !1;
      }
    }
    const options = (e) => ({
      method: "POST",
      headers: { revision: "2024-02-15", "content-type": "application/json" },
      body: JSON.stringify({
        data: {
          type: "subscription",
          attributes: {
            custom_source: `${e.source ?? "No source specified"}`,
            profile: {
              data: { type: "profile", attributes: { email: e.email } },
            },
          },
          relationships: { list: { data: { type: "list", id: e.list_id } } },
        },
      }),
    });
    class AccountRegisterEmailCapture extends HTMLElement {
      constructor() {
        super();
      }
      connectedCallback() {
        DomReadyPromise()
          .then(() => {
            const e = this.closest('form[action="/account"]'),
              t = this.attributes?.list_id?.value || !1,
              r = this.attributes?.key?.value || !1,
              n = e?.querySelector('input[type="email"]') || !1;
            e && t && r && n
              ? e.addEventListener(
                  "submit",
                  async (s) => {
                    if (
                      this.querySelector("#accepts_marketing")?.checked ||
                      !1
                    ) {
                      s.preventDefault(), s.stopPropagation();
                      const i = new FormData();
                      i.append("list_id", t),
                        i.append("key", r),
                        i.append("source", "Register Account"),
                        i.append("email", n.value),
                        await klaviyoSubscribe(!1, i),
                        e.submit();
                    }
                  },
                  !0
                )
              : this.remove();
          })
          .catch((e) => {
            console.log(e);
          });
      }
    }
    function DomReadyPromise_DomReadyPromise() {
      return new Promise(function (e, t) {
        "loading" !== document.readyState
          ? e()
          : addEventListener("DOMContentLoaded", () => {
              e();
            });
      });
    }
    function parseHTML_parseHTML(e) {
      const t = document.createElement("template");
      return (t.innerHTML = e), t.content;
    }
    customElements.define(
      "account-register-email-capture",
      AccountRegisterEmailCapture
    );
    var e = __webpack_require__(837);
    function KSnavigation(e) {
      let t, r, n, s;
      function markup(i) {
        !(function wrapperMarkup(r) {
          if (r) {
            for (var n = t.parentNode; t.firstChild; )
              n.insertBefore(t.firstChild, t);
            return void removeElement(t);
          }
          (t = createDiv("navigation-wrapper")),
            e.container.parentNode.appendChild(t),
            t.appendChild(e.container);
        })(i),
          (function dotMarkup(n) {
            if (n) return void removeElement(r);
            if (e.track.details && isFinite(e.track.details.maxIdx)) {
              r = createDiv("dots");
              [...Array(e.track.details.maxIdx + 1).keys()].forEach((t, n) => {
                var s = createDiv("dot");
                s.addEventListener("click", () => e.moveToIdx(n)),
                  r.appendChild(s);
              }),
                t.appendChild(r);
            }
          })(i),
          e.options.hideArrows ||
            (function arrowMarkup(r) {
              if (r) return removeElement(n), void removeElement(s);
              (n = createDiv("arrow arrow--left")),
                n.addEventListener("click", () => e.prev()),
                (s = createDiv("arrow arrow--right")),
                s.addEventListener("click", () => e.next()),
                t.appendChild(n),
                t.appendChild(s);
            })(i);
      }
      function removeElement(e) {
        e && e.parentNode?.removeChild(e);
      }
      function createDiv(e) {
        var t = document.createElement("div");
        return e.split(" ").forEach((e) => t.classList.add(e)), t;
      }
      function updateClasses() {
        if (!e || !e.track.details) return;
        const t =
          !!e.container.parentNode.classList.contains("navigation-wrapper") &&
          e.container.parentNode;
        if (t) {
          const r =
            !e.options.slides || e.slides.length <= e.options.slides.perView;
          t.classList.toggle("navigation-wrapper--no-padding", r);
        }
        var i = e.track.details.rel;
        r &&
          r.children.length &&
          (Array.from(r.children).forEach(function (e, t) {
            t === i
              ? e.classList.add("dot--active")
              : e.classList.remove("dot--active");
          }),
          (r.style.display =
            e.slides.length <= e.options.slides.perView ? "none" : "flex")),
          n &&
            s &&
            ((n.style.display =
              !e.options.slides || e.slides.length <= e.options.slides.perView
                ? "none"
                : "block"),
            (s.style.display =
              !e.options.slides || e.slides.length <= e.options.slides.perView
                ? "none"
                : "block"),
            0 === i
              ? n.classList.add("arrow--disabled")
              : n.classList.remove("arrow--disabled"),
            i === e.track.details.slides.length - 1
              ? s.classList.add("arrow--disabled")
              : s.classList.remove("arrow--disabled"));
      }
      e.on("created", () => {
        markup(), updateClasses(), e.update();
      }),
        e.on("update", () => {
          updateClasses();
        }),
        e.on("optionsChanged", () => {
          markup(!0), markup(), updateClasses();
        }),
        e.on("slideChanged", () => {
          updateClasses();
        }),
        e.on("destroyed", () => {
          markup(!0);
        });
    }
    /*
    class AlgoliaSearchHeader extends HTMLElement {
      constructor() {
        super(),
          (this.query = ""),
          (this.hasBeenOpened = !1),
          (this.maxProductsDisplay = 4),
          this.previousProductResults,
          (this._searchData = null),
          (this._linksData = null),
          (this._productData = null),
          (this.LinksMax = 6),
          this.cartCloseBtnTimeout;
      }
      async connectedCallback() {
        await DomReadyPromise_DomReadyPromise(),
          (this.agForm = this.querySelector("form")),
          (this.agFormInput = this.querySelector("form input")),
          (this.agProducts = this.querySelector(".ag-products")),
          (this.agLinks = this.querySelector(".ag-links")),
          (this.mask = document.querySelector(
            ".shopify-section.algolia .algolia-mask"
          ));
        const t = this.querySelector("template");
        t && ((this.config = JSON.parse(t.innerHTML)), t.remove()),
          this.initHeaderSearchIcon(),
          this.initCloseButton(),
          this.initMaskClose(),
          this.initForm(),
          (this.agSearch = await new e.AgSearchUtil({
            app_id: this.config.agConfig.appId,
            search_api_key: this.config.agConfig.publicApi,
          })),
          (this.agSearchInsightsUtil = new e.AgSearchInsightsUtil({
            app_id: this.config.agConfig.appId,
            search_api_key: this.config.agConfig.publicApi,
          }));
      }
      attributeChangedCallback(e, t, r) {
        "query" === e && r !== t && ((this.query = r), this.performSearch(r));
      }
      static get observedAttributes() {
        return ["query"];
      }
      get searchData() {
        return this._searchData;
      }
      set searchData(e) {
        (this._searchData = e),
          this.buildLinksData(),
          this.arrayCompare(
            this.previousProductResults.map((e) => e.sku),
            this.searchData.products.hits.map((e) => e.sku)
          ) || this.buildProductData();
      }
      get linksData() {
        return this._linksData;
      }
      set linksData(e) {
        (this._linksData = e), this.renderLinks();
      }
      get productData() {
        return this._productData;
      }
      set productData(e) {
        (this._productData = e), this.renderProducts();
      }
      initForm() {
        this.agFormInput.addEventListener(
          "keyup",
          (function debounce(e, t) {
            let r;
            return function (...n) {
              clearTimeout(r),
                (r = setTimeout(() => {
                  e(...n);
                }, t));
            };
          })((e) => {
            this.setAttribute("query", e.target.value);
          }, this.config.agConfig.debounce)
        );
      }
      initHeaderSearchIcon() {
        const e = document.getElementById("header-search-icon"),
          t = document.querySelector(".js-sidebar-mobile__toggle"),
          r = document.querySelector(".js-cart-toggle.mh__icon-nav-item");
        e.addEventListener("click", () => {
          t
            ? t.classList.contains("active")
              ? (t.setAttribute("aria-expanded", "false"),
                t.classList.remove("active"),
                window.globalJsSidebarNavWrapper.close(),
                clearTimeout(this.cartCloseBtnTimeout),
                (this.cartCloseBtnTimeout = setTimeout(() => {
                  document.body.classList.remove("mobile-menu"),
                    this.classList.contains("hide")
                      ? this.openSearch()
                      : this.closeSearch();
                }, 250)))
              : this.classList.contains("hide")
              ? this.openSearch()
              : this.closeSearch()
            : r
            ? (r.setAttribute("aria-expanded", "false"),
              this.classList.contains("hide")
                ? this.openSearch()
                : this.closeSearch())
            : this.classList.contains("hide")
            ? this.openSearch()
            : this.closeSearch();
        });
      }
      initCloseButton() {
        document
          .getElementById("algoliaSearchClose")
          .addEventListener("click", () => this.closeSearch());
      }
      initMaskClose() {
        this.mask.addEventListener("click", () => this.closeSearch());
      }
      buildLinksData() {
        this.agLinks.innerHTML = "";
        const e = [];
        (this.linksCount = 0),
          Object.keys(this.config.agConfig.indices).forEach((t) => {
            if ("products" == t) return;
            let r = {};
            this.searchData[t]?.hits.forEach((e) => {
              this.linksCount += 1;
              let n = "articles" == t ? `${e.blog.handle}/` : "";
              const s = "articles" === t ? "blogs" : t;
              r[e.title] = {
                title: e.title,
                url: `/${s}/${n}${e.handle}`,
                objectID: e.objectID,
                agSearchIndexName: e.agSearchIndexName,
              };
            }),
              e.push({ [t]: r });
          });
        const t = this.mergeResults(e, ["pages", "articles"], "content");
        this.updateTitles(t),
          (this.linksData = this.linksCount ? t : this.config.defaultLinks);
      }
      buildProductData() {
        this.productData = this.searchData.products.hits;
      }
      renderLinks() {
        const e = this.query && this.linksCount ? this.LinksMax : 10,
          t = this.linksData
            .map((t) => {
              const [r, n] = Object.entries(t)[0],
                s = Object.entries(n)
                  .slice(0, e)
                  .map((e) => {
                    if ("string" == typeof e[1]) {
                      const [t, r] = e;
                      return `\n                <li class="t-xs lh-rm ticklist ls-10">\n                  <a href="${r}" >\n                    ${t}\n                  </a>\n                </li>\n              `;
                    }
                    {
                      const {
                        title: t,
                        url: r,
                        objectID: n,
                        agSearchIndexName: s,
                      } = e[1];
                      return `\n                  <li class="t-xs lh-rm ticklist ls-10">\n                    <a href="${r}" \n                       data-ag_index="${s}"\n                       data-ag_object_id="${n}"\n                      >\n                      ${t}\n                    </a>\n                  </li>\n                `;
                    }
                  })
                  .join("");
              return s
                ? `<div class="ag-links__wrapper"><h2 class="t-s f-w600 lh-r t-ucase ls-12">${r}</h2><ul>${s}</ul></div>`
                : null;
            })
            .join("");
        (this.agLinks.innerHTML = t),
          this.agLinks.querySelectorAll("a[data-ag_index]").forEach((e) => {
            e.addEventListener("click", (t) => {
              const { ag_index: r, ag_object_id: n } = e.dataset;
              this.agSearchInsightsUtil.sendItemClickEvent({
                index: r,
                objectIDs: [n],
              });
            });
          });
      }
      renderProducts() {
        this.renderResultsTitle();
        const e = parseHTML_parseHTML(
          `<ul class="ag-products-slider flex ticklist">${(this.productData
            .length
            ? this.productData.slice(0, this.maxProductsDisplay)
            : this.defaultProducts
          )
            .map((e) => {
              const t = e.image,
                r =
                  e.variant_title &&
                  "Default Title" !== e.variant_title &&
                  !e.option_names.includes("size")
                    ? e.variant_title
                    : e.title,
                n = e.meta?.sf_product_hero?.sub_heading || "",
                s = (e.price, e.objectID ? `?variant=${e.objectID}` : ""),
                i = `/products/${e.handle}${s}`,
                a = e.meta?.custom?.badge || null,
                o = a
                  ? `<span class="badge-v2 badge-v2__product-card">${a}</span>`
                  : "";
              return `<li class="product-card keen-slider__slide">\n          <div>\n          <a href="${i}"\n             class="block-rel d-block"\n             data-ag_index="${e.agSearchIndexName}"\n             data-ag_object_id="${e.objectID}">\n            <img src="${t}"\n              alt="${r}"\n              width="400"\n              height="400"\n              class="product-card__image d-block row--d2">\n            ${o}\n          </a>\n          <a href="${i}" class="product-card__title d-block row--d2 t-xs lh-m f-w600 t-ucase tac ls-12">${r}</a>\n          <div class="product-card__description d-block row--d2 t-xxxs f-w400 lh-r tac ls-10">${n}</div>\n          </div>\n        </li>`;
            })
            .join("")}</ul>`
        );
        this.agProducts.querySelector(".ag-products-slider")?.remove(),
          this.agProducts.appendChild(e),
          this.buildKeenSlider(),
          this.agProducts.querySelectorAll("a[data-ag_index]").forEach((e) => {
            e.addEventListener("click", (t) => {
              const { ag_index: r, ag_object_id: n } = e.dataset;
              this.agSearchInsightsUtil.sendItemClickEvent({
                index: r,
                objectIDs: [n],
              });
            });
          });
      }
      renderResultsTitle() {
        const e = {
            noQuery: this.config.translations.results_no_search,
            hasData: this.config.translations.results_true,
            noData: this.config.translations.results_false,
          }[
            this.query
              ? this.productData.length
                ? "hasData"
                : "noData"
              : "noQuery"
          ],
          t =
            this.query && this.productData.length
              ? this.config.translations.view_all
              : this.config.translations.shop_all,
          r = parseHTML_parseHTML(
            `<div class="results-title flex justify-space row--d2">\n          <span class="t-rm f-w600 ls-10">${e}</span>\n          <a href="${
              this.query && this.productData.length
                ? `/search?q=${this.query}&view=ag`
                : this.config.settings.shop_all_url
            }" class="t-xxs f-w600 t-ucase t-ul flex align-center ls-12">${t}</a>\n        </div>`
          );
        this.agProducts.querySelector(".results-title")?.remove(),
          this.agProducts.appendChild(r);
      }
      buildKeenSlider() {
        this.resultSlider?.destroy(),
          this.waitForKeenSlider().then(() => {
            this.resultSlider = new KeenSlider(
              ".ag-products-slider",
              {
                loop: !1,
                slides: { perView: 2, spacing: 12 },
                breakpoints: {
                  "(min-width: 768px)": { slides: { perView: 3, spacing: 12 } },
                  "(min-width: 1024px)": { slides: { perView: 4 } },
                },
                created: () => {
                  this.classList.contains("hide") ||
                    setTimeout(() => {
                      this.adjustHeights(".ag-products .product-card__title");
                    }, 50);
                },
              },
              [KSnavigation]
            );
          });
      }
      openSearch() {
        this.hasBeenOpened ||
          ((this.hasBeenOpened = !0),
          (this.linksData = this.config.defaultLinks)),
          this.setAttribute("query", this.query),
          document.body.classList.add("search-open"),
          this.mask.classList.remove("hide"),
          this.classList.remove("hide"),
          this.buildKeenSlider(),
          this.agFormInput.focus();
      }
      closeSearch() {
        document.body.classList.remove("search-open"),
          this.mask.classList.add("hide"),
          this.classList.add("hide");
      }
      async performSearch(e) {
        const t = this.config.agConfig;
        this.previousProductResults = this.searchData?.products?.hits ?? [];
        const r = await this.agSearch.search({
          query: e || "empty",
          indexes: Object.keys(t.indices).reduce(
            (e, r) => (
              this.config.agConfig.indices[r] &&
                e.push({ indexName: `${t.prefix}${r}`, key: r }),
              e
            ),
            []
          ),
        });
        e || (this.defaultProducts = r.products.hits), (this.searchData = r);
      }
      adjustHeights(e) {
        const t = this.querySelectorAll(e),
          r = Array.from(t).reduce((e, t) => Math.max(e, t.offsetHeight), 0);
        t.forEach((e) => (e.style.height = `${r}px`));
      }
      async waitForKeenSlider() {
        return new Promise((e, t) => {
          const pingKS = () => {
            "undefined" != typeof KeenSlider ? e() : setTimeout(pingKS, 100);
          };
          pingKS();
        });
      }
      getVisibleHeight(e) {
        const t = e.getBoundingClientRect(),
          r = window.innerHeight;
        if (t.bottom < 0 || t.top > r) return 0;
        {
          const e = Math.max(t.top, 0);
          return Math.min(t.bottom, r) - e;
        }
      }
      arrayCompare(e, t) {
        return e.length === t.length && e.every((e, r) => e === t[r]);
      }
      mergeResults(e, t, r) {
        const n = e.reduce(
            (e, r) => (
              t.forEach((t) => {
                r[t] && (e = { ...e, ...r[t] });
              }),
              e
            ),
            {}
          ),
          s = e.filter((e) => !t.some((t) => t in e));
        return s.push({ [r]: n }), s;
      }
      updateTitles(e) {
        e.forEach((e) => {
          const t = Object.keys(e)[0];
          Object.entries(this.config.settings.titles).forEach(([r, n]) => {
            if (r === Object.keys(e)[0]) {
              const r = e[t];
              (e[n] = r), delete e[t];
            }
          });
        });
      }
    }
    customElements.define("algolia-search-header", AlgoliaSearchHeader);
    */
    class GlobalConditonalUpsellProducer_GlobalConditonalUpsellProducer {
      constructor(e) {
        if (
          ((this.singleton$ = new ObserverLite({
            key: "GlobalConditonalUpsellProducer$",
          })),
          !e)
        )
          return new Promise(async (e, t) => {
            e(await this.singleton$.once());
          });
        this.init(e);
      }
      subscribe(e) {
        return this.ObserverLite.subscribe(e);
      }
      next(e) {
        this.ObserverLite.next(e);
      }
      async init(e) {
        (this.ObserverLite = new ObserverLite()),
          (this.GlobalCart = await new GlobalCart()),
          (this.customer = e.customer),
          (this.offers = e.offers
            .map((e) => {
              (e.ObserverLite = new ObserverLite({
                key: `ConditionalUpsell.${e.id}`,
              })),
                (e.upsells = e.upsells || []),
                (e.removeOnInvalid = !0);
              const t = {
                upsell: !0,
                offer_id: e.id,
                min_spend: e.logic_minimum_spend,
                variant_ids: e.logic_cart_content_variant_ids,
                variant_excluding_ids:
                  e.logic_cart_content_variants_excluding_ids,
                samples_use_global_max: 1 == e.samples_use_global_max,
                max_items: e.max_items || !1,
                logic_allow_reorder: e.logic_allow_reorder,
                validation_error_message: e.validation_error_message,
                key: e.key,
                customer: {
                  required: {
                    tags: e.logic_customer_tags,
                    customer_order_history_variants:
                      e.logic_customer_order_history_variants,
                    new_customer_only: e.logic_new_customers_only,
                    logic_allow_reorder: e.logic_allow_reorder,
                  },
                  current: !!this.customer && {
                    email: this.customer.email,
                    upsell_offer_id_history:
                      this.customer.upsell_offer_id_history?.offerIds || [],
                    variant_id_history: this.customer.variant_id_history || [],
                  },
                },
              };
              return (
                (e.validation = t),
                (e.upsells = e.upsells.map((e) => ((e.validation = t), e))),
                (e.order = e.order || 9999999),
                !!e.upsells.length && e
              );
            })
            .filter((e) => e)
            .sort((e, t) => e.order - t.order)),
          this.singleton$.next(this),
          this.updateOffers(),
          this.GlobalCart.subscribe(() => {
            this.updateOffers();
          });
      }
      removeInvalidOFfersFromCart() {
        const e = this.offers
          .filter(
            ({ isValid: e, itemsInCart: t, removeOnInvalid: r }) =>
              !e && t.length && r
          )
          .map((e) => e.itemsInCart)
          .flat(1)
          .map(({ key: e }) => ({ key: e, quantity: 0 }));
        e.length && this.GlobalCart.updateQty(null, null, e);
      }
      getValidOffers() {
        return this.offers.filter(({ isValid: e }) => e);
      }
      updateOffers() {
        (this.offers = this.offers.map((e) => {
          const { validation: t } = e,
            r = [];
          let n = !(
            t.min_spend &&
            this.cartTotalMinusBlockItems(t.offer_id) < t.min_spend
          );
          r.push(n);
          let s = !0;
          const i = t.variant_ids || [];
          (s = !i.length || this.cartHasVariants(i)?.length), r.push(s);
          let a = !0;
          const o = t.variant_excluding_ids || [];
          (a = !o.length || !this.cartHasVariants(o)?.length), r.push(a);
          const { customer: c } = t;
          let l = !0;
          const d = c.required.tags?.split(" OR ") || [];
          l = !d.length || this.customerHasTags(d)?.length;
          const u = c.required?.new_customer_only;
          if (
            (u && c.current?.orders_count >= 1 && (l = !1),
            c.required.customer_order_history_variants?.length)
          )
            if (c.current) {
              let e = !1;
              for (let t of c.required.customer_order_history_variants)
                if (c.current.variant_id_history.some((e) => e == t)) {
                  e = !0;
                  break;
                }
              l = e;
            } else l = !1;
          if (!c.required.logic_allow_reorder) {
            const e = c.current?.upsell_offer_id_history;
            e && e.some((e) => e == t.offer_id) && (l = !1);
          }
          return (
            r.push(l),
            (e.isValid = r.filter((e) => e).length == r.length),
            (e.itemsInCart = this.GlobalCart.cart.items
              .map((t) => {
                const { variant_id: r, properties: n } = t;
                let { _upsell_validation: s } = n;
                return (
                  s && (s = JSON.parse(s)),
                  s?.offer_id == e.id && { key: t.key, variant_id: r }
                );
              })
              .filter((e) => e)),
            (e.maxItemsReached =
              e.max_items && e.itemsInCart.length == e.max_items),
            (e.upsells = e.upsells.map(
              (t) => (
                (t.addedToBag =
                  e.itemsInCart?.find(({ variant_id: e }) => e == t.id) || !1),
                t
              )
            )),
            e.ObserverLite.next(),
            e
          );
        })),
          this.removeInvalidOFfersFromCart();
      }
      cartHasVariants(e) {
        return e
          .map((e) => this.GlobalCart.cart.items.find((t) => t.variant_id == e))
          .filter((e) => e);
      }
      customerHasTags(e) {
        const t = this.customer;
        if (!t?.id || !t?.tags) return !1;
        return e.map((e) => !!t.tags.find((t) => t == e)).filter((e) => e);
      }
      cartTotalMinusBlockItems(e) {
        const t = this.GlobalCart.cart.items
          .filter(({ properties: t }) => {
            if (!t._upsell_validation) return !1;
            const r = JSON.parse(t._upsell_validation);
            return r?.offer_id == e;
          })
          .map(({ final_price: e }) => e)
          .reduce((e, t) => e + t, 0);
        return (this.GlobalCart.cart.total_price - t) / 100;
      }
    }
    class ExitIntentObserver {
      constructor() {
        (this.ObserverLite = new ObserverLite()),
          (this.startTime = Date.now()),
          (this.leaveCount = 0),
          this.init();
      }
      subscribe(e) {
        return this.ObserverLite.subscribe(e);
      }
      next(e) {
        this.ObserverLite.next(e);
      }
      init() {
        (this.startTime = Date.now()), (this.leaveCount = 0);
        const e = ((e, t) => {
          let r;
          return (...n) => {
            clearTimeout(r), (r = setTimeout(() => e(...n), t));
          };
        })(() => {
          const e = (Date.now() - this.startTime) / 1e3;
          this.leaveCount++;
          const t = { time: e, count: this.leaveCount };
          this.next(t);
        }, 100);
        window.addEventListener("mouseout", (t) => {
          null === t.relatedTarget && e();
        });
      }
    }
    class DynamicUpsellAtc extends HTMLElement {
      constructor() {
        super(), (this.ObserverLite = new ObserverLite());
      }
      get offer() {
        return this.upsellProducer.offers.find(
          ({ id: e }) => e == this.settings.offer_id
        );
      }
      get item() {
        return this.offer.upsells.find(
          ({ id: e }) => e == this.settings.item_id
        );
      }
      get state() {
        return this.item?.addedToBag
          ? "remove"
          : this.error ||
            !this.offer?.isValid ||
            (this.offer?.isValid && this.offer?.maxItemsReached)
          ? "disabled"
          : "add";
      }
      subscribe(e) {
        return this.ObserverLite.subscribe(e);
      }
      next(e) {
        this.ObserverLite.next(e);
      }
      connectedCallback() {
        DomReadyPromise()
          .then(async () => {
            this.settings = { translations: { add: "Add", remove: "Remove" } };
            const e = this.querySelector(":scope > template");
            if (e)
              try {
                (this.settings = {
                  ...this.settings,
                  ...JSON.parse(e.innerHTML),
                }),
                  e.remove();
              } catch (e) {
                return void this.update("disabled");
              }
            (this.upsellProducer = await new GlobalConditonalUpsellProducer()),
              (this.GlobalCart = await new GlobalCart()),
              this.offer.ObserverLite.subscribe(() => {
                this.update();
              }),
              this.update(),
              this.bind();
          })
          .catch((e) => {
            console.log(e);
          });
      }
      bind() {
        this.addEventListener("click", (e) => {
          "add" == this.state &&
            ((this.attributes.disabled = !0),
            this.GlobalCart.addToCart({
              items: [
                {
                  id: this.item.id,
                  quantity: 1,
                  properties: {
                    _upsell_validation: JSON.stringify(this.item.validation),
                  },
                },
              ],
            })
              .then(() => {
                (this.attributes.disabled = !1), this.next();
              })
              .catch((e) => {
                this.next(e);
              })),
            "remove" == this.state &&
              ((this.attributes.disabled = !0),
              this.GlobalCart.updateQty(!1, !1, [
                { key: this.item.addedToBag.key, qty: 0 },
              ])
                .then(() => {
                  (this.attributes.disabled = !1), this.next();
                })
                .catch((e) => {
                  this.next(e);
                }));
        });
      }
      update(e) {
        if (((e = e || this.state), !this.settings?.translations)) return;
        const { add: t, remove: r } = this.settings.translations,
          n = "remove" == e ? r : t;
        this.innerHTML = `\n      <button class="${
          this.settings.class
        }" type="button" ${
          "disabled" == e ? "disabled" : ""
        }>${n}</button>\n    `;
      }
    }
    function isNumber(e) {
      return "number" == typeof e;
    }
    function isString(e) {
      return "string" == typeof e;
    }
    function isBoolean(e) {
      return "boolean" == typeof e;
    }
    function isObject(e) {
      return "[object Object]" === Object.prototype.toString.call(e);
    }
    function mathAbs(e) {
      return Math.abs(e);
    }
    function mathSign(e) {
      return Math.sign(e);
    }
    function deltaAbs(e, t) {
      return mathAbs(e - t);
    }
    function arrayKeys(e) {
      return objectKeys(e).map(Number);
    }
    function arrayLast(e) {
      return e[arrayLastIndex(e)];
    }
    function arrayLastIndex(e) {
      return Math.max(0, e.length - 1);
    }
    function arrayIsLastIndex(e, t) {
      return t === arrayLastIndex(e);
    }
    function arrayFromNumber(e, t = 0) {
      return Array.from(Array(e), (e, r) => t + r);
    }
    function objectKeys(e) {
      return Object.keys(e);
    }
    function objectsMergeDeep(e, t) {
      return [e, t].reduce(
        (e, t) => (
          objectKeys(t).forEach((r) => {
            const n = e[r],
              s = t[r],
              i = isObject(n) && isObject(s);
            e[r] = i ? objectsMergeDeep(n, s) : s;
          }),
          e
        ),
        {}
      );
    }
    function isMouseEvent(e, t) {
      return void 0 !== t.MouseEvent && e instanceof t.MouseEvent;
    }
    function EventStore() {
      let e = [];
      const t = {
        add: function add(r, n, s, i = { passive: !0 }) {
          let a;
          if ("addEventListener" in r)
            r.addEventListener(n, s, i),
              (a = () => r.removeEventListener(n, s, i));
          else {
            const e = r;
            e.addListener(s), (a = () => e.removeListener(s));
          }
          return e.push(a), t;
        },
        clear: function clear() {
          e = e.filter((e) => e());
        },
      };
      return t;
    }
    function Animations(e, t, r, n) {
      const s = EventStore(),
        i = 1e3 / 60;
      let a = null,
        o = 0,
        c = 0;
      function animate(e) {
        if (!c) return;
        a || (a = e);
        const s = e - a;
        for (a = e, o += s; o >= i; ) r(i), (o -= i);
        n(o / i), c && t.requestAnimationFrame(animate);
      }
      function stop() {
        t.cancelAnimationFrame(c), (a = null), (o = 0), (c = 0);
      }
      return {
        init: function init() {
          s.add(e, "visibilitychange", () => {
            e.hidden &&
              (function reset() {
                (a = null), (o = 0);
              })();
          });
        },
        destroy: function destroy() {
          stop(), s.clear();
        },
        start: function start() {
          c || (c = t.requestAnimationFrame(animate));
        },
        stop,
        update: () => r(i),
        render: n,
      };
    }
    function Limit(e = 0, t = 0) {
      const r = mathAbs(e - t);
      function reachedMin(t) {
        return t < e;
      }
      function reachedMax(e) {
        return e > t;
      }
      function reachedAny(e) {
        return reachedMin(e) || reachedMax(e);
      }
      return {
        length: r,
        max: t,
        min: e,
        constrain: function constrain(r) {
          return reachedAny(r) ? (reachedMin(r) ? e : t) : r;
        },
        reachedAny,
        reachedMax,
        reachedMin,
        removeOffset: function removeOffset(e) {
          return r ? e - r * Math.ceil((e - t) / r) : e;
        },
      };
    }
    function Counter(e, t, r) {
      const { constrain: n } = Limit(0, e),
        s = e + 1;
      let i = withinLimit(t);
      function withinLimit(e) {
        return r ? mathAbs((s + e) % s) : n(e);
      }
      function get() {
        return i;
      }
      function clone() {
        return Counter(e, get(), r);
      }
      const a = {
        get,
        set: function set(e) {
          return (i = withinLimit(e)), a;
        },
        add: function add(e) {
          return clone().set(get() + e);
        },
        clone,
      };
      return a;
    }
    function DragHandler(
      e,
      t,
      r,
      n,
      s,
      i,
      a,
      o,
      c,
      l,
      d,
      u,
      h,
      p,
      m,
      g,
      b,
      f,
      v
    ) {
      const { cross: w, direction: _ } = e,
        S = ["INPUT", "SELECT", "TEXTAREA"],
        k = { passive: !1 },
        T = EventStore(),
        C = EventStore(),
        L = Limit(50, 225).constrain(p.measure(20)),
        P = { mouse: 300, touch: 400 },
        E = { mouse: 500, touch: 600 },
        I = m ? 43 : 25;
      let q = !1,
        D = 0,
        O = 0,
        A = !1,
        M = !1,
        N = !1,
        j = !1;
      function move(e) {
        if (!isMouseEvent(e, n) && e.touches.length >= 2) return up(e);
        const t = i.readPoint(e),
          r = i.readPoint(e, w),
          a = deltaAbs(t, D),
          c = deltaAbs(r, O);
        if (!M && !j) {
          if (!e.cancelable) return up(e);
          if (((M = a > c), !M)) return up(e);
        }
        const d = i.pointerMove(e);
        a > g && (N = !0),
          l.useFriction(0.3).useDuration(0.75),
          o.start(),
          s.add(_(d)),
          e.preventDefault();
      }
      function up(e) {
        const t = d.byDistance(0, !1).index !== u.get(),
          r =
            i.pointerUp(e) *
            (function forceBoost() {
              return (m ? E : P)[j ? "mouse" : "touch"];
            })(),
          n = (function allowedForce(e, t) {
            const r = u.add(-1 * mathSign(e)),
              n = d.byDistance(e, !m).distance;
            return m || mathAbs(e) < L
              ? n
              : b && t
              ? 0.5 * n
              : d.byIndex(r.get(), 0).distance;
          })(_(r), t),
          s = (function factorAbs(e, t) {
            if (0 === e || 0 === t) return 0;
            if (mathAbs(e) <= mathAbs(t)) return 0;
            const r = deltaAbs(mathAbs(e), mathAbs(t));
            return mathAbs(r / e);
          })(r, n),
          a = I - 10 * s,
          o = f + s / 50;
        (M = !1),
          (A = !1),
          C.clear(),
          l.useDuration(a).useFriction(o),
          c.distance(n, !m),
          (j = !1),
          h.emit("pointerUp");
      }
      function click(e) {
        N && (e.stopPropagation(), e.preventDefault(), (N = !1));
      }
      return {
        init: function init(e) {
          if (!v) return;
          function downIfAllowed(o) {
            (isBoolean(v) || v(e, o)) &&
              (function down(e) {
                const o = isMouseEvent(e, n);
                if (
                  ((j = o),
                  (N = m && o && !e.buttons && q),
                  (q = deltaAbs(s.get(), a.get()) >= 2),
                  o && 0 !== e.button)
                )
                  return;
                if (
                  (function isFocusNode(e) {
                    const t = e.nodeName || "";
                    return S.includes(t);
                  })(e.target)
                )
                  return;
                (A = !0),
                  i.pointerDown(e),
                  l.useFriction(0).useDuration(0),
                  s.set(a),
                  (function addDragEvents() {
                    const e = j ? r : t;
                    C.add(e, "touchmove", move, k)
                      .add(e, "touchend", up)
                      .add(e, "mousemove", move, k)
                      .add(e, "mouseup", up);
                  })(),
                  (D = i.readPoint(e)),
                  (O = i.readPoint(e, w)),
                  h.emit("pointerDown");
              })(o);
          }
          const o = t;
          T.add(o, "dragstart", (e) => e.preventDefault(), k)
            .add(o, "touchmove", () => {}, k)
            .add(o, "touchend", () => {})
            .add(o, "touchstart", downIfAllowed)
            .add(o, "mousedown", downIfAllowed)
            .add(o, "touchcancel", up)
            .add(o, "contextmenu", up)
            .add(o, "click", click, !0);
        },
        destroy: function destroy() {
          T.clear(), C.clear();
        },
        pointerDown: function pointerDown() {
          return A;
        },
      };
    }
    function DragTracker(e, t) {
      let r, n;
      function readTime(e) {
        return e.timeStamp;
      }
      function readPoint(r, n) {
        const s = "client" + ("x" === (n || e.scroll) ? "X" : "Y");
        return (isMouseEvent(r, t) ? r : r.touches[0])[s];
      }
      return {
        pointerDown: function pointerDown(e) {
          return (r = e), (n = e), readPoint(e);
        },
        pointerMove: function pointerMove(e) {
          const t = readPoint(e) - readPoint(n),
            s = readTime(e) - readTime(r) > 170;
          return (n = e), s && (r = e), t;
        },
        pointerUp: function pointerUp(e) {
          if (!r || !n) return 0;
          const t = readPoint(n) - readPoint(r),
            s = readTime(e) - readTime(r),
            i = readTime(e) - readTime(n) > 170,
            a = t / s;
          return s && !i && mathAbs(a) > 0.1 ? a : 0;
        },
        readPoint,
      };
    }
    function ResizeHandler(e, t, r, n, s, i, a) {
      const o = [e].concat(n);
      let c,
        l,
        d = [],
        u = !1;
      function readSize(e) {
        return s.measureSize(a.measure(e));
      }
      return {
        init: function init(s) {
          i &&
            ((l = readSize(e)),
            (d = n.map(readSize)),
            (c = new ResizeObserver((r) => {
              (isBoolean(i) || i(s, r)) &&
                (function defaultCallback(r) {
                  for (const i of r) {
                    if (u) return;
                    const r = i.target === e,
                      a = n.indexOf(i.target),
                      o = r ? l : d[a];
                    if (mathAbs(readSize(r ? e : n[a]) - o) >= 0.5) {
                      s.reInit(), t.emit("resize");
                      break;
                    }
                  }
                })(r);
            })),
            r.requestAnimationFrame(() => {
              o.forEach((e) => c.observe(e));
            }));
        },
        destroy: function destroy() {
          (u = !0), c && c.disconnect();
        },
      };
    }
    function ScrollBounds(e, t, r, n, s) {
      const i = s.measure(10),
        a = s.measure(50),
        o = Limit(0.1, 0.99);
      let c = !1;
      function shouldConstrain() {
        return !c && !!e.reachedAny(r.get()) && !!e.reachedAny(t.get());
      }
      return {
        shouldConstrain,
        constrain: function constrain(s) {
          if (!shouldConstrain()) return;
          const c = e.reachedMin(t.get()) ? "min" : "max",
            l = mathAbs(e[c] - t.get()),
            d = r.get() - t.get(),
            u = o.constrain(l / a);
          r.subtract(d * u),
            !s &&
              mathAbs(d) < i &&
              (r.set(e.constrain(r.get())),
              n.useDuration(25).useBaseFriction());
        },
        toggleActive: function toggleActive(e) {
          c = !e;
        },
      };
    }
    function ScrollLooper(e, t, r, n) {
      const s = t.min + 0.1,
        i = t.max + 0.1,
        { reachedMin: a, reachedMax: o } = Limit(s, i);
      return {
        loop: function loop(t) {
          if (
            !(function shouldLoop(e) {
              return 1 === e ? o(r.get()) : -1 === e && a(r.get());
            })(t)
          )
            return;
          const s = e * (-1 * t);
          n.forEach((e) => e.add(s));
        },
      };
    }
    function ScrollTarget(e, t, r, n, s) {
      const { reachedAny: i, removeOffset: a, constrain: o } = n;
      function minDistance(e) {
        return e.concat().sort((e, t) => mathAbs(e) - mathAbs(t))[0];
      }
      function shortcut(t, n) {
        const s = [t, t + r, t - r];
        if (!e) return t;
        if (!n) return minDistance(s);
        const i = s.filter((e) => mathSign(e) === n);
        return i.length ? minDistance(i) : arrayLast(s) - r;
      }
      return {
        byDistance: function byDistance(r, n) {
          const c = s.get() + r,
            { index: l, distance: d } = (function findTargetSnap(r) {
              const n = e ? a(r) : o(r),
                s = t
                  .map((e, t) => ({ diff: shortcut(e - n, 0), index: t }))
                  .sort((e, t) => mathAbs(e.diff) - mathAbs(t.diff)),
                { index: i } = s[0];
              return { index: i, distance: n };
            })(c),
            u = !e && i(c);
          return !n || u
            ? { index: l, distance: r }
            : { index: l, distance: r + shortcut(t[l] - d, 0) };
        },
        byIndex: function byIndex(e, r) {
          return { index: e, distance: shortcut(t[e] - s.get(), r) };
        },
        shortcut,
      };
    }
    function SlideFocus(e, t, r, n, s, i, a, o) {
      const c = { passive: !0, capture: !0 };
      let l = 0;
      function registerTabPress(e) {
        "Tab" === e.code && (l = new Date().getTime());
      }
      return {
        init: function init(d) {
          o &&
            (i.add(document, "keydown", registerTabPress, !1),
            t.forEach((t, u) => {
              i.add(
                t,
                "focus",
                (t) => {
                  (isBoolean(o) || o(d, t)) &&
                    (function defaultCallback(t) {
                      if (new Date().getTime() - l > 10) return;
                      a.emit("slideFocusStart"), (e.scrollLeft = 0);
                      const i = r.findIndex((e) => e.includes(t));
                      isNumber(i) &&
                        (s.useDuration(0), n.index(i, 0), a.emit("slideFocus"));
                    })(u);
                },
                c
              );
            }));
        },
      };
    }
    function Vector1D(e) {
      let t = e;
      function normalizeInput(e) {
        return isNumber(e) ? e : e.get();
      }
      return {
        get: function get() {
          return t;
        },
        set: function set(e) {
          t = normalizeInput(e);
        },
        add: function add(e) {
          t += normalizeInput(e);
        },
        subtract: function subtract(e) {
          t -= normalizeInput(e);
        },
      };
    }
    function Translate(e, t) {
      const r =
          "x" === e.scroll
            ? function x(e) {
                return `translate3d(${e}px,0px,0px)`;
              }
            : function y(e) {
                return `translate3d(0px,${e}px,0px)`;
              },
        n = t.style;
      let s = !1;
      return {
        clear: function clear() {
          s ||
            ((n.transform = ""),
            t.getAttribute("style") || t.removeAttribute("style"));
        },
        to: function to(t) {
          s || (n.transform = r(e.direction(t)));
        },
        toggleActive: function toggleActive(e) {
          s = !e;
        },
      };
    }
    function SlideLooper(e, t, r, n, s, i, a, o, c) {
      const l = 0.5,
        d = arrayKeys(s),
        u = arrayKeys(s).reverse(),
        h = (function startPoints() {
          const e = a[0];
          return findLoopPoints(slidesInGap(u, e), r, !1);
        })().concat(
          (function endPoints() {
            const e = t - a[0] - 1;
            return findLoopPoints(slidesInGap(d, e), -r, !0);
          })()
        );
      function removeSlideSizes(e, t) {
        return e.reduce((e, t) => e - s[t], t);
      }
      function slidesInGap(e, t) {
        return e.reduce(
          (e, r) => (removeSlideSizes(e, t) > 0 ? e.concat([r]) : e),
          []
        );
      }
      function findLoopPoints(s, a, d) {
        const u = (function findSlideBounds(e) {
          return i.map((r, s) => ({
            start: r - n[s] + l + e,
            end: r + t - l + e,
          }));
        })(a);
        return s.map((t) => {
          const n = d ? 0 : -r,
            s = d ? r : 0,
            i = d ? "end" : "start",
            a = u[t][i];
          return {
            index: t,
            loopPoint: a,
            slideLocation: Vector1D(-1),
            translate: Translate(e, c[t]),
            target: () => (o.get() > a ? n : s),
          };
        });
      }
      const p = {
        canLoop: function canLoop() {
          return h.every(({ index: e }) => {
            const r = d.filter((t) => t !== e);
            return removeSlideSizes(r, t) <= 0.1;
          });
        },
        clear: function clear() {
          h.forEach((e) => e.translate.clear());
        },
        loop: function loop() {
          h.forEach((e) => {
            const { target: t, translate: r, slideLocation: n } = e,
              s = t();
            s !== n.get() && (r.to(s), n.set(s));
          });
        },
        loopPoints: h,
      };
      return p;
    }
    function SlidesHandler(e, t, r) {
      let n,
        s = !1;
      return {
        init: function init(i) {
          r &&
            ((n = new MutationObserver((e) => {
              s ||
                ((isBoolean(r) || r(i, e)) &&
                  (function defaultCallback(e) {
                    for (const r of e)
                      if ("childList" === r.type) {
                        i.reInit(), t.emit("slidesChanged");
                        break;
                      }
                  })(e));
            })),
            n.observe(e, { childList: !0 }));
        },
        destroy: function destroy() {
          n && n.disconnect(), (s = !0);
        },
      };
    }
    function SlidesInView(e, t, r, n) {
      const s = {};
      let i,
        a = null,
        o = null,
        c = !1;
      return {
        init: function init() {
          (i = new IntersectionObserver(
            (e) => {
              c ||
                (e.forEach((e) => {
                  const r = t.indexOf(e.target);
                  s[r] = e;
                }),
                (a = null),
                (o = null),
                r.emit("slidesInView"));
            },
            { root: e.parentElement, threshold: n }
          )),
            t.forEach((e) => i.observe(e));
        },
        destroy: function destroy() {
          i && i.disconnect(), (c = !0);
        },
        get: function get(e = !0) {
          if (e && a) return a;
          if (!e && o) return o;
          const t = (function createInViewList(e) {
            return objectKeys(s).reduce((t, r) => {
              const n = parseInt(r),
                { isIntersecting: i } = s[n];
              return ((e && i) || (!e && !i)) && t.push(n), t;
            }, []);
          })(e);
          return e && (a = t), e || (o = t), t;
        },
      };
    }
    function SlidesToScroll(e, t, r, n, s, i, a, o, c) {
      const { startEdge: l, endEdge: d, direction: u } = e,
        h = isNumber(r);
      const p = {
        groupSlides: function groupSlides(e) {
          return h
            ? (function byNumber(e, t) {
                return arrayKeys(e)
                  .filter((e) => e % t == 0)
                  .map((r) => e.slice(r, r + t));
              })(e, r)
            : (function bySize(e) {
                return e.length
                  ? arrayKeys(e)
                      .reduce((r, h, p) => {
                        const m = arrayLast(r) || 0,
                          g = 0 === m,
                          b = h === arrayLastIndex(e),
                          f = s[l] - i[m][l],
                          v = s[l] - i[h][d],
                          w = !n && g ? u(a) : 0,
                          _ = mathAbs(v - (!n && b ? u(o) : 0) - (f + w));
                        return (
                          p && _ > t + c && r.push(h), b && r.push(e.length), r
                        );
                      }, [])
                      .map((t, r, n) => {
                        const s = Math.max(n[r - 1] || 0);
                        return e.slice(s, t);
                      })
                  : [];
              })(e);
        },
      };
      return p;
    }
    function Engine(e, t, r, n, s, i, a) {
      const {
          align: o,
          axis: c,
          direction: l,
          startIndex: d,
          loop: u,
          duration: h,
          dragFree: p,
          dragThreshold: m,
          inViewThreshold: g,
          slidesToScroll: b,
          skipSnaps: f,
          containScroll: v,
          watchResize: w,
          watchSlides: _,
          watchDrag: S,
          watchFocus: k,
        } = i,
        T = {
          measure: function measure(e) {
            const {
              offsetTop: t,
              offsetLeft: r,
              offsetWidth: n,
              offsetHeight: s,
            } = e;
            return {
              top: t,
              right: r + n,
              bottom: t + s,
              left: r,
              width: n,
              height: s,
            };
          },
        },
        C = T.measure(t),
        L = r.map(T.measure),
        P = (function Axis(e, t) {
          const r = "rtl" === t,
            n = "y" === e,
            s = !n && r ? -1 : 1;
          return {
            scroll: n ? "y" : "x",
            cross: n ? "x" : "y",
            startEdge: (function getStartEdge() {
              return n ? "top" : r ? "right" : "left";
            })(),
            endEdge: (function getEndEdge() {
              return n ? "bottom" : r ? "left" : "right";
            })(),
            measureSize: function measureSize(e) {
              const { height: t, width: r } = e;
              return n ? t : r;
            },
            direction: function direction(e) {
              return e * s;
            },
          };
        })(c, l),
        E = P.measureSize(C),
        I = (function PercentOfView(e) {
          return {
            measure: function measure(t) {
              return e * (t / 100);
            },
          };
        })(E),
        q = (function Alignment(e, t) {
          const r = {
            start: function start() {
              return 0;
            },
            center: function center(e) {
              return end(e) / 2;
            },
            end,
          };
          function end(e) {
            return t - e;
          }
          return {
            measure: function measure(n, s) {
              return isString(e) ? r[e](n) : e(t, n, s);
            },
          };
        })(o, E),
        D = !u && !!v,
        O = u || !!v,
        {
          slideSizes: A,
          slideSizesWithGaps: M,
          startGap: N,
          endGap: j,
        } = (function SlideSizes(e, t, r, n, s, i) {
          const { measureSize: a, startEdge: o, endEdge: c } = e,
            l = r[0] && s,
            d = (function measureStartGap() {
              if (!l) return 0;
              const e = r[0];
              return mathAbs(t[o] - e[o]);
            })(),
            u = (function measureEndGap() {
              if (!l) return 0;
              const e = i.getComputedStyle(arrayLast(n));
              return parseFloat(e.getPropertyValue(`margin-${c}`));
            })(),
            h = r.map(a),
            p = (function measureWithGaps() {
              return r
                .map((e, t, r) => {
                  const n = !t,
                    s = arrayIsLastIndex(r, t);
                  return n ? h[t] + d : s ? h[t] + u : r[t + 1][o] - e[o];
                })
                .map(mathAbs);
            })();
          return {
            slideSizes: h,
            slideSizesWithGaps: p,
            startGap: d,
            endGap: u,
          };
        })(P, C, L, r, O, s),
        $ = SlidesToScroll(P, E, b, u, C, L, N, j, 2),
        { snaps: R, snapsAligned: U } = (function ScrollSnaps(e, t, r, n, s) {
          const { startEdge: i, endEdge: a } = e,
            { groupSlides: o } = s,
            c = (function measureSizes() {
              return o(n)
                .map((e) => arrayLast(e)[a] - e[0][i])
                .map(mathAbs);
            })().map(t.measure),
            l = (function measureUnaligned() {
              return n.map((e) => r[i] - e[i]).map((e) => -mathAbs(e));
            })(),
            d = (function measureAligned() {
              return o(l)
                .map((e) => e[0])
                .map((e, t) => e + c[t]);
            })();
          return { snaps: l, snapsAligned: d };
        })(P, q, C, L, $),
        H = -arrayLast(R) + arrayLast(M),
        { snapsContained: G, scrollContainLimit: B } = (function ScrollContain(
          e,
          t,
          r,
          n,
          s
        ) {
          const i = Limit(-t + e, 0),
            a = (function measureBounded() {
              return r
                .map((e, t) => {
                  const { min: n, max: s } = i,
                    a = i.constrain(e),
                    o = !t,
                    c = arrayIsLastIndex(r, t);
                  return o
                    ? s
                    : c || usePixelTolerance(n, a)
                    ? n
                    : usePixelTolerance(s, a)
                    ? s
                    : a;
                })
                .map((e) => parseFloat(e.toFixed(3)));
            })(),
            o = (function findScrollContainLimit() {
              const e = a[0],
                t = arrayLast(a);
              return Limit(a.lastIndexOf(e), a.indexOf(t) + 1);
            })();
          function usePixelTolerance(e, t) {
            return deltaAbs(e, t) < 1;
          }
          return {
            snapsContained: (function measureContained() {
              if (t <= e + s) return [i.max];
              if ("keepSnaps" === n) return a;
              const { min: r, max: c } = o;
              return a.slice(r, c);
            })(),
            scrollContainLimit: o,
          };
        })(E, H, U, v, 2),
        F = D ? G : U,
        { limit: z } = (function ScrollLimit(e, t, r) {
          const n = t[0];
          return { limit: Limit(r ? n - e : arrayLast(t), n) };
        })(H, F, u),
        W = Counter(arrayLastIndex(F), d, u),
        V = W.clone(),
        Q = arrayKeys(r),
        K = Animations(
          n,
          s,
          (e) =>
            ((
              {
                dragHandler: e,
                scrollBody: t,
                scrollBounds: r,
                options: { loop: n },
              },
              s
            ) => {
              n || r.constrain(e.pointerDown()), t.seek(s);
            })(le, e),
          (e) =>
            ((
              {
                scrollBody: e,
                translate: t,
                location: r,
                offsetLocation: n,
                scrollLooper: s,
                slideLooper: i,
                dragHandler: a,
                animation: o,
                eventHandler: c,
                scrollBounds: l,
                options: { loop: d },
              },
              u
            ) => {
              const h = e.settled(),
                p = !l.shouldConstrain(),
                m = d ? h : h && p;
              m && !a.pointerDown() && (o.stop(), c.emit("settle")),
                m || c.emit("scroll");
              const g = r.get() * u + X.get() * (1 - u);
              n.set(g), d && (s.loop(e.direction()), i.loop()), t.to(n.get());
            })(le, e)
        ),
        J = F[W.get()],
        Y = Vector1D(J),
        X = Vector1D(J),
        Z = Vector1D(J),
        ee = Vector1D(J),
        te = (function ScrollBody(e, t, r, n, s, i) {
          let a = 0,
            o = 0,
            c = s,
            l = i,
            d = e.get(),
            u = 0;
          function useDuration(e) {
            return (c = e), h;
          }
          function useFriction(e) {
            return (l = e), h;
          }
          const h = {
            direction: function direction() {
              return o;
            },
            duration: function duration() {
              return c;
            },
            velocity: function velocity() {
              return a;
            },
            seek: function seek(t) {
              const s = t / 1e3,
                i = c * s,
                p = n.get() - e.get();
              let m = 0;
              return (
                c
                  ? (r.set(e),
                    (a += p / i),
                    (a *= l),
                    (d += a),
                    e.add(a * s),
                    (m = d - u))
                  : ((a = 0), r.set(n), e.set(n), (m = p)),
                (o = mathSign(m)),
                (u = d),
                h
              );
            },
            settled: function settled() {
              return mathAbs(n.get() - t.get()) < 0.001;
            },
            useBaseFriction: function useBaseFriction() {
              return useFriction(i);
            },
            useBaseDuration: function useBaseDuration() {
              return useDuration(s);
            },
            useFriction,
            useDuration,
          };
          return h;
        })(Y, Z, X, ee, h, 0.68),
        re = ScrollTarget(u, F, H, z, ee),
        ne = (function ScrollTo(e, t, r, n, s, i, a) {
          function scrollTo(s) {
            const o = s.distance,
              c = s.index !== t.get();
            i.add(o),
              o &&
                (n.duration()
                  ? e.start()
                  : (e.update(), e.render(1), e.update())),
              c && (r.set(t.get()), t.set(s.index), a.emit("select"));
          }
          return {
            distance: function distance(e, t) {
              scrollTo(s.byDistance(e, t));
            },
            index: function index(e, r) {
              const n = t.clone().set(e);
              scrollTo(s.byIndex(n.get(), r));
            },
          };
        })(K, W, V, te, re, ee, a),
        se = (function ScrollProgress(e) {
          const { max: t, length: r } = e;
          return {
            get: function get(e) {
              return r ? (e - t) / -r : 0;
            },
          };
        })(z),
        ie = EventStore(),
        ae = SlidesInView(t, r, a, g),
        { slideRegistry: oe } = (function SlideRegistry(e, t, r, n, s, i) {
          const { groupSlides: a } = s,
            { min: o, max: c } = n;
          return {
            slideRegistry: (function createSlideRegistry() {
              const n = a(i),
                s = !e || "keepSnaps" === t;
              return 1 === r.length
                ? [i]
                : s
                ? n
                : n.slice(o, c).map((e, t, r) => {
                    const n = !t,
                      s = arrayIsLastIndex(r, t);
                    return n
                      ? arrayFromNumber(arrayLast(r[0]) + 1)
                      : s
                      ? arrayFromNumber(
                          arrayLastIndex(i) - arrayLast(r)[0] + 1,
                          arrayLast(r)[0]
                        )
                      : e;
                  });
            })(),
          };
        })(D, v, F, B, $, Q),
        ce = SlideFocus(e, r, oe, ne, te, ie, a, k),
        le = {
          ownerDocument: n,
          ownerWindow: s,
          eventHandler: a,
          containerRect: C,
          slideRects: L,
          animation: K,
          axis: P,
          dragHandler: DragHandler(
            P,
            e,
            n,
            s,
            ee,
            DragTracker(P, s),
            Y,
            K,
            ne,
            te,
            re,
            W,
            a,
            I,
            p,
            m,
            f,
            0.68,
            S
          ),
          eventStore: ie,
          percentOfView: I,
          index: W,
          indexPrevious: V,
          limit: z,
          location: Y,
          offsetLocation: Z,
          previousLocation: X,
          options: i,
          resizeHandler: ResizeHandler(t, a, s, r, P, w, T),
          scrollBody: te,
          scrollBounds: ScrollBounds(z, Z, ee, te, I),
          scrollLooper: ScrollLooper(H, z, Z, [Y, Z, X, ee]),
          scrollProgress: se,
          scrollSnapList: F.map(se.get),
          scrollSnaps: F,
          scrollTarget: re,
          scrollTo: ne,
          slideLooper: SlideLooper(P, E, H, A, M, R, F, Z, r),
          slideFocus: ce,
          slidesHandler: SlidesHandler(t, a, _),
          slidesInView: ae,
          slideIndexes: Q,
          slideRegistry: oe,
          slidesToScroll: $,
          target: ee,
          translate: Translate(P, t),
        };
      return le;
    }
    customElements.define("dynamic-upsell-atc", DynamicUpsellAtc);
    const t = {
      align: "center",
      axis: "x",
      container: null,
      slides: null,
      containScroll: "trimSnaps",
      direction: "ltr",
      slidesToScroll: 1,
      inViewThreshold: 0,
      breakpoints: {},
      dragFree: !1,
      dragThreshold: 10,
      loop: !1,
      skipSnaps: !1,
      duration: 25,
      startIndex: 0,
      active: !0,
      watchDrag: !0,
      watchResize: !0,
      watchSlides: !0,
      watchFocus: !0,
    };
    function OptionsHandler(e) {
      function mergeOptions(e, t) {
        return objectsMergeDeep(e, t || {});
      }
      const t = {
        mergeOptions,
        optionsAtMedia: function optionsAtMedia(t) {
          const r = t.breakpoints || {},
            n = objectKeys(r)
              .filter((t) => e.matchMedia(t).matches)
              .map((e) => r[e])
              .reduce((e, t) => mergeOptions(e, t), {});
          return mergeOptions(t, n);
        },
        optionsMediaQueries: function optionsMediaQueries(t) {
          return t
            .map((e) => objectKeys(e.breakpoints || {}))
            .reduce((e, t) => e.concat(t), [])
            .map(e.matchMedia);
        },
      };
      return t;
    }
    function EmblaCarousel(e, r, n) {
      const s = e.ownerDocument,
        i = s.defaultView,
        a = OptionsHandler(i),
        o = (function PluginsHandler(e) {
          let t = [];
          const r = {
            init: function init(r, n) {
              return (
                (t = n.filter(
                  ({ options: t }) => !1 !== e.optionsAtMedia(t).active
                )),
                t.forEach((t) => t.init(r, e)),
                n.reduce((e, t) => Object.assign(e, { [t.name]: t }), {})
              );
            },
            destroy: function destroy() {
              t = t.filter((e) => e.destroy());
            },
          };
          return r;
        })(a),
        c = EventStore(),
        l = (function EventHandler() {
          let e,
            t = {};
          function getListeners(e) {
            return t[e] || [];
          }
          const r = {
            init: function init(t) {
              e = t;
            },
            emit: function emit(t) {
              return getListeners(t).forEach((r) => r(e, t)), r;
            },
            off: function off(e, n) {
              return (t[e] = getListeners(e).filter((e) => e !== n)), r;
            },
            on: function on(e, n) {
              return (t[e] = getListeners(e).concat([n])), r;
            },
            clear: function clear() {
              t = {};
            },
          };
          return r;
        })(),
        { mergeOptions: d, optionsAtMedia: u, optionsMediaQueries: h } = a,
        { on: p, off: m, emit: g } = l,
        b = reActivate;
      let f,
        v,
        w,
        _,
        S = !1,
        k = d(t, EmblaCarousel.globalOptions),
        T = d(k),
        C = [];
      function createEngine(t) {
        const r = Engine(e, w, _, s, i, t, l);
        if (t.loop && !r.slideLooper.canLoop()) {
          return createEngine(Object.assign({}, t, { loop: !1 }));
        }
        return r;
      }
      function activate(t, r) {
        S ||
          ((k = d(k, t)),
          (T = u(k)),
          (C = r || C),
          (function storeElements() {
            const { container: t, slides: r } = T,
              n = isString(t) ? e.querySelector(t) : t;
            w = n || e.children[0];
            const s = isString(r) ? w.querySelectorAll(r) : r;
            _ = [].slice.call(s || w.children);
          })(),
          (f = createEngine(T)),
          h([k, ...C.map(({ options: e }) => e)]).forEach((e) =>
            c.add(e, "change", reActivate)
          ),
          T.active &&
            (f.translate.to(f.location.get()),
            f.animation.init(),
            f.slidesInView.init(),
            f.slideFocus.init(L),
            f.eventHandler.init(L),
            f.resizeHandler.init(L),
            f.slidesHandler.init(L),
            f.options.loop && f.slideLooper.loop(),
            w.offsetParent && _.length && f.dragHandler.init(L),
            (v = o.init(L, C))));
      }
      function reActivate(e, t) {
        const r = selectedScrollSnap();
        deActivate(), activate(d({ startIndex: r }, e), t), l.emit("reInit");
      }
      function deActivate() {
        f.dragHandler.destroy(),
          f.eventStore.clear(),
          f.translate.clear(),
          f.slideLooper.clear(),
          f.resizeHandler.destroy(),
          f.slidesHandler.destroy(),
          f.slidesInView.destroy(),
          f.animation.destroy(),
          o.destroy(),
          c.clear();
      }
      function scrollTo(e, t, r) {
        T.active &&
          !S &&
          (f.scrollBody
            .useBaseFriction()
            .useDuration(!0 === t ? 0 : T.duration),
          f.scrollTo.index(e, r || 0));
      }
      function selectedScrollSnap() {
        return f.index.get();
      }
      const L = {
        canScrollNext: function canScrollNext() {
          return f.index.add(1).get() !== selectedScrollSnap();
        },
        canScrollPrev: function canScrollPrev() {
          return f.index.add(-1).get() !== selectedScrollSnap();
        },
        containerNode: function containerNode() {
          return w;
        },
        internalEngine: function internalEngine() {
          return f;
        },
        destroy: function destroy() {
          S ||
            ((S = !0), c.clear(), deActivate(), l.emit("destroy"), l.clear());
        },
        off: m,
        on: p,
        emit: g,
        plugins: function plugins() {
          return v;
        },
        previousScrollSnap: function previousScrollSnap() {
          return f.indexPrevious.get();
        },
        reInit: b,
        rootNode: function rootNode() {
          return e;
        },
        scrollNext: function scrollNext(e) {
          scrollTo(f.index.add(1).get(), e, -1);
        },
        scrollPrev: function scrollPrev(e) {
          scrollTo(f.index.add(-1).get(), e, 1);
        },
        scrollProgress: function scrollProgress() {
          return f.scrollProgress.get(f.location.get());
        },
        scrollSnapList: function scrollSnapList() {
          return f.scrollSnapList;
        },
        scrollTo,
        selectedScrollSnap,
        slideNodes: function slideNodes() {
          return _;
        },
        slidesInView: function slidesInView() {
          return f.slidesInView.get();
        },
        slidesNotInView: function slidesNotInView() {
          return f.slidesInView.get(!1);
        },
      };
      return activate(r, n), setTimeout(() => l.emit("init"), 0), L;
    }
    (EmblaCarousel.globalOptions = void 0),
      (EmblaCarousel.globalOptions = { watchSlides: !1 });
    class ObservableTimeout {
      constructor(e) {
        (this.ObserverLite = new ObserverLite()),
          (this.timeout = !1),
          (this.delay = e || 5e3);
      }
      subscribe(e) {
        return this.ObserverLite.subscribe(e);
      }
      next(e) {
        this.ObserverLite.next(e);
      }
      stop() {
        this?.timeout && clearTimeout(this.timeout);
      }
      go() {
        this &&
          (this.stop(),
          (this.timeout = setTimeout(() => {
            this.next(), this.go();
          }, this.delay)));
      }
      setDelay(e) {
        (this.delay = e), this.go();
      }
    }
    function EmblaCarouselAutoplay(e, t) {
      const r = e?.delay || 5e3,
        n = t.rootNode(),
        s = new ObservableTimeout(r);
      let i,
        a,
        o = !1;
      (window.onload = () => {
        s.go();
      }),
        s.subscribe(() => {
          t.canScrollNext() ? t.scrollNext() : t.scrollTo(0);
        }),
        t.on("reInit", s.go),
        t.on("pointerUp", s.go),
        t.on("pointerDown", s.stop);
      const conditionallyPauseAutoPlay = () => {
          o || s.stop();
        },
        conditionallyResumeAutoPlay = () => {
          o || s.go();
        };
      n.addEventListener("touchstart", conditionallyPauseAutoPlay),
        n.addEventListener("touchend", conditionallyPauseAutoPlay),
        n.addEventListener("mouseover", conditionallyPauseAutoPlay),
        n.addEventListener("touchcancel", conditionallyResumeAutoPlay),
        n.addEventListener("mouseout", conditionallyResumeAutoPlay),
        window.addEventListener("load", () => {
          n.matches(":hover") && conditionallyPauseAutoPlay();
        }),
        (i = () => {
          (o = !0), s.stop();
        }),
        (a = () => {
          (o = !1), s.go();
        });
      return {
        type: "autoplay",
        get paused() {
          return o;
        },
        pause: i,
        play: a,
        setDelay: (e) => {
          s.setDelay(e);
        },
      };
    }
    function EmblaCarouselScrollbar(e = {}, t) {
      let r,
        n,
        s = t.internalEngine(),
        i = 0,
        a = 1,
        o = !1,
        c = 0,
        l = 0;
      function mapToScroll() {
        const { target: r } = e;
        (i = t.scrollProgress()), (i = i > 1 ? 1 : i < 0 ? 0 : i);
        const s = r.offsetWidth - n.offsetWidth;
        n.style.transform = `translateX(${s * i}px)`;
      }
      function resetCursorAndMouseDownState() {
        (o = !1),
          (n.style.cursor = "grab"),
          document.removeEventListener("mousemove", onDragMove),
          document.removeEventListener("mouseup", resetCursorAndMouseDownState),
          document.removeEventListener(
            "mouseleave",
            resetCursorAndMouseDownState
          ),
          document.removeEventListener("touchmove", onDragMove),
          document.removeEventListener(
            "touchend",
            resetCursorAndMouseDownState
          ),
          document.body.classList.remove("embla__dragging"),
          (c = 0);
      }
      function onDragStart(e) {
        e.preventDefault(),
          (o = !0),
          (n.style.cursor = "grabbing"),
          (c = (e.pageX || e.touches[0].pageX) - r.offsetLeft),
          (l =
            parseInt(
              n.style.transform.replace("translateX(", "").replace("px)", "")
            ) || 0),
          document.body.classList.add("embla__dragging"),
          document.addEventListener("mousemove", onDragMove),
          document.addEventListener("mouseup", resetCursorAndMouseDownState),
          document.addEventListener("mouseleave", resetCursorAndMouseDownState),
          document.addEventListener("touchmove", onDragMove, { passive: !1 }),
          document.addEventListener("touchend", resetCursorAndMouseDownState);
      }
      function onDragMove(e) {
        if (!o) return;
        e.preventDefault();
        const t = (e.pageX || e.touches[0].pageX) - r.offsetLeft;
        let s = l + (t - c);
        const i = r.offsetWidth - n.offsetWidth;
        s < 0 && (s = 0),
          s > i && (s = i),
          (n.style.transform = `translateX(${s}px)`),
          updateCarouselScrollPosition(s, i);
      }
      function updateCarouselScrollPosition(e, t) {
        const r = s.scrollSnaps;
        let n = e / t;
        (n *= r[r.length - 1]), s.translate.to(n);
      }
      function onScrollbarClick(e) {
        if (e.target === n) return;
        const t = e.pageX - r.getBoundingClientRect().left,
          s = n.offsetWidth,
          i = r.offsetWidth - s;
        let a = t - s / 2;
        a < 0 && (a = 0),
          a > i && (a = i),
          (n.style.transform = `translateX(${a}px)`),
          updateCarouselScrollPosition(a, i);
      }
      function updateSize() {
        const { target: s } = e;
        r.style.width = "100%";
        const i = t.containerNode();
        a = i.scrollWidth / i.offsetWidth;
        const o = s.offsetWidth / a;
        (n.style.width = `${o}px`), mapToScroll();
      }
      e.target &&
        !s.options.loop &&
        (function build() {
          const { target: i } = e;
          r ||
            i.dataset.init ||
            ((i.dataset.init = !0),
            (r = document.createElement("div")),
            (n = document.createElement("div")),
            r.appendChild(n),
            i.appendChild(r),
            (r.style.height = "4px"),
            (r.style.background = "rgba(0,0,0,.1)"),
            (n.style.height = "100%"),
            (n.style.background = "#000"),
            (n.style.cursor = "grab"),
            Array.from(["init", "reInit", "scroll", "settle"]).forEach((e) =>
              t.on(e, mapToScroll)
            ),
            n.addEventListener("mousedown", onDragStart),
            n.addEventListener("touchstart", onDragStart, { passive: !1 }),
            r.addEventListener("click", onScrollbarClick),
            updateSize(),
            t.on("resize", (e) => {
              (t = e), (s = e.internalEngine()), updateSize();
            }));
        })();
      return { type: "scrollbar" };
    }
    function EmblaNav(e = {}, t) {
      e.prevBtn &&
        e.nextBtn &&
        (function addPrevNextBtnsClickHandlers() {
          const scrollPrev = () => t.scrollPrev(),
            scrollNext = () => t.scrollNext();
          e.prevBtn.addEventListener("click", scrollPrev, !1),
            e.nextBtn.addEventListener("click", scrollNext, !1);
          const r = (function addTogglePrevNextBtnsActive() {
            const togglePrevNextBtnsState = () => {
              t.canScrollPrev()
                ? e.prevBtn.removeAttribute("disabled")
                : e.prevBtn.setAttribute("disabled", "disabled"),
                t.canScrollNext()
                  ? e.nextBtn.removeAttribute("disabled")
                  : e.nextBtn.setAttribute("disabled", "disabled");
            };
            return (
              t
                .on("select", togglePrevNextBtnsState)
                .on("init", togglePrevNextBtnsState)
                .on("reInit", togglePrevNextBtnsState),
              () => {
                e.prevBtn.removeAttribute("disabled"),
                  e.nextBtn.removeAttribute("disabled");
              }
            );
          })();
          return (
            t.on("destroy", addPrevNextBtnsClickHandlers),
            () => {
              r(),
                e.prevBtn.removeEventListener("click", scrollPrev, !1),
                e.nextBtn.removeEventListener("click", scrollNext, !1);
            }
          );
        })(),
        e.dotsNode &&
          (function addDotBtnsAndClickHandlers() {
            let r = [];
            const addDotBtnsWithClickHandlers = () => {
                (e.dotsNode.innerHTML = t
                  .scrollSnapList()
                  .map(
                    () =>
                      '<button class="global-carousel__dot" type="button"></button>'
                  )
                  .join("")),
                  (r = Array.from(
                    e.dotsNode.querySelectorAll(".global-carousel__dot")
                  )),
                  r.forEach((e, r) => {
                    e.addEventListener("click", () => t.scrollTo(r), !1);
                  });
              },
              toggleDotBtnsActive = () => {
                e.dotsNode.style.display =
                  t.canScrollPrev() || t.canScrollNext() ? "block" : "none";
                const n = t.previousScrollSnap(),
                  s = t.selectedScrollSnap();
                r[n]?.classList?.remove("global-carousel__dot--selected"),
                  r[s]?.classList?.add("global-carousel__dot--selected");
              };
            return (
              t
                .on("init", addDotBtnsWithClickHandlers)
                .on("destroy", addDotBtnsWithClickHandlers)
                .on("reInit", addDotBtnsWithClickHandlers)
                .on("init", toggleDotBtnsActive)
                .on("reInit", toggleDotBtnsActive)
                .on("select", toggleDotBtnsActive),
              () => {
                e.dotsNode.innerHTML = "";
              }
            );
          })();
      return { type: "nav" };
    }
    class GlobalCarousel extends HTMLElement {
      constructor() {
        super(), (this.embla = null);
      }
      subscribe(e) {
        return this.ObserverLite.subscribe(e);
      }
      next(e) {
        this.ObserverLite.next(e);
      }
      connectedCallback() {
        DomReadyPromise()
          .then(async () => {
            this.ObserverLite = new ObserverLite();
            let e = this.querySelector(":scope > template");
            if (e) {
              try {
                this.settings = JSON.parse(e.innerHTML);
              } catch (e) {
                console.log(e);
              }
              e.remove(), (e = null);
            }
            this.init();
          })
          .catch((e) => {
            console.log(e);
          });
      }
      init() {
        setTimeout(() => {
          if (
            (this.settings?.options &&
              this.querySelector(".global-carousel__items") &&
              (this.embla = new EmblaCarousel(
                this.querySelector(".global-carousel__items"),
                this.settings.options
              )),
            this.settings?.plugins)
          ) {
            const e = {
              autoplay: EmblaCarouselAutoplay,
              nav: EmblaNav,
              scrollbar: EmblaCarouselScrollbar,
            };
            Object.keys(this.settings.plugins).forEach((t) => {
              const r = this.settings.plugins[t];
              "scrollbar" == t &&
                (r.target = r.target
                  ? this.querySelector(r.target)
                  : this.querySelector(".global-carousel__scrollbar")),
                "nav" == t &&
                  ((r.dotsNode = r.dotsNode
                    ? this.querySelector(r.dotsNode)
                    : this.querySelector(".global-carousel__pagination")),
                  (r.nextBtn = r.nextBtn
                    ? this.querySelector(r.nextBtn)
                    : this.querySelector(".global-carousel__nav-next")),
                  (r.prevBtn = r.prevBtn
                    ? this.querySelector(r.prevBtn)
                    : this.querySelector(".global-carousel__nav-prev")));
              const n = e[t](r, this.embla);
              (this.plugins = this.plugins || []), this.plugins.push(n);
            });
          }
          this.next({ init: !0 });
        }, 0);
      }
      destroy() {
        this.embla && (this.embla.destroy(), (this.embla = null));
      }
    }
    customElements.define("global-carousel", GlobalCarousel);
    class GlobalHotspotTarget extends HTMLElement {
      constructor() {
        super();
      }
      connectedCallback() {
        DomReadyPromise()
          .then(async () => {
            const {
              product_handle: e,
              sku: t,
              hotspot_item_class: r,
              hotspot_item_target: n,
              dark: s,
              show_reviews: i,
            } = this.dataset;
            if (!e) return void this.remove();
            (this.style.opacity = "1"),
              (this.product_handle = e),
              (this.sku = !(!t || !t.length) && t),
              (this.hotspot_item_class = r || !1),
              (this.dark = "true" === s),
              (this.showReviews = "true" === i);
            const openHotspot = async (e) => {
              if (
                !(
                  (e && e.key && "Enter" !== e.key && "keydown" === e.type) ||
                  "true" == this.dataset.open
                )
              ) {
                if ((e.preventDefault(), e.stopPropagation(), !this.hotspot)) {
                  const e =
                      n && this.closest(n) ? this.closest(n) : this.parentNode,
                    t = ` \n              <global-hotspot-item\n                ${
                      this.hotspot_item_class
                        ? `class="${this.hotspot_item_class}"`
                        : ""
                    }\n                data-product_handle="${
                      this.product_handle
                    }"\n                data-sku="${
                      this.sku
                    }"\n                data-dark="${
                      this.dark
                    }"\n                data-show_reviews="${
                      this.showReviews
                    }">\n              </global-hotspot-item>\n            `;
                  this.insertAdjacentHTML("afterend", t),
                    (this.hotspot = e.querySelector(
                      `global-hotspot-item[data-product_handle="${this.product_handle}"]`
                    ));
                  const { error: r } = await this.hotspot.ObserverLite.once();
                  if (r) return void this.remove();
                  this.hotspot.subscribe(({ open: e, error: t }) => {
                    t ? this.remove() : (this.dataset.open = e);
                  });
                }
                this.hotspot.show();
              }
            };
            this.addEventListener("click", openHotspot),
              this.addEventListener("keydown", openHotspot);
          })
          .catch((e) => {
            console.error(e);
          });
      }
    }
    customElements.define("global-hotspot-target", GlobalHotspotTarget);
    class GlobalHotspotItem extends HTMLElement {
      constructor() {
        super(), (this.onBodyClick = this.onBodyClick.bind(this));
      }
      subscribe(e) {
        return this.ObserverLite.subscribe(e);
      }
      next(e) {
        this.ObserverLite.next(e);
      }
      connectedCallback() {
        (this.ObserverLite = new ObserverLite()),
          (this.GlobalHotspotObserver = new ObserverLite({
            key: "Global.HotspotEvents",
          })),
          DomReadyPromise()
            .then(async () => {
              const {
                product_handle: e,
                sku: t,
                dark: r,
                show_reviews: n,
              } = this.dataset;
              if (!e)
                return (
                  this.hide(),
                  this.next({ error: "no product found" }),
                  void this.remove()
                );
              (this.always_visible = !!this.attributes.always_visible),
                (this.product_handle = e),
                (this.sku = !(!t || !t.length) && t),
                (this.dark = "true" === r),
                (this.showReviews = "true" === n),
                this.always_visible
                  ? this.show()
                  : ((this.allHotspots$ = new ObserverLite({
                      key: "Global.AllHotspots$",
                    })),
                    this.allHotspots$.subscribe((e) => {
                      e != this && this.hide();
                    })),
                this.next({ ready: !0 });
            })
            .catch((e) => {
              console.error(e);
            });
      }
      animateIn() {
        this.classList.remove("visually-hidden"),
          (this.style.display = "block"),
          (this.animate([{ opacity: 0 }, { opacity: 1 }], 300).onfinish = (
            e
          ) => {
            this.style.opacity = 1;
          });
      }
      animateOut() {
        this.animate([{ opacity: 1 }, { opacity: 0 }], 300).onfinish = (e) => {
          this.classList.add("visually-hidden"),
            (this.style.display = "none"),
            (this.style.opacity = 0);
        };
      }
      onBodyClick(e) {
        this.contains(e.target) || this.hide();
      }
      async show() {
        if (
          (this.animateIn(),
          this.rendered || (await this.render()),
          !this.always_visible)
        ) {
          document.body.addEventListener("click", this.onBodyClick);
          let e = !1,
            t = 0,
            r = 0;
          const n = 100,
            s = this;
          document.addEventListener("mousedown", (n) => {
            (e = !0), (t = n.clientX), (r = n.clientY);
          }),
            document.addEventListener("mouseup", (i) => {
              if (e) {
                const a = Math.abs(i.clientX - t),
                  o = Math.abs(i.clientY - r);
                (a > n || o > n) && s.hide(), (e = !1);
              }
            });
        }
        this.allHotspots$ && this.allHotspots$.next(this),
          this.GlobalHotspotObserver.next({ event: "show", hotspot: this }),
          this.next({ open: !0 });
      }
      async hide() {
        this.animateOut(),
          this.always_visible ||
            document.body.removeEventListener("click", this.onBodyClick),
          this.next({ open: !1 });
      }
      async render() {
        if (!this.productData) {
          this.dataset.loading = !0;
          const e = await (async function getProduct(e) {
            const t = await new StoreFrontApi();
            let r = `\n    {\n      productByHandle(handle:"${e}"){\n        id\n        title\n        metafields(\n          identifiers: [\n            { namespace: "sf_product_hero", key: "sub_heading" },\n            { namespace: "sf_product_hero", key: "size" }\n          ]\n        ) {\n          key\n          namespace\n          value\n        }\n        options(first:3){\n          name\n          optionValues{\n            id\n            name\n          }\n        }\n        variants(first:25){\n          edges{\n            node{\n              id\n              sku\n              availableForSale\n              title\n              price{\n                amount\n              }\n              compareAtPrice{\n                amount\n              }\n              image{\n                altText\n                url\n              }\n              selectedOptions{\n                name\n                value\n              }\n              metafields(\n                identifiers: [\n                  { namespace: "MOS2", key: "tagline" },\n                  { namespace: "custom", key: "badge" }\n                ]\n              ) {\n                key\n                namespace\n                value\n              }  \n            }\n          }\n        }\n      }\n    }\n  `,
              n = null;
            try {
              const { data: e, errors: s } = await t.authFetch({ body: r });
              return s
                ? { errors: s }
                : ((n = e.productByHandle),
                  !!n &&
                    ((n.variants = n.variants.edges
                      .map(({ node: e }) => e)
                      .map((e) => ((e.id = e.id.split("/").reverse()[0]), e))),
                    n || !1));
            } catch (e) {
              return console.error(e), !1;
            }
          })(this.product_handle);
          console.log(e,"product data");
          if (!e)
            return (
              this.hide(),
              this.next({ error: "no product found" }),
              void this.remove()
            );
          (this.productData = e), (this.GlobalCart = await new GlobalCart());
        }
        let e = this.showReviews
            ? this.buildReviews(this.productData, this.product_handle)
            : null,
          t = this.sku
            ? this.productData.variants.findIndex(({ sku: e }) => e == this.sku)
            : 0;
        (t = t >= 0 ? t : 0), (this.variant = this.productData.variants[t]);
        const r =
            this.variant.metafields
              ?.filter((e) => null !== e)
              .find(({ key: e, value: t }) => t && "tagline" == e)?.value ||
            this.productData.metafields
              ?.filter((e) => null !== e)
              .find(({ key: e, value: t }) => t && "sub_heading" == e)?.value ||
            !1,
          n =
            this.productData.metafields
              ?.filter((e) => null !== e)
              .find(({ key: e, value: t }) => t && "size" == e)
              ?.value?.split("/")[t] || !1,
          s = `/products/${this.product_handle}?variant=${this.variant.id}`,
          i = await this.#s(
            this.variant.price.amount,
            this.variant.compareAtPrice?.amount,
            this.variant.id
          ),
          a =
            this.variant.metafields
              ?.filter((e) => null !== e)
              .find(({ key: e, value: t }) => t && "badge" == e)
              ?.value?.split("/")[t] || !1;
        (this.innerHTML = `\n      <div class="flex row-wrap align-stretch justify-left ${
          this.dark ? "bdr" : ""
        }">\n        <a href="${s}" class="flex img-wrapper" tabindex="0">\n          ${
          a
            ? `\n            <span class='badge-v2 badge-v2__product-card block-z3' aria-label='${a}'>${a}</span>\n          `
            : ""
        }\n          <img \n          class="global-hotspot-item__img"\n          width="256"\n          height="256"\n          alt="${
          this.productData.title
        } - ${this.variant.title}"\n          src="${
          this.variant.image.url
        }?w=256">\n        </a>\n        <div class="global-hotspot-item__content flex column-nowrap gap--d3 ${
          this.dark ? "invert" : ""
        }">\n          <a href="${s}" class="h-style t-rm f-w500 mr-20">${
          "Default Title" === this.variant.title
            ? this.productData.title
            : this.variant.title
        }</a>\n          ${
          r
            ? `<span class="global-hotspot-item__subheading" tabindex="0">${r}</span>`
            : ""
        }\n          ${
          e || '<div data-reviews="false"></div>'
        }\n\n          <div class="v2-size-price-block t-xxs lh-m mr-auto" tabindex="0">\n            ${
          n ? `<span>${n.trim()}</span>` : ""
        }\n            <span>${i}</span>\n          </div>\n          <button class="global-hotspot-item__atc v2-atc-bag-btn btn-reset" aria-label="Add To Bag" type="submit" tabindex="0" aria-label="Buy this product button"></button>\n          <button class="global-hotspot-item__close btn-reset" type="button" tabindex="0" aria-label="Close this banner">\n            <svg width="10" height="10" viewBox="0 0 10 10" fill="none" xmlns="http://www.w3.org/2000/svg">\n              <path d="M0.0502526 9.24265L4.29289 5.00001L0.0502526 0.757365L0.757359 0.0502578L5 4.2929L9.24264 0.0502578L9.94975 0.757365L5.70711 5.00001L9.94975 9.24265L9.24264 9.94975L5 5.70711L0.757359 9.94975L0.0502526 9.24265Z" fill="black"/>\n            </svg>\n          </button>\n        </div>\n      </div>\n    `),
          void 0 !== window.yotpoWidgetsContainer &&
            (await window.yotpoWidgetsContainer.initWidgets()),
          (this.addButton = this.querySelector('button[type="submit"]')),
          (this.closeButton = this.querySelector('button[type="button"]')),
          this.toggleAtcButtonState(),
          this.GlobalCart.subscribe(() => {
            this.toggleAtcButtonState();
          }),
          this.addButton.addEventListener("click", (e) => {
            e.preventDefault(),
              (this.addButton.disabled = !0),
              (this.dataset.loading = !0);
            const t = { items: [{ id: this.variant.id, quantity: 1 }] };
            this.GlobalCart.addToCart(t).then(() => {
              window.GlobalCartMain.updateData();
              this.dataset.loading = !1;
            });
          }),
          this.closeButton.addEventListener("click", (e) => {
            e.preventDefault(), this.hide();
          }),
          (this.rendered = !0),
          (this.dataset.loading = !1);
      }
      toggleAtcButtonState() {
        const e = this.GlobalCart.getLineItemsByVariantId(this.variant.id)
          .map(({ quantity: e }) => e)
          .reduce((e, t) => e + t, 0);
        this.addButton.disabled = e >= 6;
      }
      async #s(e, t, r) {
        e *= 100;
        const n = `<span class='price-v2__${r}${
          (t = 100 * t || void 0) ? " f-w600" : ""
        }'>${this.GlobalCart.ShopifyUtils.formatMoney(e)}</span>`;
        let s = t
          ? `<s class="cell-r--d3">${this.GlobalCart.ShopifyUtils.formatMoney(
              t
            )}</s>${n}`
          : n;
        return (
          sitewide && (s = await sitewide.updateGlobalProductPriceV2(r, s)), s
        );
      }
      buildReviews(e, t) {
        return `\n      <a href="/products/${t}#shopify-section-product-reviews-js" class="hotspot-reviews">\n        <div class="yotpo-widget-instance no-events" data-yotpo-instance-id="${
          window?.yotpoStarsInstanceId
        }" data-yotpo-product-id="${
          e.id.split("/Product/")[1]
        }" data-yotpo-cart-product-id="" data-yotpo-section-id="${
          window?.yotpoSectionId
        }"></div>\n      </a>\n    `;
      }
    }
    customElements.define("global-hotspot-item", GlobalHotspotItem);
    class SidebarCart extends HTMLElement {
      constructor() {
        super();
      }
      connectedCallback() {
        DomReadyPromise()
          .then(async () => {
            this.renderOnInit = !!this.attributes.render;
            let e = !1;
            const t = this.querySelector(":scope > template");
            if (t) {
              try {
                e = Array.from(
                  t.content.querySelectorAll("sidebar-cart-layout")
                );
              } catch (e) {
                throw new Error(e);
              }
              t.remove();
            } else e = Array.from(this.querySelectorAll("sidebar-cart-layout"));
            if (!e.length) throw new Error("no layouts");
            if (
              ((this.layouts = {
                empty: e.filter(({ attributes: e }) => e.empty || e.always),
                hasItems: e.filter(({ attributes: e }) => !e.empty || e.always),
              }),
              !this.layouts?.hasItems?.length)
            )
              throw new Error("no layouts");
            (this.GlobalCart = await new GlobalCart()),
              this.GlobalCart.subscribe(() => {
                this.render();
              }),
              this.renderOnInit && this.render();
            const r = new ObserverLite({ key: "GlobalSidebar.SidebarCart" });
            this.SidebarCartWrapper = await r.once();
            const { render: n } =
              await this.SidebarCartWrapper.ObserverLite.once();
            n &&
              (this.render(),
              this.SidebarCartWrapper.subscribe(({ render: e }) => {
                this.render();
              }));
          })
          .catch((e) => {
            console.log(e);
          });
      }
      async render() {
        const e = this.GlobalCart.cart.item_count,
          t = this.empty || !1;
        if (!this.rendered || (t && e > 0) || (!t && 0 == e)) {
          (this.rendered = !0), (this.empty = 0 == e);
          const t =
            !e && this.layouts?.empty?.length
              ? this.layouts.empty
              : this.layouts.hasItems;
          (this.innerHTML = ""),
            t.forEach((e) => {
              const t = e.cloneNode(!0);
              this.appendChild(t);
            });
        }
      }
    }
    customElements.define("sidebar-cart", SidebarCart);
    class SidebarCartLayout extends HTMLElement {
      constructor() {
        super();
      }
      connectedCallback() {
        DomReadyPromise()
          .then(async () => {
            this.init();
          })
          .catch((e) => {
            console.log(e);
          });
      }
      async init() {
        const e = [...this.querySelectorAll("sidebar-cart-section")],
          t = e.map((e) => e.ObserverLite.once());
        await Promise.all(t), (this.cartSections = e), this.renderAllSections();
      }
      renderAllSections() {
        this.cartSections.forEach((e) => {
          e.render();
        });
      }
    }
    customElements.define("sidebar-cart-layout", SidebarCartLayout);
    class SidebarCartSection extends HTMLElement {
      constructor() {
        super(), (this.ObserverLite = new ObserverLite());
      }
      subscribe(e) {
        return this.ObserverLite.subscribe(e);
      }
      next(e) {
        this.ObserverLite.next(e);
      }
      connectedCallback() {
        this.connected ||
          ((this.connected = !0),
          DomReadyPromise()
            .then(async () => {
              const e = this.querySelector(":scope > template[data-settings]");
              if (e) {
                try {
                  this.settings = JSON.parse(e.innerHTML);
                } catch (e) {
                  return void console.log(e);
                }
                if ((e.remove(), this.settings.dependancies?.length)) {
                  const e = new DynamicImporter(this.settings.dependancies);
                  await e.load();
                }
                if (this.settings.observer_key) {
                  new ObserverLite({
                    key: this.settings.observer_key,
                  }).subscribe((e) => {
                    "ui:hidden" == e?.eventType
                      ? this.setAttribute("hidden", !0)
                      : this.removeAttribute("hidden");
                  });
                }
                this.unwrap();
                const t = this.querySelector(":scope > template[data-content]");
                if (
                  ((this.contentHTML = t?.innerHTML || !1), !this.contentHTML)
                )
                  return this.remove(), void this.next();
                this.next(),
                  (this.GlobalCart =
                    this.GlobalCart || (await new GlobalCart())),
                  this.GlobalCart.subscribe(async () => {
                    this.settings.dynamicLiquid &&
                      ((this.contentHTML = await this.getUpdatedHTML()),
                      this.rendered && this.render());
                  });
              }
            })
            .catch((e) => {
              console.log(e);
            }));
      }
      getUpdatedHTML() {
        return new Promise((e, t) => {
          fetch(`${window.Shopify.routes.root}?sections=${this.settings.id}`)
            .then((e) => e.json())
            .then((t) => {
              let r = t[this.settings.id];
              r = parseHTML(r);
              const n = r.querySelector("[data-content]");
              e(n.innerHTML);
            });
        });
      }
      unwrap() {
        if (this.parentNode.id === `shopify-section-${this.settings.id}`) {
          const e = this.parentNode;
          for (; e.firstChild; ) e.parentNode.insertBefore(e.firstChild, e);
          e.remove();
        }
      }
      async render() {
        (this.innerHTML = this.contentHTML), (this.rendered = !0);
      }
    }
    customElements.define("sidebar-cart-section", SidebarCartSection);
    class SellingPlanSelector extends HTMLElement {
      constructor() {
        super(), (this.ObserverLite = new ObserverLite());
      }
      subscribe(e) {
        return this.ObserverLite.subscribe(e);
      }
      next(e) {
        this.ObserverLite.next(e);
      }
      connectedCallback() {
        DomReadyPromise()
          .then(async () => {
            const e = this.querySelector(":scope > template");
            if (e) {
              try {
                (this.settings = JSON.parse(e.innerHTML)), e.remove();
              } catch (e) {
                throw e;
              }
              this.settings &&
                ((this.selected =
                  this.settings.selling_plan_allocation?.selling_plan?.id ||
                  !1),
                this.settings.selling_plan_group.selling_plans.unshift({
                  id: !1,
                  name: "One time only",
                }),
                this.render());
            }
          })
          .catch((e) => {
            console.log(e);
          });
      }
      async bind() {
        (this.input = this.querySelector("input")),
          (this.selector = this.querySelector("select")),
          this.selector.addEventListener("change", (e) => {
            (this.selected = this.selector.value),
              (this.input.value = this.selected),
              this.next();
          });
      }
      render() {
        const e = this.settings.selling_plan_group.discount_percentage,
          t = this.settings.translations.button_text.replace(
            "[[amount]]",
            `${e}%`
          );
        (this.innerHTML = `\n      <div class="box-selector">\n        <input class="box-selector__input" type="hidden" name="selling_plan" value="${
          this.selected
        }" aria-hidden="true">\n        <label class="box-selector__label">${t}</label>\n        <select aria-label="${t}" name="selling_plan_select" class="box-selector__select block-12/12 select-alt-style">\n          ${this.settings.selling_plan_group.selling_plans
          .map(
            ({ name: e, id: t }) =>
              `\n                <option \n                  value="${t}" \n                  ${
                this.selected && this.selected == t ? "selected" : ""
              }>${e}\n                </option>\n              `
          )
          .join("")}\n        </select>\n      </div>\n    `),
          this.bind();
      }
    }
    customElements.define("selling-plan-selector", SellingPlanSelector);
    class ObserverLite_ObserverLite {
      constructor(e) {
        if (
          ((e = e || {}),
          (this.id = Math.floor(999999999999 * Math.random())),
          (this.settings = e),
          e.key)
        ) {
          if (
            ((window.GlobalObersverLiteInstances =
              window.GlobalObersverLiteInstances || {}),
            window.GlobalObersverLiteInstances[e.key])
          )
            return window.GlobalObersverLiteInstances[e.key];
          window.GlobalObersverLiteInstances[e.key] = this;
        }
      }
      once() {
        return new Promise((e, t) => {
          this.onceDone && e(this.onceDone);
          const r = this.subscribe((t) => {
            (t = t || !0), (this.onceDone = t), e(t), this.unsubscribe(r);
          });
        });
      }
      setOnce(e) {
        (e = e || !0), (this.onceDone = e);
      }
      next(...e) {
        this.onceDone || this.setOnce(...e),
          this.subject &&
            this.subject.length &&
            this.subject.forEach(({ callback: t }) => {
              t(...e);
            });
      }
      subscribe(e) {
        return (
          (this.subject = this.subject || []),
          (e = { callback: e, id: Math.floor(1e14 + 9e14 * Math.random()) }),
          this.subject.push(e),
          e
        );
      }
      unsubscribe(e) {
        this.subject = this.subject.filter(({ id: t }) => t !== e.id);
      }
      unsubscribeAll(e) {
        this.subject?.forEach((e) => this.unsubscribe(e)),
          e && (this.onceDone = !1);
      }
    }
    class CartItems extends HTMLElement {
      constructor() {
        super();
      }
      async connectedCallback() {
        this.connected ||
          ((this.globalObserver$ = new ObserverLite_ObserverLite({
            key: "GlobalSidebar.SidebarCart.Sections.CartItems",
          })),
          (this.connected = !0),
          DomReadyPromise()
            .then(async () => {
              const e = this.querySelector(":scope > template");
              if (e) {
                try {
                  this.settings = JSON.parse(e.innerHTML);
                } catch (e) {
                  return void console.log(e);
                }
                e.remove(),
                  (this.GlobalCart = await new GlobalCart()),
                  this.render(),
                  this.GlobalCart.subscribe(({ discrete: e }) => {
                    e || this.render();
                  });
              }
            })
            .catch((e) => {
              console.log(e);
            }));
      }
      render() {
        const { items: e } = this.GlobalCart.cart;
        (this.innerHTML = e.length
          ? e
              .map((e, t) => {
                if (e) {
                  const {
                      product_title: t,
                      variant_title: r,
                      options_with_values: n,
                      variant_options: s,
                      image: i,
                      url: a,
                      discounts: o,
                      line: c,
                      key: l,
                      quantity: d,
                      final_line_price: u,
                      original_line_price: h,
                      properties: p,
                      selling_plan_group: m,
                      selling_plan_allocation: g,
                      badge: b,
                    } = e,
                    f = {
                      product_title: t,
                      variant_title: r,
                      options_with_values: n,
                      variant_options: s,
                      image: i,
                      url: a,
                      discounts: o,
                      line: c,
                      key: l,
                      quantity: d,
                      final_line_price: u,
                      original_line_price: h,
                      properties: p,
                      selling_plan_group: m,
                      selling_plan_allocation: g,
                      badge: b,
                    };
                  return `\n              <cart-line-item class="flex-grid--d2 flex column-nowrap">\n                <template data-settings>\n                  {\n                    "line_item":${JSON.stringify(
                    f
                  )},\n                    "translations":${JSON.stringify(
                    this.settings.translations
                  )},\n                    "subscriptions":${JSON.stringify(
                    this.settings.subscriptions
                  )}\n                  }\n                </template>\n              </cart-line-item>\n            `;
                }
              })
              .join("")
          : `\n        <div class="tac cell-l cell-r flex column-nowrap align-center justify-center flex-grid">\n          <h2 class="h-style t-m">${
              this.settings.empty.cart_empty_header
            }</h2>\n          <div class="t-grey lh-r t-rm empty-cart-message">${
              this.settings.empty.cart_empty_message
            }</div>\n          <a class="btn btn--large" href="${
              this.settings.empty.cart_empty_cta_url?.length
                ? this.settings.empty.cart_empty_cta_url
                : "/"
            }">${
              this.settings.empty.cart_empty_cta_text
            }</a>\n        </div>\n      `),
          this.globalObserver$.next(this);
      }
    }
    customElements.define("cart-items", CartItems);
    class CartLineItem extends HTMLElement {
      constructor(e) {
        super();
      }
      connectedCallback() {
        DomReadyPromise()
          .then(async () => {
            const e = this.querySelector(":scope > template");
            if (e) {
              try {
                (this.settings = JSON.parse(e.innerHTML)), e.remove();
              } catch (e) {
                console.log(e);
              }
              this.settings &&
                ((this.GlobalCart = await new GlobalCart()), this.render());
            }
          })
          .catch((e) => {
            console.log(e);
          });
      }
      async bind() {
        (this.GlobalCart = this.GlobalCart || (await new GlobalCart())),
          (this.qtyselector = this.querySelector(".js-sidebar-cart__update")),
          this.qtyselector?.addEventListener("change", (e) => {
            this.GlobalCart.updateQty(
              this.settings.line_item,
              parseInt(this.qtyselector.value)
            );
          }),
          this.qtyselector?.addEventListener("click", (e) => {
            e.preventDefault(), e.stopPropagation();
          }),
          (this.removeButton = this.querySelector(".js-sidebar-cart__remove")),
          this.removeButton?.addEventListener("click", (e) => {
            e.preventDefault(),
              e.stopPropagation(),
              this.GlobalCart.updateQty(this.settings.line_item, 0),
              this.remove();
          }),
          (this.sellingPlanSelector = this.querySelector(
            "selling-plan-selector"
          )),
          this.sellingPlanSelector &&
            this.sellingPlanSelector.subscribe(() => {
              const { key: e, quantity: t } = this.settings.line_item,
                r = {
                  key: e,
                  quantity: t,
                  selling_plan: parseInt(this.sellingPlanSelector.selected),
                };
              this.GlobalCart.updateLine(r);
            });
      }
      getPreTitlesHtml({
        params: e,
        properties: t,
        product_type: r,
        badge: n,
      }) {
        let s = `\n      ${
          e.is_sample
            ? `\n          <span class="sb-cart-item__pre-title">${this.settings.translations.product.free_sample}</span>\n        `
            : ""
        }\n      ${
          e.isFreeGift || e.isFreeTravelSize
            ? `\n          <span class="sb-cart-item__pre-title">${this.settings.translations.product.free_gift}</span>\n        `
            : ""
        }\n      ${
          e.isBirthdayGift
            ? `\n          <span class="sb-cart-item__pre-title">${this.settings.translations.product.birthday_gift}</span>\n        `
            : ""
        }  \n      ${
          t._bundle || "Bundles" === r
            ? `\n          <span class="sb-cart-item__pre-title">${this.settings.translations.product.bundle}</span>\n        `
            : ""
        }\n    `
          .trim()
          .replace(/\n\s+/g, "");
        return (
          !s.length &&
            n &&
            (s = `<span class="sb-cart-item__badge" aria-label="${n}">${n}</span>`),
          s
        );
      }
      render() {
        let {
          line: e,
          product_title: t,
          variant_title: r,
          image: n,
          url: s,
          discounts: i,
          key: a,
          quantity: o,
          final_line_price: c,
          original_line_price: l,
          properties: d,
          product_type: u,
          selling_plan_group: h,
          selling_plan_allocation: p,
          badge: m,
        } = this.settings.line_item;
        d = d || {};
        let g = d._variantInventoryQty ? d._variantInventoryQty : 6;
        g = g > 6 ? 6 : g;
        const b = {};
        (b.isBirthdayGift = d._birthdayGift && 0 == c),
          (b.isFreeGift =
            (d._FreeGiftTieredDiscountId && 0 == c) ||
            d._gift ||
            b.isBirthdayGift),
          (b.is_sample =
            d._RoswellSample ||
            u?.toLowerCase().includes("sample") ||
            t?.toLowerCase().includes("sample") ||
            r?.toLowerCase().includes("sample")),
          (b.isFreeTravelSize =
            0 == c &&
            t?.toLowerCase().includes("travel size") &&
            !b.isFreeGift);
        const f =
            b.isFreeGift ||
            b.is_sample ||
            d._birthdayGift ||
            d._bundle ||
            d._csa_builder,
          v = !(f || g <= 0 || b.isFreeTravelSize),
          w = !b.isFreeGift,
          _ = this.settings.subscriptions,
          S =
            !b.isFreeGift &&
            !b.is_sample &&
            (h || p) &&
            _.show &&
            _.button_text.length;
        S && p && ((l = p.compare_at_price * o), (c = p.price * o)),
          (!b.isFreeGift && !b.is_sample) ||
            i.length ||
            i.push({ title: "Free Product" });
        const k = `\n      <img \n        src="${n}?&width=128" \n        alt="${t}" \n        loading="lazy" \n        width="128" \n        height="128"\n      >\n        ${
            v ? "" : `<span class="counter global-cart-line-pill">${o}</span>`
          }\n    `,
          T = `\n      ${this.getPreTitlesHtml({
            params: b,
            properties: d,
            product_type: u,
            badge: m,
          })}\n\n      <span class="d-block f-w600 t-s ls-5 lh-18 t-ucase t-black">${
            r || t
          }</span>\n\n      ${
            d._csa_builder
              ? `<span class="sb-cart-item__sub-title t-black">CSA Kit Builder: ${d._csa_builder}</span>`
              : ""
          }\n    `,
          C = `\n        <a aria-label="View ${t}" href="${s}" class="sb-cart-item__image">${k}</a>\n    \n        <div class="sb-cart-item__details cell-l block flex column-wrap align-top justify-left flex-grid-y--d3">\n          \n          <a aria-label="View ${t}" href="${s}" class="block flex column-wrap align-top justify-left flex-grid-y--d3">${T}</a>\n\n          ${
            v || w
              ? `\n                <div class="flex row-wrap align-center flex-grid--d2">\n                  ${
                  v
                    ? `\n                      <select \n                        class="js-sidebar-cart__update select-alt-style select-alt-style--s" \n                        name="qty" data-id="${a}" aria-label="quantity">\n                        ${new Array(
                        g + 1
                      )
                        .fill(!1)
                        .map(
                          (e, t) =>
                            `<option value="${t}" ${
                              t == o ? "selected" : ""
                            }>${t}</option>`
                        )
                        .join(
                          ""
                        )}\n                      </select>\n                    `
                    : ""
                }\n\n                  ${
                  w
                    ? `\n                      <button type="button" class="js-sidebar-cart__remove t-s t-black" data-id="${a}">\n                        <u>${this.settings.translations.product.remove}</u>\n                      </button>\n                    `
                    : ""
                }\n                </div>\n              `
              : ""
          }\n\n          ${
            b.isBirthdayGift
              ? `\n                <button type="button" class="js-sidebar-cart__remove t-s" data-id="${a}">\n                  <u>${this.settings.translations.product.remove}</u>\n                </button>\n              `
              : ""
          }\n\n          ${
            c
              ? `\n              <span class="sb-cart-item__price f-w600 t-s ls-5 lh-18 flex column-nowrap align-bottom">\n                ${
                  l != c
                    ? `\n                  <small class="t-s t-grey"><s>${this.GlobalCart.ShopifyUtils.formatMoney(
                        l
                      )}</s></small>\n                `
                    : ""
                }\n                <span>${this.GlobalCart.ShopifyUtils.formatMoney(
                  c
                )}</span>\n              </span>\n            `
              : ""
          }\n\n          ${(f && i && i.length, "")}  \n      </div>\n    `;
        (this.innerHTML = `\n      <div class="sb-cart-item block-rel flex row-wrap align-top justify-left">\n        ${C}\n      </div>\n      ${
          S
            ? `\n           <selling-plan-selector class="block-12/12">\n             <template>\n               {\n                 "selling_plan_group":${
                h ? JSON.stringify(h) : "false"
              },\n                 "selling_plan_allocation":${
                p ? JSON.stringify(p) : "false"
              },\n                 "translations":{\n                    "button_text":"${
                _.button_text
              }"\n                 }\n               }\n             </template>\n           </selling-plan-selector>\n          `
            : ""
        }\n    `),
          this.bind();
      }
    }
    customElements.define("cart-line-item", CartLineItem);
    class CartFooterMain extends HTMLElement {
      constructor() {
        super(), (this.ObserverLite = new ObserverLite());
      }
      subscribe(e) {
        return this.ObserverLite.subscribe(e);
      }
      next(e) {
        this.ObserverLite.next(e);
      }
      decodeHtmlString(e) {
        const t = document.createElement("textarea");
        return (t.innerHTML = e), t.value;
      }
      connectedCallback() {
        DomReadyPromise()
          .then(async () => {
            const e = this.querySelector(":scope > template");
            if (e) {
              try {
                const t = JSON.parse(e.innerHTML);
                (this.settings = t), e.remove();
              } catch (e) {
                console.log(e);
              }
              this.settings &&
                ((this.GlobalCart = await new GlobalCart()),
                this.GlobalCart.subscribe(() => {
                  this.render();
                }),
                this.render(),
                this.GlobalCart.requestQueues$.subscribe((e) => {
                  this.updateState(e > 0);
                }));
            }
          })
          .catch((e) => {
            console.log(e);
          });
      }
      updateState(e) {
        (this.total_el = this.querySelector(".js-sb-cart-footer__total")),
          this.total_el && (this.total_el.dataset.cart_ui_thinking_text = e),
          (this.points_el = this.querySelector(".js-sb-cart-footer__points")),
          this.points_el && (this.points_el.dataset.cart_ui_thinking_text = e),
          (this.button_el = this.querySelector(".js-sb-cart-footer__btn")),
          this.button_el &&
            (this.button_el.dataset.cart_ui_thinking_button = e);
      }
      render() {
        const {
          total_price: e,
          original_total_price: t,
          item_count: r,
        } = this.GlobalCart.cart;
        if (!r)
          return (
            (this.innerHTML = ""),
            this.setAttribute("hidden", !0),
            void this.next({ eventType: "ui:hidden" })
          );
        this.removeAttribute("hidden"),
          this.next({ eventType: "ui:show" }),
          this.settings.dv2_fg__show &&
            this.GlobalCart.freeGiftToggle &&
            (this.GlobalCart.freeGiftToggle.show = !0),
          (this.innerHTML = `\n        <form action="/cart" method="post" class="flex flex-grid--d3 column-nowrap">\n          <div class="flex row-wrap align-center justify-space flex-grid--d2 t-ucase f-w600 ls-5 lh-18 t-ucase t-rm">\n            <span class="">${
            this.settings.total_text
          }</span>\n            <div class="js-sb-cart-footer__total flex row-wrap align-bottom justify-right flex-grid--d3">\n              ${
            t != e
              ? `<span class="f-w400 t-xxs t-grey"><s>${this.GlobalCart.ShopifyUtils.formatMoney(
                  t
                )}</s></span>`
              : ""
          }\n              <span>${this.GlobalCart.ShopifyUtils.formatMoney(
            e
          )}</span>\n            </div>\n          </div>\n          ${
            this.settings.lp__show && this.settings.lp__label?.length
              ? `\n                <div class="flex row-wrap align-center justify-space flex-grid--d2">\n                  <span class="flex row-wrap align-center justify-left flex-grid--d2">\n                    <span class="sb-cart-ll-points">${
                  this.settings.lp__label
                }</span>\n                    <button class="d-block js-sb-cart-footer__hint-toggle sb-cart-footer__hint-toggle" type="button">\n                      <svg width="18" height="18" viewBox="0 0 18 18" fill="none" xmlns="http://www.w3.org/2000/svg">\n                        <path d="M8.5 13.5H9.5V8H8.5V13.5ZM9 6.57693C9.17437 6.57693 9.32053 6.51795 9.43848 6.4C9.55641 6.28205 9.61537 6.13589 9.61537 5.96152C9.61537 5.78718 9.55641 5.64102 9.43848 5.52307C9.32053 5.40512 9.17437 5.34615 9 5.34615C8.82563 5.34615 8.67948 5.40512 8.56153 5.52307C8.44359 5.64102 8.38463 5.78718 8.38463 5.96152C8.38463 6.13589 8.44359 6.28205 8.56153 6.4C8.67948 6.51795 8.82563 6.57693 9 6.57693ZM9.00335 18C7.7588 18 6.58872 17.7638 5.4931 17.2915C4.39748 16.8192 3.44444 16.1782 2.63397 15.3685C1.82352 14.5588 1.18192 13.6066 0.70915 12.512C0.236383 11.4174 0 10.2479 0 9.00335C0 7.7588 0.236158 6.58872 0.708475 5.4931C1.18081 4.39748 1.82183 3.44444 2.63153 2.63398C3.44123 1.82353 4.39337 1.18192 5.48795 0.709151C6.58255 0.236384 7.75212 0 8.99665 0C10.2412 0 11.4113 0.236158 12.5069 0.708475C13.6025 1.18081 14.5556 1.82182 15.366 2.63152C16.1765 3.44122 16.8181 4.39337 17.2908 5.48795C17.7636 6.58255 18 7.75212 18 8.99665C18 10.2412 17.7638 11.4113 17.2915 12.5069C16.8192 13.6025 16.1782 14.5556 15.3685 15.366C14.5588 16.1765 13.6066 16.8181 12.512 17.2909C11.4174 17.7636 10.2479 18 9.00335 18ZM9 17C11.2333 17 13.125 16.225 14.675 14.675C16.225 13.125 17 11.2333 17 9C17 6.76667 16.225 4.875 14.675 3.325C13.125 1.775 11.2333 1 9 1C6.76667 1 4.875 1.775 3.325 3.325C1.775 4.875 1 6.76667 1 9C1 11.2333 1.775 13.125 3.325 14.675C4.875 16.225 6.76667 17 9 17Z" fill="black"/>\n                      </svg>\n                    </button>\n                  </span>\n                  <span class="js-sb-cart-footer__points">${Math.floor(
                  e / 100
                )}</span>\n                  <div class="js-sb-cart-footer__hint-text sb-cart-footer__hint-text block-12/12 t-xxs bdr-t bdr-grey-mid ct--d2 block-rel">\n                    <button class="js-sb-cart-footer__hint-toggle sb-cart-footer__hint-text-close sb-cart__close-x"></button>\n                    ${this.decodeHtmlString(
                  this.settings.lp__hint
                )}\n                  </div>\n                </div>\n              `
              : ""
          }\n          ${
            this.settings.dv2_fg__show && this.GlobalCart.freeGiftToggle
              ? `\n              <global-freegift-toggle hidden>\n                  <template>\n                    ${JSON.stringify(
                  {
                    gift_remove__text: this.settings.dv2_fg__label,
                    remove__tooltip: this.settings.dv2_fg__tooltip,
                  }
                )}\n                  </template>\n                </global-freegift-toggle>\n              `
              : ""
          } \n          <button \n            name="checkout" \n            class="sb-cart-footer__btn js-sb-cart-footer__btn btn btn--secondary btn--full">\n              ${
            this.settings.button_text
          }\n          </button>\n        </form>\n      `),
          this.bind();
      }
      bind() {
        (this.lp_content = this.querySelector(".js-sb-cart-footer__hint-text")),
          this.lp_content &&
            this.querySelectorAll(".js-sb-cart-footer__hint-toggle").forEach(
              (e) =>
                e.addEventListener("click", (e) => {
                  e.preventDefault(),
                    (this.lp_content.style.display =
                      "block" == this.lp_content.style.display
                        ? "none"
                        : "block");
                })
            );
      }
    }
    customElements.define("cart-footer-main", CartFooterMain);
    class CartIconBanner extends HTMLElement {
      constructor() {
        super(), (this.ObserverLite = new ObserverLite());
      }
      subscribe(e) {
        return this.ObserverLite.subscribe(e);
      }
      next(e) {
        this.ObserverLite.next(e);
      }
      connectedCallback() {
        DomReadyPromise()
          .then(async () => {
            const e = this.querySelector(":scope > template");
            if (e) {
              try {
                const t = JSON.parse(e.innerHTML);
                (this.settings = t), e.remove();
              } catch (e) {
                console.log(e);
              }
              if (this.settings) {
                const e = this.attributes?.observer_key?.value || !1;
                if (e) {
                  const t = new ObserverLite({ key: e });
                  this.ObserverLite.subscribe((e) => {
                    t.next(e);
                  });
                }
                (this.GlobalCart = await new GlobalCart()),
                  this.GlobalCart.subscribe(() => {
                    this.render();
                  }),
                  this.render();
              }
            }
          })
          .catch((e) => {
            console.log(e);
          });
      }
      render() {
        let { total_price: e } = this.GlobalCart.cart;
        const { blocks: t } = this.settings,
          r = t.filter(({ threshold: t }) => e / 100 >= t)?.reverse() || !1,
          n = !!r && r[0];
        if (!n)
          return (
            (this.tiers = !1),
            this.setAttribute("hidden", !0),
            void this.next({ eventType: "ui:hidden" })
          );
        this.removeAttribute("hidden"),
          this.next({ eventType: "ui:show" }),
          (this.innerHTML = `\n      \n    ${
            n.icon
              ? `\n          <img \n            class="sb-cart-banner__img" \n            loading="lazy" \n            width="64" \n            height="64" \n            alt="${
                  n.icon.alt || !1
                }"\n            src="${
                  n.icon.src || n.icon
                }&width=64">\n        `
              : ""
          }\n    <div class="sb-cart-banner__rte rte-content">${
            n.text
          }</div>\n    `);
      }
    }
    customElements.define("cart-icon-banner", CartIconBanner);
    class CartBeam extends HTMLElement {
      constructor() {
        super();
      }
      connectedCallback() {
        DomReadyPromise()
          .then(async () => {
            setTimeout(() => {
              const e = document.querySelector(
                "beam-select-nonprofit"
              )?.shadowRoot;
              if (e) {
                e.querySelector(".block-header-promo-pill-container");
                const t = e.querySelector(".header-inline");
                t && (t.style.textAlign = "center");
              }
            }, 200);
          })
          .catch((e) => {
            console.log(e);
          });
      }
    }
    customElements.define("cart-beam", CartBeam);
    class CartMessageBar extends HTMLElement {
      constructor() {
        super();
      }
      connectedCallback() {
        DomReadyPromise()
          .then(async () => {
            const e = this.querySelector(":scope > template");
            if (e) {
              try {
                this.settings = JSON.parse(e.innerHTML);
              } catch (e) {
                console.log(e);
              }
              e.remove();
            }
            this.settings?.blocks?.length && this.render();
          })
          .catch((e) => {
            console.log(e);
          });
      }
      async render() {
        this.innerHTML = `\n      <div class="js-embla-slider bg-black">\n        <div class="embla__container">\n          ${this.settings.blocks
          .map(
            ({ text: e }) =>
              `<div class="embla__slide t-white t-s ls-10 text-center cell-l--d2 cell-r--d2 content-center">\n                  ${e.replace(
                /<a /g,
                '<a class="no-hover t-white t-ul" '
              )}\n                </div>`
          )
          .join("")}\n        </div>\n      </div>\n    `;
        const e = new ObserverLite({ key: "GlobalSidebar.SidebarCart" }),
          t = await e.once(),
          r = this.querySelector(".js-embla-slider"),
          n = this.settings;
        if (r && n.options) {
          const e = EmblaCarousel(r, n.options);
          if (n.plugins) {
            const r = EmblaCarouselAutoplay(n.plugins.autoplay, e);
            t.subscribe(({ open: e }) => {
              void 0 !== e && 1 == e
                ? r.play()
                : void 0 !== e && 0 == e && r.pause();
            });
          }
        }
      }
    }
    customElements.define("cart-message-bar", CartMessageBar);
    var n = __webpack_require__(260);
    class CountriesData_CountriesData {
      constructor(e) {
        const t = new ObserverLite({ key: "CountriesDataSingleton$" });
        if (!e)
          return new Promise(async (e) => {
            e(await t.once());
          });
        (this.settings = e),
          (this.ObserverLite = new ObserverLite()),
          (this.countries = []),
          (this.lsKey = "gbl_loco_key2103");
        this.getParams().relocate && this.setLs("doNotRelocate", !0),
          this.init(t);
      }
      get currentCountry() {
        const e =
          0 !== this.countries.length &&
          this.countries.filter(({ zone: e }) => e === this.market);
        return e.length > 0 && e[0];
      }
      subscribe(e) {
        return this.ObserverLite.subscribe(e);
      }
      next(e) {
        this.ObserverLite.next(e);
      }
      getCountry(e, t) {
        let r = this.countries.filter((r) =>
          Array.isArray(r[e]) ? r[e].some((e) => e == t) : r[e] == t
        );
        return !!r.length && r[0];
      }
      getParams(e = window.location.href) {
        const t = {},
          r = document.createElement("a");
        r.href = e;
        return (
          r.search
            .substring(1)
            .split("&")
            .forEach((e) => {
              const [r, n] = e.split("=");
              t[r] = decodeURIComponent(n);
            }),
          t
        );
      }
      setLs(e, t) {
        const r = JSON.parse(window.localStorage.getItem(this.lsKey) || "{}");
        (r[e] = t), window.localStorage.setItem(this.lsKey, JSON.stringify(r));
      }
      getLs() {
        return JSON.parse(window.localStorage.getItem(this.lsKey) || "{}");
      }
      async init(e) {
        window.location.href.indexOf("www.medik8") > -1
          ? (this.market = "GB")
          : window.location.href.indexOf("us.medik8") > -1
          ? (this.market = "US")
          : window.location.href.indexOf("eu.medik8") > -1
          ? (this.market = "EU")
          : (this.market = "INT");
        try {
          await this.getCountriesJson(), e.next(this);
        } catch (e) {
          console.warn("Error in init:", e);
        }
      }
      getCountriesJson() {
        return new Promise((e, t) => {
          this.loaded
            ? e(this.countries)
            : fetch(this.settings.jsonDataUrl)
                .then((e) => e.json())
                .then((t) => {
                  (this.countries = [
                    ...this.countries,
                    ...t.filter(
                      (e) => !this.countries.some((t) => t.id === e.id)
                    ),
                  ]),
                    (this.loaded = !0),
                    e(this.countries);
                })
                .catch((e) => {
                  console.log("Error loading countries data:", e), t(!1);
                });
        });
      }
    }
    class GlobalCountySelector extends HTMLElement {
      constructor() {
        super(),
          (this.show = !1),
          document.body.addEventListener("hide-country-dropdown", () => {
            this.show && this.toggle(!0);
          });
      }
      connectedCallback() {
        !this.id &&
          window.location.href.includes("medik8") &&
          DomReadyPromise()
          .then(async () => {
              try {
                (this.countriesData = await new CountriesData()),
                  (this.settings =
                    this.countriesData.settings.selectorSettings);
                const e = this.querySelector("[data-counties-logo-sources]"),
                  t = "countiesLogoSources";
                let r;
                if (e)
                  (r = JSON.parse(e.innerHTML.trim())),
                    localStorage.setItem(t, JSON.stringify(r));
                else {
                  const e = localStorage.getItem(t);
                  r = e ? JSON.parse(e) : null;
                }
                if (!r)
                  throw new Error("[data-counties-logo-sources] not saved.");
                (this.logo_sources = r),
                  (this.show_full_name = !!this.attributes.show_full_name),
                  this.populateToggle();
              } catch (e) {
                console.error("Error:", e);
              }
            })
            .catch((e) => {
              console.error("Error:", e);
            });
      }
      subscribe(e) {
        return this.ObserverLite.subscribe(e);
      }
      next(e) {
        this.ObserverLite.next(e);
      }
      htmlToNode(e) {
        const t = document.createElement("template");
        return (e = e.trim()), (t.innerHTML = e), t.content.firstChild;
      }
      async toggle(e) {
        this.listIsRendered ||
          e ||
          ((this.listIsRendered = !0), await this.populateCountryList()),
          this.show || e
            ? ((this.show = !1),
              this.countries_dropdown.classList.remove("active"))
            : ((this.show = !this.show),
              this.show
                ? this.countries_dropdown.classList.add("active")
                : this.countries_dropdown.classList.remove("active"));
      }
      populateToggle() {
        const e = this.countriesData.currentCountry;
        if (e) {
          const t = Array.isArray(e.isoAlpha2) ? e.isoAlpha2[0] : e.isoAlpha2,
            r =
              this.logo_sources.find((e) => e.isoAlpha2 === t.toLowerCase())
                ?.url || "",
            n = Number(e.id) <= 7 ? "eager" : "lazy",
            s = `<div data-country-toggle class="country-selector__active">\n                    <div class="country-flag">\n                      <img src="${r}" alt="${
              e.name
            } flag" height="18" width="18" loading="${n}" />\n                    </div>\n                    <div class="country country-name">\n                      ${
              this.show_full_name ? e.name : e.currency.substring(1)
            }\n                    </div>`;
          (this.country_toggle = this.htmlToNode(s)),
            (this.innerHTML = ""),
            this.append(this.country_toggle),
            this.country_toggle.addEventListener("click", () => {
              this.toggle();
            });
        }
      }
      async populateCountryList() {
        if (!(await this.countriesData.getCountriesJson())) return;
        const e = this.countriesData.countries
            .filter(({ id: e }) => e && e > 2)
            .map((e) => {
              const t = Array.isArray(e.isoAlpha2)
                  ? e.isoAlpha2[0]
                  : e.isoAlpha2,
                r =
                  this.logo_sources.find((e) => e.isoAlpha2 === t.toLowerCase())
                    ?.url || "",
                n = Number(e.id) <= 7 ? "eager" : "lazy";
              return `<a data-filter-item data-filter-name="${e.name}" href="${e.website}">\n                  <div class="country-flag">\n                    <img \n                      loading="${n}" \n                      src="${r}" \n                      width="18" height="18" alt="${e.name} flag" />\n                  </div>\n                  <div class="country country-name">${e.name}</div>\n                  <div class="flag-currency push">${e.currency}</div>\n                </a>`;
            })
            .join(""),
          t = `<div data-country-dropdown class="country-selector__dropdown">\n                            <div class="country-selector__header">\n                              <h6 class="country-selector__delivery-title">${this.settings.country_selector_heading}</h6>\n                              <span class="country-selector__header-container flex align-center block-rel">\n                                <button class="country-selector__close-button modal-close modal-close-btn btn-reset @tablet__show" type="button"></button>\n                                <div class="country-search-input-wrapper">\n                                  <input class="country-search grow-1" data-search type="text" placeholder="Search for location..."/>\n                                </div>\n                              </span>\n                            </div>\n                            <div class="country-selector__countries-container">\n                              <div data-countries-wrapper class="country-selector__countries-wrapper">${e}</div>\n                              <div class="country-selector__country-footer">\n                                <small>\n                                  <a href="${this.settings.country_selector_footer_url}">${this.settings.country_selector_footer_text}</a>\n                                </small>\n                              </div>\n                            </div>\n                          </div>`;
        (this.countries_dropdown = this.htmlToNode(t)),
          this.country_toggle.after(this.countries_dropdown),
          this.querySelector("[data-search]").addEventListener("focus", (e) => {
            e.preventDefault(), e.stopPropagation();
          }),
          this.querySelector("[data-search]").addEventListener("input", (e) => {
            e.preventDefault(), e.stopPropagation();
            const t = e.target.value.toLowerCase();
            this.querySelectorAll("[data-filter-item]").forEach((e) => {
              e.style.display = e.textContent.toLowerCase().includes(t)
                ? ""
                : "none";
            });
          }),
          document.addEventListener("mouseup", (e) => {
            !e.target.closest(".country-selector") &&
              this.show &&
              this.toggle(!0);
          }),
          document
            .querySelectorAll(".country-selector__close-button")
            .forEach((e) =>
              e.addEventListener("click", (e) => {
                this.show && (e.preventDefault(), this.toggle(!0));
              })
            ),
          window.addEventListener("scroll", () => {
            this.show && this.toggle(!0);
          });
      }
    }
    customElements.define("global-country-selector", GlobalCountySelector);
    class CountdownTimer extends HTMLElement {
      constructor() {
        super(),
          (this.runoutHide = "true" === this.getAttribute("runout-hide")),
          (this.epochEndTime = Math.floor(
            Date.parse(this.getAttribute("target-date")) / 1e3
          ));
      }
      connectedCallback() {
        DomReadyPromise()
          .then(() => {
            this.render(), this.startCountdown();
          })
          .catch((e) => console.error("Error initializing CountdownTimer:", e));
      }
      render() {
        (this.daysSpan = this.querySelector(".days")),
          (this.hoursSpan = this.querySelector(".hours")),
          (this.minutesSpan = this.querySelector(".minutes")),
          (this.secondsSpan = this.querySelector(".seconds")),
          (this.colonElements = this.querySelectorAll(".colon"));
      }
      getTimeRemaining(e) {
        const t = e - Math.floor(Date.now() / 1e3);
        return {
          total: t,
          days: Math.floor(t / 86400),
          hours: Math.floor((t % 86400) / 3600),
          minutes: Math.floor((t % 3600) / 60),
          seconds: t % 60,
        };
      }
      startCountdown() {
        const zeroFill = (e) => (e < 10 ? `0${e}` : e),
          updateCountdown = () => {
            const e = this.getTimeRemaining(this.epochEndTime);
            if (e.total <= 0)
              return (
                this.runoutHide
                  ? (this.style.display = "none")
                  : ((this.daysSpan.textContent = "00d"),
                    (this.hoursSpan.textContent = "00h"),
                    (this.minutesSpan.textContent = "00m"),
                    (this.secondsSpan.textContent = "00s")),
                void clearInterval(this.interval)
              );
            (this.daysSpan.textContent = `${zeroFill(e.days)}d`),
              (this.hoursSpan.textContent = `${zeroFill(e.hours)}h`),
              (this.minutesSpan.textContent = `${zeroFill(e.minutes)}m`),
              (this.secondsSpan.textContent = `${zeroFill(e.seconds)}s`);
          };
        updateCountdown(), (this.interval = setInterval(updateCountdown, 1e3));
      }
      disconnectedCallback() {
        this.interval && clearInterval(this.interval);
      }
    }
    customElements.define("countdown-timer", CountdownTimer);
    class SocialLogin extends HTMLElement {
      constructor() {
        super(),
          (this.iconMap = {}),
          (this.loginHandlers = {
            google: loginWithGoogle,
            facebook: loginWithFacebook,
            apple: loginWithApple,
          });
      }
      connectedCallback() {
        (this.providers = window.medik8?.socialLogin?.providers || []),
          (this.buttonContainer = this.querySelector(".sl-container__buttons")),
          this.#l(),
          this.providers.forEach((e) => {
            const t = this.#d(e);
            this.buttonContainer.insertAdjacentHTML("beforeend", t);
          }),
          this.querySelectorAll(".sl-container__button").forEach((e) => {
            const t = e.getAttribute("login-provider"),
              r = this.loginHandlers[t];
            e.addEventListener("click", async () => {
              let e;
              this.#u();
              try {
                ({ error: e } = await r());
              } catch (t) {
                e = t;
              }
              e && this.#h(t, e);
            });
          });
      }
      #l() {
        const e = this.querySelector("template");
        if (!e) return;
        const t = document.createElement("div");
        (t.innerHTML = e?.innerHTML.trim()),
          e.remove(),
          this.providers.forEach((e) => {
            const r = t.querySelector(`#social-icon-${e}`);
            r && (this.iconMap[e] = r.cloneNode(!0));
          }),
          (this.iconMap.alertCircle = t
            .querySelector("#alert-circle")
            .cloneNode(!0));
      }
      #d(e) {
        const t = this.iconMap[e];
        return `\n      <button class="sl-container__button flex block-12/12 row--d2" login-provider="${e}">\n        <div class="sl-container__content flex block-rel">\n          <span class="sl-container__icon flex">${
          t?.outerHTML || ""
        }</span>\n          <span class="sl-container__label flex align-center">${e.toUpperCase()}</span>\n        </div>\n      </button>\n    `;
      }
      #h(e, t) {
        const r = this.iconMap.alertCircle,
          n = `\n      <div class="sl-container__errors flex gap--d3 block-rounded-5">\n        <div class="flex align-top">\n          ${
            r?.outerHTML || ""
          }\n        </div>\n        <div class="flex flex-dir-col">\n          <span>We were unable to log you in with ${this.#p(
            e
          )}.</span>\n          <span>Reason: ${t}</span>\n        </div>\n      </div>\n    `;
        this.buttonContainer.insertAdjacentHTML("beforebegin", n);
      }
      #u() {
        this.querySelectorAll(".sl-container__errors").forEach((e) =>
          e.remove()
        );
      }
      #p(e) {
        return e.charAt(0).toUpperCase() + e.slice(1).toLowerCase();
      }
    }
    customElements.define("social-login", SocialLogin);
    class EmailSubscribeV2 extends HTMLElement {
      constructor() {
        super();
      }
      connectedCallback() {
        (this.klaviyoListId = this.getAttribute("klaviyo")),
          (this.successMessage = this.getAttribute("success-message")),
          (this.errorMessage = this.getAttribute("error-message")),
          (this.messageEl = this.querySelector(".email-sub__message")),
          (this.messageText = this.querySelector(".email-sub__message-text")),
          (this.messageClose = this.querySelector(".email-sub__message-close")),
          (this.form = this.querySelector("form")),
          this.messageClose.addEventListener(
            "click",
            this.toggleVisibility.bind(this)
          ),
          this.klaviyoListId ? this.initKlaviyo() : this.initBloomreach();
      }
      initKlaviyo() {
        this.addEventListener("submit", async function (e) {
          e.preventDefault();
          const t = await KlaviyoSubscribe_klaviyoSubscribe(this.form);
          this.showResultMessage(t),
            (this.querySelector("input[type=email]").value = ""),
            this.toggleVisibility();
        });
      }
      initBloomreach() {
        this.addEventListener("submit", async function (e) {
          e.preventDefault();
          const t = this.form.querySelector("input[type=email]").value;
          await exponea.identify({ email_id: t }, { email: t });
          const r = await new Promise((e) => {
            "object" != typeof exponea && e(!1);
            let r = !1;
            const n = setTimeout(() => {
              (r = !0), e(!1);
            }, 3e3);
            exponea.track(
              "consent",
              {
                action: "accept",
                category: "email",
                email: t,
                valid_until: "unlimited",
                source: "crm",
              },
              () => {
                r || (clearTimeout(n), e(!0));
              }
            );
          });
          this.showResultMessage(r),
            (this.form.querySelector("input[type=email]").value = ""),
            this.toggleVisibility();
        });
      }
      showResultMessage(e) {
        this.messageText.textContent = e
          ? this.successMessage
          : this.errorMessage;
      }
      toggleVisibility() {
        this.form.classList.toggle("hide"),
          this.messageEl.classList.toggle("hide");
      }
    }
    customElements.define("email-subscribe-v2", EmailSubscribeV2);
    class SmsSubscribe extends HTMLElement {
      constructor() {
        super();
      }
      connectedCallback() {
        (this.klaviyoListId = this.getAttribute("klaviyo")),
          (this.successMessage = this.getAttribute("success-message")),
          (this.errorMessage = this.getAttribute("error-message")),
          (this.messageEl = this.querySelector(".sms-sub__message")),
          (this.messageText = this.querySelector(".sms-sub__message-text")),
          (this.messageClose = this.querySelector(".sms-sub__message-close")),
          (this.form = this.querySelector("form")),
          this.messageClose.addEventListener(
            "click",
            this.toggleVisibility.bind(this)
          ),
          this.klaviyoListId ? this.initKlaviyo() : this.initBloomreach();
      }
      initKlaviyo() {
        this.addEventListener("submit", async function (e) {
          e.preventDefault();
          this.showResultMessage(!0),
            (this.querySelector("input[type=tel]").value = ""),
            this.toggleVisibility();
        });
      }
      initBloomreach() {
        this.addEventListener("submit", async function (e) {
          e.preventDefault();
          this.form.querySelector("input[type=tel]").value;
        });
      }
      showResultMessage(e) {
        this.messageText.textContent = e
          ? this.successMessage
          : this.errorMessage;
      }
      toggleVisibility() {
        this.form.classList.toggle("hide"),
          this.messageEl.classList.toggle("hide");
      }
    }
    customElements.define("sms-subscribe", SmsSubscribe),
      DomReadyPromise_DomReadyPromise()
        /*.then(() => {
          let e = !1;
          const t = window.medik8.misc.useOldLoginModal
            ? "account__login-form"
            : "account_consolidated";
          document
            .querySelectorAll('[href="#account"], [account-modal]')
            .forEach((r) =>
              r.addEventListener("click", async (r) => {
                r.preventDefault(),
                  window.customer_logged_in
                    ? (window.location.href = "/account")
                    : (e ||
                        (await new Promise((r, n) => {
                          fetch(`${window.Shopify.routes.root}?sections=${t}`)
                            .then((e) => e.json())
                            .then((s) => {
                              s?.[t]
                                ? ((e = new ModalBox({
                                    content: s[t],
                                    settings: {
                                      contentClass: "bg-white",
                                      containerCloseButton: !0,
                                    },
                                  })),
                                  e.subscribe(({ type: t }) => {
                                    if ("open:rendered" == t) {
                                      e.wrapper
                                        .querySelectorAll("form")
                                        .forEach((e) => {
                                          const t =
                                            e.querySelector(
                                              '[name="return_to"]'
                                            );
                                          t
                                            ? (t.value = `${window.location.pathname}${window.location.search}`)
                                            : e.insertAdjacentHTML(
                                                "afterbegin",
                                                `<input type="hidden" name="return_to" value="${window.location.pathname}${window.location.search}"/>`
                                              );
                                        });
                                      let t = !1;
                                      const r =
                                          e.wrapper.querySelector(
                                            "#CustomerLoginForm"
                                          ),
                                        n = e.wrapper.querySelector(
                                          "#RecoverPasswordForm"
                                        );
                                      e.wrapper
                                        .querySelectorAll(
                                          ".js-password-reset-toggle"
                                        )
                                        .forEach((e) =>
                                          e.addEventListener("click", (e) => {
                                            e.preventDefault(),
                                              (t = !t),
                                              (r.style.display = t
                                                ? "none"
                                                : "block"),
                                              (n.style.display = t
                                                ? "block"
                                                : "none");
                                          })
                                        );
                                      const s =
                                          e.wrapper.querySelectorAll(
                                            "[data-tab]"
                                          ),
                                        i =
                                          e.wrapper.querySelector(
                                            ".js-login-form"
                                          ),
                                        a =
                                          e.wrapper.querySelector(
                                            ".js-register-form"
                                          );
                                      s.forEach((e) =>
                                        e.addEventListener("click", (t) => {
                                          t.preventDefault();
                                          const { tab: r } = e.dataset;
                                          (i.style.display =
                                            "login" == r ? "block" : "none"),
                                            (a.style.display =
                                              "register" == r
                                                ? "block"
                                                : "none"),
                                            s.forEach((t) => {
                                              t.classList.toggle(
                                                "selected",
                                                t == e
                                              );
                                            });
                                        })
                                      );
                                      e.wrapper
                                        .querySelectorAll("script")
                                        .forEach((e) => {
                                          const t =
                                            document.createElement("script");
                                          e.src
                                            ? (t.src = e.src)
                                            : (t.textContent = e.textContent),
                                            document.head.appendChild(t),
                                            document.head.removeChild(t);
                                        });
                                    }
                                  }),
                                  r())
                                : n();
                            })
                            .catch((e) => {
                              n();
                            });
                        }).catch((e) => {
                          window.location.href = "/account";
                        })),
                      e.open());
              })
            );
        })
        .catch((e) => console.log(e));*/
  })();
  var n = self;
  for (var s in r) n[s] = r[s];
  r.__esModule && Object.defineProperty(n, "__esModule", { value: !0 });
})();
